/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The concept of a date without a time and/or timezone, e.g. My birthday is January 1st, 1864 regardless of timezone. */
  DateScalar: { input: any; output: any; }
  /** Returns a string in simplified extended ISO format (ISO 8601), which is always 24 or 27 characters long (YYYY-MM-DDTHH:mm:ss.sssZ or ±YYYYYY-MM-DDTHH:mm:ss.sssZ, respectively). The timezone is always zero UTC offset, as denoted by the suffix "Z". */
  ISOString: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type AccordionItem = {
  __typename?: 'AccordionItem';
  content: Scalars['String']['output'];
  council?: Maybe<Council>;
  council_aggregate?: Maybe<AggregationResult>;
  id: Scalars['ID']['output'];
  isExpanded?: Maybe<Scalars['Boolean']['output']>;
  itemOrder: Scalars['Float']['output'];
  location: AccordionLocation;
  title: Scalars['String']['output'];
  userType: AccordionUserType;
};


export type AccordionItemCouncilArgs = {
  filter?: InputMaybe<CouncilsListFilter>;
};


export type AccordionItemCouncil_AggregateArgs = {
  filter?: InputMaybe<CouncilsListFilter>;
};

/** Data needed to create or update AccordionItems. If an ID is passed, this is an update, otherwise it's an insert. */
export type AccordionItemCreateOrUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  council?: InputMaybe<CouncilCreateOrUpdateInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isExpanded?: InputMaybe<Scalars['Boolean']['input']>;
  itemOrder?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<AccordionLocation>;
  title?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<AccordionUserType>;
};

/** Data needed to create AccordionItems. */
export type AccordionItemInsertInput = {
  content: Scalars['String']['input'];
  council?: InputMaybe<CouncilCreateOrUpdateInput>;
  isExpanded?: InputMaybe<Scalars['Boolean']['input']>;
  itemOrder: Scalars['Float']['input'];
  location: AccordionLocation;
  title: Scalars['String']['input'];
  userType: AccordionUserType;
};

/** Data needed to update AccordionItems. An ID must be passed. */
export type AccordionItemUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  council?: InputMaybe<CouncilCreateOrUpdateInput>;
  id: Scalars['ID']['input'];
  isExpanded?: InputMaybe<Scalars['Boolean']['input']>;
  itemOrder?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<AccordionLocation>;
  title?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<AccordionUserType>;
};

export type AccordionItemsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<AccordionItemsListFilter>>>;
  _not?: InputMaybe<AccordionItemsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<AccordionItemsListFilter>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_gt?: InputMaybe<Scalars['String']['input']>;
  content_gte?: InputMaybe<Scalars['String']['input']>;
  content_ilike?: InputMaybe<Scalars['String']['input']>;
  content_in?: InputMaybe<Array<Scalars['String']['input']>>;
  content_like?: InputMaybe<Scalars['String']['input']>;
  content_lt?: InputMaybe<Scalars['String']['input']>;
  content_lte?: InputMaybe<Scalars['String']['input']>;
  content_ne?: InputMaybe<Scalars['String']['input']>;
  content_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  content_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  content_null?: InputMaybe<Scalars['Boolean']['input']>;
  council?: InputMaybe<CouncilsListFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  isExpanded?: InputMaybe<Scalars['Boolean']['input']>;
  isExpanded_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isExpanded_ne?: InputMaybe<Scalars['Boolean']['input']>;
  isExpanded_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isExpanded_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  isExpanded_null?: InputMaybe<Scalars['Boolean']['input']>;
  itemOrder?: InputMaybe<Scalars['Float']['input']>;
  itemOrder_gt?: InputMaybe<Scalars['Float']['input']>;
  itemOrder_gte?: InputMaybe<Scalars['Float']['input']>;
  itemOrder_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  itemOrder_lt?: InputMaybe<Scalars['Float']['input']>;
  itemOrder_lte?: InputMaybe<Scalars['Float']['input']>;
  itemOrder_ne?: InputMaybe<Scalars['Float']['input']>;
  itemOrder_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  itemOrder_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  itemOrder_null?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<AccordionLocation>;
  location_in?: InputMaybe<Array<AccordionLocation>>;
  location_nin?: InputMaybe<Array<AccordionLocation>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_ilike?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_like?: InputMaybe<Scalars['String']['input']>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_ne?: InputMaybe<Scalars['String']['input']>;
  title_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  title_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  title_null?: InputMaybe<Scalars['Boolean']['input']>;
  userType?: InputMaybe<AccordionUserType>;
  userType_in?: InputMaybe<Array<AccordionUserType>>;
  userType_nin?: InputMaybe<Array<AccordionUserType>>;
};

export type AccordionItemsOrderByInput = {
  content?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  isExpanded?: InputMaybe<Sort>;
  itemOrder?: InputMaybe<Sort>;
  location?: InputMaybe<Sort>;
  title?: InputMaybe<Sort>;
  userType?: InputMaybe<Sort>;
};

/** Pagination options for AccordionItems. */
export type AccordionItemsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccordionItemsOrderByInput>;
};

export enum AccordionLocation {
  AboutSubscriptions = 'ABOUT_SUBSCRIPTIONS',
  AppUpdates = 'APP_UPDATES',
  BagScanned = 'BAG_SCANNED',
  HelpAccount = 'HELP_ACCOUNT',
  HelpCurbyRewards = 'HELP_CURBY_REWARDS',
  HelpMaterialsWeRecycle = 'HELP_MATERIALS_WE_RECYCLE',
  HelpMission = 'HELP_MISSION',
  HelpOtherMaterials = 'HELP_OTHER_MATERIALS',
  HelpProgram = 'HELP_PROGRAM',
  HelpProgramMaterial = 'HELP_PROGRAM_MATERIAL',
  InformExisting = 'INFORM_EXISTING',
  RewardsHowItWorks = 'REWARDS_HOW_IT_WORKS',
  RewardsTsAndCs = 'REWARDS_TS_AND_CS',
  SubscriptionDetails = 'SUBSCRIPTION_DETAILS',
  WelcomePage = 'WELCOME_PAGE'
}

export enum AccordionUserType {
  Admin = 'ADMIN',
  All = 'ALL',
  AllAdmins = 'ALL_ADMINS',
  SuperAdmin = 'SUPER_ADMIN',
  User = 'USER'
}

export type Account = {
  __typename?: 'Account';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
};

/** Data needed to create or update Accounts. If an ID is passed, this is an update, otherwise it's an insert. */
export type AccountCreateOrUpdateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordType?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create Accounts. */
export type AccountInsertInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  recordType?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to update Accounts. An ID must be passed. */
export type AccountUpdateInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  recordType?: InputMaybe<Scalars['String']['input']>;
};

export type AccountsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<AccountsListFilter>>>;
  _not?: InputMaybe<AccountsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<AccountsListFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_ilike?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_like?: InputMaybe<Scalars['String']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  name_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  name_null?: InputMaybe<Scalars['Boolean']['input']>;
  recordType?: InputMaybe<Scalars['String']['input']>;
  recordType_gt?: InputMaybe<Scalars['String']['input']>;
  recordType_gte?: InputMaybe<Scalars['String']['input']>;
  recordType_ilike?: InputMaybe<Scalars['String']['input']>;
  recordType_in?: InputMaybe<Array<Scalars['String']['input']>>;
  recordType_like?: InputMaybe<Scalars['String']['input']>;
  recordType_lt?: InputMaybe<Scalars['String']['input']>;
  recordType_lte?: InputMaybe<Scalars['String']['input']>;
  recordType_ne?: InputMaybe<Scalars['String']['input']>;
  recordType_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  recordType_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  recordType_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountsOrderByInput = {
  id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  recordType?: InputMaybe<Sort>;
};

/** Pagination options for Accounts. */
export type AccountsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccountsOrderByInput>;
};

export type AdminUiEntityAttributeMetadata = {
  __typename?: 'AdminUiEntityAttributeMetadata';
  clientGeneratedPrimaryKeys?: Maybe<Scalars['Boolean']['output']>;
  exportPageSize?: Maybe<Scalars['Float']['output']>;
  isReadOnly?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminUiEntityMetadata = {
  __typename?: 'AdminUiEntityMetadata';
  attributes: AdminUiEntityAttributeMetadata;
  backendDisplayName?: Maybe<Scalars['String']['output']>;
  backendId?: Maybe<Scalars['String']['output']>;
  defaultFilter?: Maybe<Scalars['JSON']['output']>;
  defaultSort?: Maybe<Scalars['JSON']['output']>;
  excludeFromTracing: Scalars['Boolean']['output'];
  fieldForDetailPanelNavigationId: Scalars['String']['output'];
  fields: Array<AdminUiFieldMetadata>;
  hideInSideBar: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  plural: Scalars['String']['output'];
  primaryKeyField: Scalars['String']['output'];
  summaryField?: Maybe<Scalars['String']['output']>;
  supportedAggregationTypes: Array<AggregationType>;
  supportsPseudoCursorPagination: Scalars['Boolean']['output'];
};

export type AdminUiEnumMetadata = {
  __typename?: 'AdminUiEnumMetadata';
  name: Scalars['String']['output'];
  values: Array<AdminUiEnumValueMetadata>;
};

export type AdminUiEnumValueMetadata = {
  __typename?: 'AdminUiEnumValueMetadata';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AdminUiFieldAttributeMetadata = {
  __typename?: 'AdminUiFieldAttributeMetadata';
  isReadOnly: Scalars['Boolean']['output'];
  isRequiredForCreate: Scalars['Boolean']['output'];
  isRequiredForUpdate: Scalars['Boolean']['output'];
};

export type AdminUiFieldExtensionsMetadata = {
  __typename?: 'AdminUiFieldExtensionsMetadata';
  key?: Maybe<Scalars['String']['output']>;
};

export type AdminUiFieldFormatMetadata = {
  __typename?: 'AdminUiFieldFormatMetadata';
  format?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};

export type AdminUiFieldMetadata = {
  __typename?: 'AdminUiFieldMetadata';
  attributes?: Maybe<AdminUiFieldAttributeMetadata>;
  detailPanelInputComponent?: Maybe<DetailPanelInputComponent>;
  extensions?: Maybe<AdminUiFieldExtensionsMetadata>;
  filter?: Maybe<AdminUiFilterMetadata>;
  format?: Maybe<AdminUiFieldFormatMetadata>;
  hideInDetailForm?: Maybe<Scalars['Boolean']['output']>;
  hideInFilterBar?: Maybe<Scalars['Boolean']['output']>;
  hideInTable?: Maybe<Scalars['Boolean']['output']>;
  isArray?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  relatedEntity?: Maybe<Scalars['String']['output']>;
  relationshipBehaviour?: Maybe<Scalars['String']['output']>;
  relationshipType?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type AdminUiFilterMetadata = {
  __typename?: 'AdminUiFilterMetadata';
  options?: Maybe<Scalars['JSON']['output']>;
  type: AdminUiFilterType;
};

export enum AdminUiFilterType {
  Boolean = 'BOOLEAN',
  DateRange = 'DATE_RANGE',
  DateTimeRange = 'DATE_TIME_RANGE',
  DropDownText = 'DROP_DOWN_TEXT',
  Enum = 'ENUM',
  Numeric = 'NUMERIC',
  NumericRange = 'NUMERIC_RANGE',
  Relationship = 'RELATIONSHIP',
  Text = 'TEXT'
}

export type AdminUiMetadata = {
  __typename?: 'AdminUiMetadata';
  entities: Array<AdminUiEntityMetadata>;
  enums: Array<AdminUiEnumMetadata>;
};

export type AggregationResult = {
  __typename?: 'AggregationResult';
  count: Scalars['Int']['output'];
};

export enum AggregationType {
  Count = 'COUNT'
}

export type ApiKey = {
  __typename?: 'ApiKey';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  revoked?: Maybe<Scalars['Boolean']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
};

export type ApiKeyInsertInput = {
  key: Scalars['String']['input'];
  revoked?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  secret: Scalars['String']['input'];
};

export type ApiKeyUpdateInput = {
  id: Scalars['ID']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  revoked?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  secret?: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeysListFilter = {
  _and?: InputMaybe<Array<InputMaybe<ApiKeysListFilter>>>;
  _not?: InputMaybe<ApiKeysListFilter>;
  _or?: InputMaybe<Array<InputMaybe<ApiKeysListFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_gt?: InputMaybe<Scalars['String']['input']>;
  key_gte?: InputMaybe<Scalars['String']['input']>;
  key_ilike?: InputMaybe<Scalars['String']['input']>;
  key_in?: InputMaybe<Array<Scalars['String']['input']>>;
  key_like?: InputMaybe<Scalars['String']['input']>;
  key_lt?: InputMaybe<Scalars['String']['input']>;
  key_lte?: InputMaybe<Scalars['String']['input']>;
  key_ne?: InputMaybe<Scalars['String']['input']>;
  key_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  key_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  key_null?: InputMaybe<Scalars['Boolean']['input']>;
  revoked?: InputMaybe<Scalars['Boolean']['input']>;
  revoked_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  revoked_ne?: InputMaybe<Scalars['Boolean']['input']>;
  revoked_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  revoked_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  revoked_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AssetStatus {
  BagAudit = 'BAG_AUDIT',
  BagBaled = 'BAG_BALED',
  BagContaminated = 'BAG_CONTAMINATED',
  BagReceived = 'BAG_RECEIVED',
  BagScanned = 'BAG_SCANNED',
  BaleCreated = 'BALE_CREATED',
  BaleDispatched = 'BALE_DISPATCHED',
  BaleProcessed = 'BALE_PROCESSED',
  LoadDelivered = 'LOAD_DELIVERED',
  LoadInTransit = 'LOAD_IN_TRANSIT'
}

export enum AssetType {
  Bag = 'BAG',
  Load = 'LOAD',
  PayloadTag = 'PAYLOAD_TAG',
  Tag = 'TAG'
}

export enum AssetUseCase {
  BaleLoad = 'BALE_LOAD',
  CustomerBag = 'CUSTOMER_BAG',
  CustomerTag = 'CUSTOMER_TAG',
  FacilityTag = 'FACILITY_TAG',
  MaterialBale = 'MATERIAL_BALE',
  OffsetBale = 'OFFSET_BALE'
}

export type BatchCode = {
  __typename?: 'BatchCode';
  code: Scalars['String']['output'];
  createdAt: Scalars['ISOString']['output'];
  createdByUser: User;
  createdByUser_aggregate?: Maybe<AggregationResult>;
  id: Scalars['ID']['output'];
  trackableAssets: Array<TrackableAsset>;
  trackableAssets_aggregate?: Maybe<AggregationResult>;
};


export type BatchCodeCreatedByUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type BatchCodeCreatedByUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type BatchCodeTrackableAssetsArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type BatchCodeTrackableAssets_AggregateArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};

/** Data needed to create or update BatchCodes. If an ID is passed, this is an update, otherwise it's an insert. */
export type BatchCodeCreateOrUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  trackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
};

/** Data needed to create BatchCodes. */
export type BatchCodeInsertInput = {
  code: Scalars['String']['input'];
  createdAt: Scalars['ISOString']['input'];
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  trackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
};

/** Data needed to update BatchCodes. An ID must be passed. */
export type BatchCodeUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  id: Scalars['ID']['input'];
  trackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
};

export type BatchCodesListFilter = {
  _and?: InputMaybe<Array<InputMaybe<BatchCodesListFilter>>>;
  _not?: InputMaybe<BatchCodesListFilter>;
  _or?: InputMaybe<Array<InputMaybe<BatchCodesListFilter>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_gt?: InputMaybe<Scalars['String']['input']>;
  code_gte?: InputMaybe<Scalars['String']['input']>;
  code_ilike?: InputMaybe<Scalars['String']['input']>;
  code_in?: InputMaybe<Array<Scalars['String']['input']>>;
  code_like?: InputMaybe<Scalars['String']['input']>;
  code_lt?: InputMaybe<Scalars['String']['input']>;
  code_lte?: InputMaybe<Scalars['String']['input']>;
  code_ne?: InputMaybe<Scalars['String']['input']>;
  code_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  code_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  code_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUser?: InputMaybe<UsersListFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  trackableAssets?: InputMaybe<TrackableAssetsListFilter>;
};

export type BatchCodesOrderByInput = {
  code?: InputMaybe<Sort>;
  createdAt?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
};

/** Pagination options for BatchCodes. */
export type BatchCodesPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BatchCodesOrderByInput>;
};

export type Blacklist = {
  __typename?: 'Blacklist';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** Data needed to create or update Blacklists. If an ID is passed, this is an update, otherwise it's an insert. */
export type BlacklistCreateOrUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Data needed to create Blacklists. */
export type BlacklistInsertInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to update Blacklists. An ID must be passed. */
export type BlacklistUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type BlacklistsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<BlacklistsListFilter>>>;
  _not?: InputMaybe<BlacklistsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<BlacklistsListFilter>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_gt?: InputMaybe<Scalars['String']['input']>;
  email_gte?: InputMaybe<Scalars['String']['input']>;
  email_ilike?: InputMaybe<Scalars['String']['input']>;
  email_in?: InputMaybe<Array<Scalars['String']['input']>>;
  email_like?: InputMaybe<Scalars['String']['input']>;
  email_lt?: InputMaybe<Scalars['String']['input']>;
  email_lte?: InputMaybe<Scalars['String']['input']>;
  email_ne?: InputMaybe<Scalars['String']['input']>;
  email_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  email_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  email_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlacklistsOrderByInput = {
  email?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
};

/** Pagination options for Blacklists. */
export type BlacklistsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BlacklistsOrderByInput>;
};

export type Case = {
  __typename?: 'Case';
  account?: Maybe<Account>;
  account_aggregate?: Maybe<AggregationResult>;
  caseNumber?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  contact_aggregate?: Maybe<AggregationResult>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  priority?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};


export type CaseAccountArgs = {
  filter?: InputMaybe<AccountsListFilter>;
};


export type CaseAccount_AggregateArgs = {
  filter?: InputMaybe<AccountsListFilter>;
};


export type CaseContactArgs = {
  filter?: InputMaybe<ContactsListFilter>;
};


export type CaseContact_AggregateArgs = {
  filter?: InputMaybe<ContactsListFilter>;
};

/** Data needed to create or update Cases. If an ID is passed, this is an update, otherwise it's an insert. */
export type CaseCreateOrUpdateInput = {
  account?: InputMaybe<AccountCreateOrUpdateInput>;
  caseNumber?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactCreateOrUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create Cases. */
export type CaseInsertInput = {
  account?: InputMaybe<AccountCreateOrUpdateInput>;
  caseNumber?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactCreateOrUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to update Cases. An ID must be passed. */
export type CaseUpdateInput = {
  account?: InputMaybe<AccountCreateOrUpdateInput>;
  caseNumber?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactCreateOrUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type CasesListFilter = {
  _and?: InputMaybe<Array<InputMaybe<CasesListFilter>>>;
  _not?: InputMaybe<CasesListFilter>;
  _or?: InputMaybe<Array<InputMaybe<CasesListFilter>>>;
  account?: InputMaybe<AccountsListFilter>;
  caseNumber?: InputMaybe<Scalars['String']['input']>;
  caseNumber_gt?: InputMaybe<Scalars['String']['input']>;
  caseNumber_gte?: InputMaybe<Scalars['String']['input']>;
  caseNumber_ilike?: InputMaybe<Scalars['String']['input']>;
  caseNumber_in?: InputMaybe<Array<Scalars['String']['input']>>;
  caseNumber_like?: InputMaybe<Scalars['String']['input']>;
  caseNumber_lt?: InputMaybe<Scalars['String']['input']>;
  caseNumber_lte?: InputMaybe<Scalars['String']['input']>;
  caseNumber_ne?: InputMaybe<Scalars['String']['input']>;
  caseNumber_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  caseNumber_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  caseNumber_null?: InputMaybe<Scalars['Boolean']['input']>;
  contact?: InputMaybe<ContactsListFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_ilike?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_like?: InputMaybe<Scalars['String']['input']>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  description_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  description_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  priority_gt?: InputMaybe<Scalars['String']['input']>;
  priority_gte?: InputMaybe<Scalars['String']['input']>;
  priority_ilike?: InputMaybe<Scalars['String']['input']>;
  priority_in?: InputMaybe<Array<Scalars['String']['input']>>;
  priority_like?: InputMaybe<Scalars['String']['input']>;
  priority_lt?: InputMaybe<Scalars['String']['input']>;
  priority_lte?: InputMaybe<Scalars['String']['input']>;
  priority_ne?: InputMaybe<Scalars['String']['input']>;
  priority_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  priority_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  priority_null?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_gt?: InputMaybe<Scalars['String']['input']>;
  reason_gte?: InputMaybe<Scalars['String']['input']>;
  reason_ilike?: InputMaybe<Scalars['String']['input']>;
  reason_in?: InputMaybe<Array<Scalars['String']['input']>>;
  reason_like?: InputMaybe<Scalars['String']['input']>;
  reason_lt?: InputMaybe<Scalars['String']['input']>;
  reason_lte?: InputMaybe<Scalars['String']['input']>;
  reason_ne?: InputMaybe<Scalars['String']['input']>;
  reason_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  reason_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  reason_null?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_gt?: InputMaybe<Scalars['String']['input']>;
  status_gte?: InputMaybe<Scalars['String']['input']>;
  status_ilike?: InputMaybe<Scalars['String']['input']>;
  status_in?: InputMaybe<Array<Scalars['String']['input']>>;
  status_like?: InputMaybe<Scalars['String']['input']>;
  status_lt?: InputMaybe<Scalars['String']['input']>;
  status_lte?: InputMaybe<Scalars['String']['input']>;
  status_ne?: InputMaybe<Scalars['String']['input']>;
  status_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  status_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  status_null?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subject_gt?: InputMaybe<Scalars['String']['input']>;
  subject_gte?: InputMaybe<Scalars['String']['input']>;
  subject_ilike?: InputMaybe<Scalars['String']['input']>;
  subject_in?: InputMaybe<Array<Scalars['String']['input']>>;
  subject_like?: InputMaybe<Scalars['String']['input']>;
  subject_lt?: InputMaybe<Scalars['String']['input']>;
  subject_lte?: InputMaybe<Scalars['String']['input']>;
  subject_ne?: InputMaybe<Scalars['String']['input']>;
  subject_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  subject_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  subject_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CasesOrderByInput = {
  caseNumber?: InputMaybe<Sort>;
  description?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  priority?: InputMaybe<Sort>;
  reason?: InputMaybe<Sort>;
  status?: InputMaybe<Sort>;
  subject?: InputMaybe<Sort>;
};

/** Pagination options for Cases. */
export type CasesPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CasesOrderByInput>;
};

export type Contact = {
  __typename?: 'Contact';
  account?: Maybe<Account>;
  account_aggregate?: Maybe<AggregationResult>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};


export type ContactAccountArgs = {
  filter?: InputMaybe<AccountsListFilter>;
};


export type ContactAccount_AggregateArgs = {
  filter?: InputMaybe<AccountsListFilter>;
};

/** Data needed to create or update Contacts. If an ID is passed, this is an update, otherwise it's an insert. */
export type ContactCreateOrUpdateInput = {
  account?: InputMaybe<AccountCreateOrUpdateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create Contacts. */
export type ContactInsertInput = {
  account?: InputMaybe<AccountCreateOrUpdateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to update Contacts. An ID must be passed. */
export type ContactUpdateInput = {
  account?: InputMaybe<AccountCreateOrUpdateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type ContactsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<ContactsListFilter>>>;
  _not?: InputMaybe<ContactsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<ContactsListFilter>>>;
  account?: InputMaybe<AccountsListFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_gt?: InputMaybe<Scalars['String']['input']>;
  email_gte?: InputMaybe<Scalars['String']['input']>;
  email_ilike?: InputMaybe<Scalars['String']['input']>;
  email_in?: InputMaybe<Array<Scalars['String']['input']>>;
  email_like?: InputMaybe<Scalars['String']['input']>;
  email_lt?: InputMaybe<Scalars['String']['input']>;
  email_lte?: InputMaybe<Scalars['String']['input']>;
  email_ne?: InputMaybe<Scalars['String']['input']>;
  email_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  email_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  email_null?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_gt?: InputMaybe<Scalars['String']['input']>;
  firstName_gte?: InputMaybe<Scalars['String']['input']>;
  firstName_ilike?: InputMaybe<Scalars['String']['input']>;
  firstName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName_like?: InputMaybe<Scalars['String']['input']>;
  firstName_lt?: InputMaybe<Scalars['String']['input']>;
  firstName_lte?: InputMaybe<Scalars['String']['input']>;
  firstName_ne?: InputMaybe<Scalars['String']['input']>;
  firstName_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  firstName_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_gt?: InputMaybe<Scalars['String']['input']>;
  lastName_gte?: InputMaybe<Scalars['String']['input']>;
  lastName_ilike?: InputMaybe<Scalars['String']['input']>;
  lastName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName_like?: InputMaybe<Scalars['String']['input']>;
  lastName_lt?: InputMaybe<Scalars['String']['input']>;
  lastName_lte?: InputMaybe<Scalars['String']['input']>;
  lastName_ne?: InputMaybe<Scalars['String']['input']>;
  lastName_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  lastName_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactsOrderByInput = {
  email?: InputMaybe<Sort>;
  firstName?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  lastName?: InputMaybe<Sort>;
};

/** Pagination options for Contacts. */
export type ContactsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContactsOrderByInput>;
};

export type ContentSection = {
  __typename?: 'ContentSection';
  alignment: ContentSectionAlignment;
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location: ContentSectionLocation;
  placement: ContentSectionPlacement;
  style: ContentSectionStyle;
  subheading?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userType: ContentSectionUserType;
};

export enum ContentSectionAlignment {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

/** Data needed to create or update ContentSections. If an ID is passed, this is an update, otherwise it's an insert. */
export type ContentSectionCreateOrUpdateInput = {
  alignment?: InputMaybe<ContentSectionAlignment>;
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<ContentSectionLocation>;
  placement?: InputMaybe<ContentSectionPlacement>;
  style?: InputMaybe<ContentSectionStyle>;
  subheading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<ContentSectionUserType>;
};

/** Data needed to create ContentSections. */
export type ContentSectionInsertInput = {
  alignment?: InputMaybe<ContentSectionAlignment>;
  content: Scalars['String']['input'];
  location: ContentSectionLocation;
  placement?: InputMaybe<ContentSectionPlacement>;
  style?: InputMaybe<ContentSectionStyle>;
  subheading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<ContentSectionUserType>;
};

export enum ContentSectionLocation {
  AboutSubscriptions = 'ABOUT_SUBSCRIPTIONS',
  Account = 'ACCOUNT',
  Alerts = 'ALERTS',
  AppUpdates = 'APP_UPDATES',
  BagScanned = 'BAG_SCANNED',
  Billing = 'BILLING',
  CancelAutoRenew = 'CANCEL_AUTO_RENEW',
  ChangePassword = 'CHANGE_PASSWORD',
  CheckoutProduct = 'CHECKOUT_PRODUCT',
  CheckoutProductResult = 'CHECKOUT_PRODUCT_RESULT',
  CheckoutSubscription = 'CHECKOUT_SUBSCRIPTION',
  CheckoutSubscriptionResult = 'CHECKOUT_SUBSCRIPTION_RESULT',
  ChooseSubscription = 'CHOOSE_SUBSCRIPTION',
  DeleteAccount = 'DELETE_ACCOUNT',
  EnterCode = 'ENTER_CODE',
  Help = 'HELP',
  Home = 'HOME',
  InformExisting = 'INFORM_EXISTING',
  Login = 'LOGIN',
  PasswordLinkSent = 'PASSWORD_LINK_SENT',
  PastWinners = 'PAST_WINNERS',
  Privacy = 'PRIVACY',
  ReportIssue = 'REPORT_ISSUE',
  RequestPasswordReset = 'REQUEST_PASSWORD_RESET',
  ResetPassword = 'RESET_PASSWORD',
  Rewards = 'REWARDS',
  ScanBag = 'SCAN_BAG',
  Shop = 'SHOP',
  SignUp = 'SIGN_UP',
  SignUpDetails = 'SIGN_UP_DETAILS',
  Subscription = 'SUBSCRIPTION',
  SubscriptionDetail = 'SUBSCRIPTION_DETAIL',
  Terms = 'TERMS',
  Welcome = 'WELCOME'
}

export enum ContentSectionPlacement {
  Bottom = 'BOTTOM',
  Middle = 'MIDDLE',
  Top = 'TOP'
}

export enum ContentSectionStyle {
  Card = 'CARD',
  Text = 'TEXT',
  Warning = 'WARNING'
}

/** Data needed to update ContentSections. An ID must be passed. */
export type ContentSectionUpdateInput = {
  alignment?: InputMaybe<ContentSectionAlignment>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  location?: InputMaybe<ContentSectionLocation>;
  placement?: InputMaybe<ContentSectionPlacement>;
  style?: InputMaybe<ContentSectionStyle>;
  subheading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<ContentSectionUserType>;
};

export enum ContentSectionUserType {
  Admin = 'ADMIN',
  All = 'ALL',
  AllAdmins = 'ALL_ADMINS',
  SuperAdmin = 'SUPER_ADMIN',
  User = 'USER'
}

export type ContentSectionsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<ContentSectionsListFilter>>>;
  _not?: InputMaybe<ContentSectionsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<ContentSectionsListFilter>>>;
  alignment?: InputMaybe<ContentSectionAlignment>;
  alignment_in?: InputMaybe<Array<ContentSectionAlignment>>;
  alignment_nin?: InputMaybe<Array<ContentSectionAlignment>>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_gt?: InputMaybe<Scalars['String']['input']>;
  content_gte?: InputMaybe<Scalars['String']['input']>;
  content_ilike?: InputMaybe<Scalars['String']['input']>;
  content_in?: InputMaybe<Array<Scalars['String']['input']>>;
  content_like?: InputMaybe<Scalars['String']['input']>;
  content_lt?: InputMaybe<Scalars['String']['input']>;
  content_lte?: InputMaybe<Scalars['String']['input']>;
  content_ne?: InputMaybe<Scalars['String']['input']>;
  content_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  content_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  content_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<ContentSectionLocation>;
  location_in?: InputMaybe<Array<ContentSectionLocation>>;
  location_nin?: InputMaybe<Array<ContentSectionLocation>>;
  placement?: InputMaybe<ContentSectionPlacement>;
  placement_in?: InputMaybe<Array<ContentSectionPlacement>>;
  placement_nin?: InputMaybe<Array<ContentSectionPlacement>>;
  style?: InputMaybe<ContentSectionStyle>;
  style_in?: InputMaybe<Array<ContentSectionStyle>>;
  style_nin?: InputMaybe<Array<ContentSectionStyle>>;
  subheading?: InputMaybe<Scalars['String']['input']>;
  subheading_gt?: InputMaybe<Scalars['String']['input']>;
  subheading_gte?: InputMaybe<Scalars['String']['input']>;
  subheading_ilike?: InputMaybe<Scalars['String']['input']>;
  subheading_in?: InputMaybe<Array<Scalars['String']['input']>>;
  subheading_like?: InputMaybe<Scalars['String']['input']>;
  subheading_lt?: InputMaybe<Scalars['String']['input']>;
  subheading_lte?: InputMaybe<Scalars['String']['input']>;
  subheading_ne?: InputMaybe<Scalars['String']['input']>;
  subheading_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  subheading_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  subheading_null?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_ilike?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_like?: InputMaybe<Scalars['String']['input']>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_ne?: InputMaybe<Scalars['String']['input']>;
  title_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  title_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  title_null?: InputMaybe<Scalars['Boolean']['input']>;
  userType?: InputMaybe<ContentSectionUserType>;
  userType_in?: InputMaybe<Array<ContentSectionUserType>>;
  userType_nin?: InputMaybe<Array<ContentSectionUserType>>;
};

export type ContentSectionsOrderByInput = {
  alignment?: InputMaybe<Sort>;
  content?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  location?: InputMaybe<Sort>;
  placement?: InputMaybe<Sort>;
  style?: InputMaybe<Sort>;
  subheading?: InputMaybe<Sort>;
  title?: InputMaybe<Sort>;
  userType?: InputMaybe<Sort>;
};

/** Pagination options for ContentSections. */
export type ContentSectionsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContentSectionsOrderByInput>;
};

export type Council = {
  __typename?: 'Council';
  accordionItems?: Maybe<Array<AccordionItem>>;
  accordionItems_aggregate?: Maybe<AggregationResult>;
  createdAt?: Maybe<Scalars['ISOString']['output']>;
  dropOffLocations?: Maybe<Array<DropOffLocation>>;
  dropOffLocations_aggregate?: Maybe<AggregationResult>;
  freeTag: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  offersPickup: Scalars['Boolean']['output'];
  placeId?: Maybe<Scalars['String']['output']>;
  postcodes?: Maybe<Array<Postcode>>;
  postcodes_aggregate?: Maybe<AggregationResult>;
  staff?: Maybe<Array<User>>;
  staff_aggregate?: Maybe<AggregationResult>;
  suburbs: Array<Suburb>;
  suburbs_aggregate?: Maybe<AggregationResult>;
  users?: Maybe<Array<User>>;
  users_aggregate?: Maybe<AggregationResult>;
};


export type CouncilAccordionItemsArgs = {
  filter?: InputMaybe<AccordionItemsListFilter>;
};


export type CouncilAccordionItems_AggregateArgs = {
  filter?: InputMaybe<AccordionItemsListFilter>;
};


export type CouncilDropOffLocationsArgs = {
  filter?: InputMaybe<DropOffLocationsListFilter>;
};


export type CouncilDropOffLocations_AggregateArgs = {
  filter?: InputMaybe<DropOffLocationsListFilter>;
};


export type CouncilPostcodesArgs = {
  filter?: InputMaybe<PostcodesListFilter>;
};


export type CouncilPostcodes_AggregateArgs = {
  filter?: InputMaybe<PostcodesListFilter>;
};


export type CouncilStaffArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type CouncilStaff_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type CouncilSuburbsArgs = {
  filter?: InputMaybe<SuburbsListFilter>;
};


export type CouncilSuburbs_AggregateArgs = {
  filter?: InputMaybe<SuburbsListFilter>;
};


export type CouncilUsersArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type CouncilUsers_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};

/** Data needed to create or update Councils. If an ID is passed, this is an update, otherwise it's an insert. */
export type CouncilCreateOrUpdateInput = {
  accordionItems?: InputMaybe<Array<AccordionItemCreateOrUpdateInput>>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  dropOffLocations?: InputMaybe<Array<DropOffLocationCreateOrUpdateInput>>;
  freeTag?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offersPickup?: InputMaybe<Scalars['Boolean']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  postcodes?: InputMaybe<Array<PostcodeCreateOrUpdateInput>>;
  staff?: InputMaybe<Array<UserCreateOrUpdateInput>>;
  suburbs?: InputMaybe<Array<SuburbCreateOrUpdateInput>>;
  users?: InputMaybe<Array<UserCreateOrUpdateInput>>;
};

/** Data needed to create Councils. */
export type CouncilInsertInput = {
  accordionItems?: InputMaybe<Array<AccordionItemCreateOrUpdateInput>>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  dropOffLocations?: InputMaybe<Array<DropOffLocationCreateOrUpdateInput>>;
  freeTag: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  offersPickup: Scalars['Boolean']['input'];
  placeId?: InputMaybe<Scalars['String']['input']>;
  postcodes?: InputMaybe<Array<PostcodeCreateOrUpdateInput>>;
  staff?: InputMaybe<Array<UserCreateOrUpdateInput>>;
  suburbs?: InputMaybe<Array<SuburbCreateOrUpdateInput>>;
  users?: InputMaybe<Array<UserCreateOrUpdateInput>>;
};

export type CouncilStats = {
  __typename?: 'CouncilStats';
  councilId: Scalars['Float']['output'];
  details: CouncilStatsDetails;
  suburbs: Array<CouncilStatsSuburb>;
};

export type CouncilStatsDetails = {
  __typename?: 'CouncilStatsDetails';
  accountsCreated: Scalars['Float']['output'];
  accountsTotal: Scalars['Float']['output'];
  kgDiverted: Scalars['Float']['output'];
  scanEvents: Scalars['Float']['output'];
  subscriptions: Array<SubscriptionCount>;
  trackableAssets: Scalars['Float']['output'];
};

export type CouncilStatsSuburb = {
  __typename?: 'CouncilStatsSuburb';
  details: CouncilStatsDetails;
  suburbId: Scalars['Float']['output'];
  suburbName: Scalars['String']['output'];
};

/** Data needed to update Councils. An ID must be passed. */
export type CouncilUpdateInput = {
  accordionItems?: InputMaybe<Array<AccordionItemCreateOrUpdateInput>>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  dropOffLocations?: InputMaybe<Array<DropOffLocationCreateOrUpdateInput>>;
  freeTag?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  offersPickup?: InputMaybe<Scalars['Boolean']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  postcodes?: InputMaybe<Array<PostcodeCreateOrUpdateInput>>;
  staff?: InputMaybe<Array<UserCreateOrUpdateInput>>;
  suburbs?: InputMaybe<Array<SuburbCreateOrUpdateInput>>;
  users?: InputMaybe<Array<UserCreateOrUpdateInput>>;
};

export type CouncilsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<CouncilsListFilter>>>;
  _not?: InputMaybe<CouncilsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<CouncilsListFilter>>>;
  accordionItems?: InputMaybe<AccordionItemsListFilter>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  dropOffLocations?: InputMaybe<DropOffLocationsListFilter>;
  freeTag?: InputMaybe<Scalars['Boolean']['input']>;
  freeTag_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  freeTag_ne?: InputMaybe<Scalars['Boolean']['input']>;
  freeTag_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  freeTag_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  freeTag_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_ilike?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_like?: InputMaybe<Scalars['String']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  name_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  name_null?: InputMaybe<Scalars['Boolean']['input']>;
  offersPickup?: InputMaybe<Scalars['Boolean']['input']>;
  offersPickup_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  offersPickup_ne?: InputMaybe<Scalars['Boolean']['input']>;
  offersPickup_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  offersPickup_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  offersPickup_null?: InputMaybe<Scalars['Boolean']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  placeId_gt?: InputMaybe<Scalars['String']['input']>;
  placeId_gte?: InputMaybe<Scalars['String']['input']>;
  placeId_ilike?: InputMaybe<Scalars['String']['input']>;
  placeId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  placeId_like?: InputMaybe<Scalars['String']['input']>;
  placeId_lt?: InputMaybe<Scalars['String']['input']>;
  placeId_lte?: InputMaybe<Scalars['String']['input']>;
  placeId_ne?: InputMaybe<Scalars['String']['input']>;
  placeId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  placeId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  placeId_null?: InputMaybe<Scalars['Boolean']['input']>;
  postcodes?: InputMaybe<PostcodesListFilter>;
  staff?: InputMaybe<UsersListFilter>;
  suburbs?: InputMaybe<SuburbsListFilter>;
  users?: InputMaybe<UsersListFilter>;
};

export type CouncilsOrderByInput = {
  createdAt?: InputMaybe<Sort>;
  freeTag?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  offersPickup?: InputMaybe<Sort>;
  placeId?: InputMaybe<Sort>;
};

/** Pagination options for Councils. */
export type CouncilsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CouncilsOrderByInput>;
};

export type CreateSalesforceCaseInput = {
  description: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type Credential = {
  __typename?: 'Credential';
  id: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type CredentialInsertInput = {
  confirm: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CredentialUpdateInput = {
  confirm?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<CredentialsListFilter>>>;
  _not?: InputMaybe<CredentialsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<CredentialsListFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  username_gt?: InputMaybe<Scalars['String']['input']>;
  username_gte?: InputMaybe<Scalars['String']['input']>;
  username_ilike?: InputMaybe<Scalars['String']['input']>;
  username_in?: InputMaybe<Array<Scalars['String']['input']>>;
  username_like?: InputMaybe<Scalars['String']['input']>;
  username_lt?: InputMaybe<Scalars['String']['input']>;
  username_lte?: InputMaybe<Scalars['String']['input']>;
  username_ne?: InputMaybe<Scalars['String']['input']>;
  username_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  username_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  username_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CredentialsOrderByInput = {
  id?: InputMaybe<Sort>;
  username?: InputMaybe<Sort>;
};

/** Pagination options for Credentials. */
export type CredentialsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CredentialsOrderByInput>;
};

export type CustomCreateUserInput = {
  confirm: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type DeleteCurrentUserInput = {
  comments: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type DeleteOneFilterInput = {
  id: Scalars['ID']['input'];
};

export type DetailPanelInputComponent = {
  __typename?: 'DetailPanelInputComponent';
  name: DetailPanelInputComponentOption;
  options?: Maybe<Scalars['JSON']['output']>;
};

export enum DetailPanelInputComponentOption {
  Markdown = 'MARKDOWN',
  RichText = 'RICH_TEXT',
  Text = 'TEXT'
}

export type DropOffLocation = {
  __typename?: 'DropOffLocation';
  address: Scalars['String']['output'];
  council?: Maybe<Array<Council>>;
  council_aggregate?: Maybe<AggregationResult>;
  drivingDistance?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  lat: Scalars['Float']['output'];
  lgaId?: Maybe<Scalars['Float']['output']>;
  lng: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  placeId?: Maybe<Scalars['String']['output']>;
  retailer?: Maybe<Scalars['String']['output']>;
  suburb: Scalars['String']['output'];
};


export type DropOffLocationCouncilArgs = {
  filter?: InputMaybe<CouncilsListFilter>;
};


export type DropOffLocationCouncil_AggregateArgs = {
  filter?: InputMaybe<CouncilsListFilter>;
};

/** Data needed to create or update DropOffLocations. If an ID is passed, this is an update, otherwise it's an insert. */
export type DropOffLocationCreateOrUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  council?: InputMaybe<Array<CouncilCreateOrUpdateInput>>;
  drivingDistance?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lgaId?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  retailer?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create DropOffLocations. */
export type DropOffLocationInsertInput = {
  address: Scalars['String']['input'];
  council?: InputMaybe<Array<CouncilCreateOrUpdateInput>>;
  drivingDistance?: InputMaybe<Scalars['Float']['input']>;
  lat: Scalars['Float']['input'];
  lgaId?: InputMaybe<Scalars['Float']['input']>;
  lng: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  placeId?: InputMaybe<Scalars['String']['input']>;
  retailer?: InputMaybe<Scalars['String']['input']>;
  suburb: Scalars['String']['input'];
};

/** Data needed to update DropOffLocations. An ID must be passed. */
export type DropOffLocationUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  council?: InputMaybe<Array<CouncilCreateOrUpdateInput>>;
  drivingDistance?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lgaId?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  retailer?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
};

export type DropOffLocationsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<DropOffLocationsListFilter>>>;
  _not?: InputMaybe<DropOffLocationsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<DropOffLocationsListFilter>>>;
  address?: InputMaybe<Scalars['String']['input']>;
  address_gt?: InputMaybe<Scalars['String']['input']>;
  address_gte?: InputMaybe<Scalars['String']['input']>;
  address_ilike?: InputMaybe<Scalars['String']['input']>;
  address_in?: InputMaybe<Array<Scalars['String']['input']>>;
  address_like?: InputMaybe<Scalars['String']['input']>;
  address_lt?: InputMaybe<Scalars['String']['input']>;
  address_lte?: InputMaybe<Scalars['String']['input']>;
  address_ne?: InputMaybe<Scalars['String']['input']>;
  address_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  address_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  address_null?: InputMaybe<Scalars['Boolean']['input']>;
  council?: InputMaybe<CouncilsListFilter>;
  drivingDistance?: InputMaybe<Scalars['Float']['input']>;
  drivingDistance_gt?: InputMaybe<Scalars['Float']['input']>;
  drivingDistance_gte?: InputMaybe<Scalars['Float']['input']>;
  drivingDistance_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  drivingDistance_lt?: InputMaybe<Scalars['Float']['input']>;
  drivingDistance_lte?: InputMaybe<Scalars['Float']['input']>;
  drivingDistance_ne?: InputMaybe<Scalars['Float']['input']>;
  drivingDistance_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  drivingDistance_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  drivingDistance_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lat_gt?: InputMaybe<Scalars['Float']['input']>;
  lat_gte?: InputMaybe<Scalars['Float']['input']>;
  lat_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lat_lt?: InputMaybe<Scalars['Float']['input']>;
  lat_lte?: InputMaybe<Scalars['Float']['input']>;
  lat_ne?: InputMaybe<Scalars['Float']['input']>;
  lat_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  lat_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  lat_null?: InputMaybe<Scalars['Boolean']['input']>;
  lgaId?: InputMaybe<Scalars['Float']['input']>;
  lgaId_gt?: InputMaybe<Scalars['Float']['input']>;
  lgaId_gte?: InputMaybe<Scalars['Float']['input']>;
  lgaId_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lgaId_lt?: InputMaybe<Scalars['Float']['input']>;
  lgaId_lte?: InputMaybe<Scalars['Float']['input']>;
  lgaId_ne?: InputMaybe<Scalars['Float']['input']>;
  lgaId_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  lgaId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  lgaId_null?: InputMaybe<Scalars['Boolean']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  lng_gt?: InputMaybe<Scalars['Float']['input']>;
  lng_gte?: InputMaybe<Scalars['Float']['input']>;
  lng_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lng_lt?: InputMaybe<Scalars['Float']['input']>;
  lng_lte?: InputMaybe<Scalars['Float']['input']>;
  lng_ne?: InputMaybe<Scalars['Float']['input']>;
  lng_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  lng_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  lng_null?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_ilike?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_like?: InputMaybe<Scalars['String']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  name_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  name_null?: InputMaybe<Scalars['Boolean']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  placeId_gt?: InputMaybe<Scalars['String']['input']>;
  placeId_gte?: InputMaybe<Scalars['String']['input']>;
  placeId_ilike?: InputMaybe<Scalars['String']['input']>;
  placeId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  placeId_like?: InputMaybe<Scalars['String']['input']>;
  placeId_lt?: InputMaybe<Scalars['String']['input']>;
  placeId_lte?: InputMaybe<Scalars['String']['input']>;
  placeId_ne?: InputMaybe<Scalars['String']['input']>;
  placeId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  placeId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  placeId_null?: InputMaybe<Scalars['Boolean']['input']>;
  retailer?: InputMaybe<Scalars['String']['input']>;
  retailer_gt?: InputMaybe<Scalars['String']['input']>;
  retailer_gte?: InputMaybe<Scalars['String']['input']>;
  retailer_ilike?: InputMaybe<Scalars['String']['input']>;
  retailer_in?: InputMaybe<Array<Scalars['String']['input']>>;
  retailer_like?: InputMaybe<Scalars['String']['input']>;
  retailer_lt?: InputMaybe<Scalars['String']['input']>;
  retailer_lte?: InputMaybe<Scalars['String']['input']>;
  retailer_ne?: InputMaybe<Scalars['String']['input']>;
  retailer_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  retailer_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  retailer_null?: InputMaybe<Scalars['Boolean']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
  suburb_gt?: InputMaybe<Scalars['String']['input']>;
  suburb_gte?: InputMaybe<Scalars['String']['input']>;
  suburb_ilike?: InputMaybe<Scalars['String']['input']>;
  suburb_in?: InputMaybe<Array<Scalars['String']['input']>>;
  suburb_like?: InputMaybe<Scalars['String']['input']>;
  suburb_lt?: InputMaybe<Scalars['String']['input']>;
  suburb_lte?: InputMaybe<Scalars['String']['input']>;
  suburb_ne?: InputMaybe<Scalars['String']['input']>;
  suburb_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  suburb_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  suburb_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DropOffLocationsOrderByInput = {
  address?: InputMaybe<Sort>;
  drivingDistance?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  lat?: InputMaybe<Sort>;
  lgaId?: InputMaybe<Sort>;
  lng?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  placeId?: InputMaybe<Sort>;
  retailer?: InputMaybe<Sort>;
  suburb?: InputMaybe<Sort>;
};

/** Pagination options for DropOffLocations. */
export type DropOffLocationsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DropOffLocationsOrderByInput>;
};

export type FacilitiesListFilter = {
  _and?: InputMaybe<Array<InputMaybe<FacilitiesListFilter>>>;
  _not?: InputMaybe<FacilitiesListFilter>;
  _or?: InputMaybe<Array<InputMaybe<FacilitiesListFilter>>>;
  address?: InputMaybe<Scalars['String']['input']>;
  address_gt?: InputMaybe<Scalars['String']['input']>;
  address_gte?: InputMaybe<Scalars['String']['input']>;
  address_ilike?: InputMaybe<Scalars['String']['input']>;
  address_in?: InputMaybe<Array<Scalars['String']['input']>>;
  address_like?: InputMaybe<Scalars['String']['input']>;
  address_lt?: InputMaybe<Scalars['String']['input']>;
  address_lte?: InputMaybe<Scalars['String']['input']>;
  address_ne?: InputMaybe<Scalars['String']['input']>;
  address_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  address_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  address_null?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_gt?: InputMaybe<Scalars['String']['input']>;
  code_gte?: InputMaybe<Scalars['String']['input']>;
  code_ilike?: InputMaybe<Scalars['String']['input']>;
  code_in?: InputMaybe<Array<Scalars['String']['input']>>;
  code_like?: InputMaybe<Scalars['String']['input']>;
  code_lt?: InputMaybe<Scalars['String']['input']>;
  code_lte?: InputMaybe<Scalars['String']['input']>;
  code_ne?: InputMaybe<Scalars['String']['input']>;
  code_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  code_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  code_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deleted_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  deleted_ne?: InputMaybe<Scalars['Boolean']['input']>;
  deleted_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  deleted_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  deleted_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lat_gt?: InputMaybe<Scalars['Float']['input']>;
  lat_gte?: InputMaybe<Scalars['Float']['input']>;
  lat_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lat_lt?: InputMaybe<Scalars['Float']['input']>;
  lat_lte?: InputMaybe<Scalars['Float']['input']>;
  lat_ne?: InputMaybe<Scalars['Float']['input']>;
  lat_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  lat_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  lat_null?: InputMaybe<Scalars['Boolean']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  lng_gt?: InputMaybe<Scalars['Float']['input']>;
  lng_gte?: InputMaybe<Scalars['Float']['input']>;
  lng_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lng_lt?: InputMaybe<Scalars['Float']['input']>;
  lng_lte?: InputMaybe<Scalars['Float']['input']>;
  lng_ne?: InputMaybe<Scalars['Float']['input']>;
  lng_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  lng_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  lng_null?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_ilike?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_like?: InputMaybe<Scalars['String']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  name_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  name_null?: InputMaybe<Scalars['Boolean']['input']>;
  photoRequired?: InputMaybe<Scalars['Boolean']['input']>;
  photoRequired_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  photoRequired_ne?: InputMaybe<Scalars['Boolean']['input']>;
  photoRequired_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  photoRequired_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  photoRequired_null?: InputMaybe<Scalars['Boolean']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  placeId_gt?: InputMaybe<Scalars['String']['input']>;
  placeId_gte?: InputMaybe<Scalars['String']['input']>;
  placeId_ilike?: InputMaybe<Scalars['String']['input']>;
  placeId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  placeId_like?: InputMaybe<Scalars['String']['input']>;
  placeId_lt?: InputMaybe<Scalars['String']['input']>;
  placeId_lte?: InputMaybe<Scalars['String']['input']>;
  placeId_ne?: InputMaybe<Scalars['String']['input']>;
  placeId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  placeId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  placeId_null?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_gt?: InputMaybe<Scalars['String']['input']>;
  postcode_gte?: InputMaybe<Scalars['String']['input']>;
  postcode_ilike?: InputMaybe<Scalars['String']['input']>;
  postcode_in?: InputMaybe<Array<Scalars['String']['input']>>;
  postcode_like?: InputMaybe<Scalars['String']['input']>;
  postcode_lt?: InputMaybe<Scalars['String']['input']>;
  postcode_lte?: InputMaybe<Scalars['String']['input']>;
  postcode_ne?: InputMaybe<Scalars['String']['input']>;
  postcode_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  postcode_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  postcode_null?: InputMaybe<Scalars['Boolean']['input']>;
  productTypes?: InputMaybe<MultipleFacilityProductTypesListFilter>;
  scanEvents?: InputMaybe<ScanEventsListFilter>;
  scanTypes?: InputMaybe<MultipleFacilityScanTypesListFilter>;
  state?: InputMaybe<FacilityState>;
  state_in?: InputMaybe<Array<FacilityState>>;
  state_nin?: InputMaybe<Array<FacilityState>>;
  type?: InputMaybe<FacilityType>;
  type_in?: InputMaybe<Array<FacilityType>>;
  type_nin?: InputMaybe<Array<FacilityType>>;
  users?: InputMaybe<UsersListFilter>;
};

export type FacilitiesOrderByInput = {
  address?: InputMaybe<Sort>;
  code?: InputMaybe<Sort>;
  createdAt?: InputMaybe<Sort>;
  deleted?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  lat?: InputMaybe<Sort>;
  lng?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  photoRequired?: InputMaybe<Sort>;
  placeId?: InputMaybe<Sort>;
  postcode?: InputMaybe<Sort>;
  state?: InputMaybe<Sort>;
  type?: InputMaybe<Sort>;
};

/** Pagination options for Facilities. */
export type FacilitiesPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FacilitiesOrderByInput>;
};

export type Facility = {
  __typename?: 'Facility';
  address: Scalars['String']['output'];
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISOString']['output'];
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  photoRequired: Scalars['Boolean']['output'];
  placeId: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  productTypes?: Maybe<Array<FacilityProductTypes>>;
  productTypes_aggregate?: Maybe<AggregationResult>;
  scanEvents: ScanEvent;
  scanEvents_aggregate?: Maybe<AggregationResult>;
  scanTypes?: Maybe<Array<FacilityScanTypes>>;
  scanTypes_aggregate?: Maybe<AggregationResult>;
  state: FacilityState;
  type: FacilityType;
  users?: Maybe<Array<User>>;
  users_aggregate?: Maybe<AggregationResult>;
};


export type FacilityProductTypesArgs = {
  filter?: InputMaybe<MultipleFacilityProductTypesListFilter>;
};


export type FacilityProductTypes_AggregateArgs = {
  filter?: InputMaybe<MultipleFacilityProductTypesListFilter>;
};


export type FacilityScanEventsArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
};


export type FacilityScanEvents_AggregateArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
};


export type FacilityScanTypesArgs = {
  filter?: InputMaybe<MultipleFacilityScanTypesListFilter>;
};


export type FacilityScanTypes_AggregateArgs = {
  filter?: InputMaybe<MultipleFacilityScanTypesListFilter>;
};


export type FacilityUsersArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type FacilityUsers_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};

export type FacilityBagAuditInput = {
  contaminationAmount?: InputMaybe<Scalars['Float']['input']>;
  facilityId: Scalars['String']['input'];
  isContaminated?: InputMaybe<Scalars['Boolean']['input']>;
  isDamaged?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  scannableCode: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export enum FacilityBagScanAction {
  Accept = 'ACCEPT',
  Audit = 'AUDIT',
  Reject = 'REJECT'
}

export type FacilityBagScanInput = {
  action: FacilityBagScanAction;
  facilityId: Scalars['String']['input'];
  material: MaterialType;
  scannableCode: Scalars['String']['input'];
};

export type FacilityBaleCreateInput = {
  facilityId: Scalars['String']['input'];
  material: MaterialType;
  scannableCode: Scalars['String']['input'];
};

export type FacilityBaleInboundInput = {
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
  docketId: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
  truckRegistration: Scalars['String']['input'];
  weight: Scalars['Float']['input'];
};

export type FacilityBaleOutboundInput = {
  codes: Array<Scalars['String']['input']>;
  docketId: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
  truckRegistration: Scalars['String']['input'];
  weight: Scalars['Float']['input'];
};

export type FacilityBaleProcessedInput = {
  codes: Array<Scalars['String']['input']>;
  facilityId: Scalars['String']['input'];
};

/** Data needed to create or update Facilities. If an ID is passed, this is an update, otherwise it's an insert. */
export type FacilityCreateOrUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photoRequired?: InputMaybe<Scalars['Boolean']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  productTypes?: InputMaybe<Array<FacilityProductTypesCreateOrUpdateInput>>;
  scanEvents?: InputMaybe<ScanEventCreateOrUpdateInput>;
  scanTypes?: InputMaybe<Array<FacilityScanTypesCreateOrUpdateInput>>;
  state?: InputMaybe<FacilityState>;
  type?: InputMaybe<FacilityType>;
  users?: InputMaybe<Array<UserCreateOrUpdateInput>>;
};

export type FacilityCustomer = {
  __typename?: 'FacilityCustomer';
  account: Account;
  account_aggregate?: Maybe<AggregationResult>;
  createdAt: Scalars['DateScalar']['output'];
  id: Scalars['ID']['output'];
  salesforceAccountId: Scalars['String']['output'];
};


export type FacilityCustomerAccountArgs = {
  filter?: InputMaybe<AccountsListFilter>;
};


export type FacilityCustomerAccount_AggregateArgs = {
  filter?: InputMaybe<AccountsListFilter>;
};

/** Data needed to create or update FacilityCustomers. If an ID is passed, this is an update, otherwise it's an insert. */
export type FacilityCustomerCreateOrUpdateInput = {
  account?: InputMaybe<AccountCreateOrUpdateInput>;
  createdAt?: InputMaybe<Scalars['DateScalar']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create FacilityCustomers. */
export type FacilityCustomerInsertInput = {
  account?: InputMaybe<AccountCreateOrUpdateInput>;
  createdAt: Scalars['DateScalar']['input'];
  salesforceAccountId: Scalars['String']['input'];
};

/** Data needed to update FacilityCustomers. An ID must be passed. */
export type FacilityCustomerUpdateInput = {
  account?: InputMaybe<AccountCreateOrUpdateInput>;
  createdAt?: InputMaybe<Scalars['DateScalar']['input']>;
  id: Scalars['ID']['input'];
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type FacilityCustomersListFilter = {
  _and?: InputMaybe<Array<InputMaybe<FacilityCustomersListFilter>>>;
  _not?: InputMaybe<FacilityCustomersListFilter>;
  _or?: InputMaybe<Array<InputMaybe<FacilityCustomersListFilter>>>;
  account?: InputMaybe<AccountsListFilter>;
  createdAt?: InputMaybe<Scalars['DateScalar']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateScalar']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateScalar']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateScalar']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateScalar']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateScalar']['input']>;
  createdAt_ne?: InputMaybe<Scalars['DateScalar']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['DateScalar']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId_gt?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId_gte?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId_ilike?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  salesforceAccountId_like?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId_lt?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId_lte?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId_ne?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  salesforceAccountId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  salesforceAccountId_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FacilityCustomersOrderByInput = {
  createdAt?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  salesforceAccountId?: InputMaybe<Sort>;
};

/** Pagination options for FacilityCustomers. */
export type FacilityCustomersPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FacilityCustomersOrderByInput>;
};

/** Data needed to create Facilities. */
export type FacilityInsertInput = {
  address: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['ISOString']['input'];
  deleted: Scalars['Boolean']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  photoRequired: Scalars['Boolean']['input'];
  placeId: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  productTypes?: InputMaybe<Array<FacilityProductTypesCreateOrUpdateInput>>;
  scanEvents?: InputMaybe<ScanEventCreateOrUpdateInput>;
  scanTypes?: InputMaybe<Array<FacilityScanTypesCreateOrUpdateInput>>;
  state: FacilityState;
  type: FacilityType;
  users?: InputMaybe<Array<UserCreateOrUpdateInput>>;
};

export type FacilityProductTypes = {
  __typename?: 'FacilityProductTypes';
  facilities?: Maybe<Array<Facility>>;
  facilities_aggregate?: Maybe<AggregationResult>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};


export type FacilityProductTypesFacilitiesArgs = {
  filter?: InputMaybe<FacilitiesListFilter>;
};


export type FacilityProductTypesFacilities_AggregateArgs = {
  filter?: InputMaybe<FacilitiesListFilter>;
};

/** Data needed to create or update MultipleFacilityProductTypes. If an ID is passed, this is an update, otherwise it's an insert. */
export type FacilityProductTypesCreateOrUpdateInput = {
  facilities?: InputMaybe<Array<FacilityCreateOrUpdateInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create MultipleFacilityProductTypes. */
export type FacilityProductTypesInsertInput = {
  facilities?: InputMaybe<Array<FacilityCreateOrUpdateInput>>;
  name: Scalars['String']['input'];
};

/** Data needed to update MultipleFacilityProductTypes. An ID must be passed. */
export type FacilityProductTypesUpdateInput = {
  facilities?: InputMaybe<Array<FacilityCreateOrUpdateInput>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FacilityScanTypes = {
  __typename?: 'FacilityScanTypes';
  facilities?: Maybe<Array<Facility>>;
  facilities_aggregate?: Maybe<AggregationResult>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};


export type FacilityScanTypesFacilitiesArgs = {
  filter?: InputMaybe<FacilitiesListFilter>;
};


export type FacilityScanTypesFacilities_AggregateArgs = {
  filter?: InputMaybe<FacilitiesListFilter>;
};

/** Data needed to create or update MultipleFacilityScanTypes. If an ID is passed, this is an update, otherwise it's an insert. */
export type FacilityScanTypesCreateOrUpdateInput = {
  facilities?: InputMaybe<Array<FacilityCreateOrUpdateInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create MultipleFacilityScanTypes. */
export type FacilityScanTypesInsertInput = {
  facilities?: InputMaybe<Array<FacilityCreateOrUpdateInput>>;
  name: Scalars['String']['input'];
};

/** Data needed to update MultipleFacilityScanTypes. An ID must be passed. */
export type FacilityScanTypesUpdateInput = {
  facilities?: InputMaybe<Array<FacilityCreateOrUpdateInput>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum FacilityState {
  Act = 'ACT',
  Nsw = 'NSW',
  Nt = 'NT',
  Qld = 'QLD',
  Sa = 'SA',
  Tas = 'TAS',
  Vic = 'VIC',
  Wa = 'WA'
}

export enum FacilityType {
  AggregationFacility = 'AGGREGATION_FACILITY',
  EndMarket = 'END_MARKET',
  MaterialRecovery = 'MATERIAL_RECOVERY',
  Processor = 'PROCESSOR'
}

/** Data needed to update Facilities. An ID must be passed. */
export type FacilityUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photoRequired?: InputMaybe<Scalars['Boolean']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  productTypes?: InputMaybe<Array<FacilityProductTypesCreateOrUpdateInput>>;
  scanEvents?: InputMaybe<ScanEventCreateOrUpdateInput>;
  scanTypes?: InputMaybe<Array<FacilityScanTypesCreateOrUpdateInput>>;
  state?: InputMaybe<FacilityState>;
  type?: InputMaybe<FacilityType>;
  users?: InputMaybe<Array<UserCreateOrUpdateInput>>;
};

export type GenerateBatchCodesInput = {
  isTrial: Scalars['Boolean']['input'];
  materialType: MaterialType;
  numberOfUniqueCodes: Scalars['Float']['input'];
  productType: AssetType;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type GetDropoffLocationsInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type GetSectionContentInput = {
  location: ContentSectionLocation;
  placement: ContentSectionPlacement;
};

export type GraphweaverMedia = {
  __typename?: 'GraphweaverMedia';
  filename: Scalars['String']['output'];
  type: MediaType;
  url: Scalars['String']['output'];
};

/** Data needed to create or update GraphweaverMedias. If an ID is passed, this is an update, otherwise it's an insert. */
export type GraphweaverMediaCreateOrUpdateInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MediaType>;
};

/** Data needed to create GraphweaverMedias. */
export type GraphweaverMediaInsertInput = {
  filename: Scalars['String']['input'];
  type: MediaType;
};

/** Data needed to update GraphweaverMedias. An ID must be passed. */
export type GraphweaverMediaUpdateInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MediaType>;
};

export type GraphweaverMediasListFilter = {
  _and?: InputMaybe<Array<InputMaybe<GraphweaverMediasListFilter>>>;
  _not?: InputMaybe<GraphweaverMediasListFilter>;
  _or?: InputMaybe<Array<InputMaybe<GraphweaverMediasListFilter>>>;
  filename?: InputMaybe<Scalars['String']['input']>;
  filename_gt?: InputMaybe<Scalars['String']['input']>;
  filename_gte?: InputMaybe<Scalars['String']['input']>;
  filename_ilike?: InputMaybe<Scalars['String']['input']>;
  filename_in?: InputMaybe<Array<Scalars['String']['input']>>;
  filename_like?: InputMaybe<Scalars['String']['input']>;
  filename_lt?: InputMaybe<Scalars['String']['input']>;
  filename_lte?: InputMaybe<Scalars['String']['input']>;
  filename_ne?: InputMaybe<Scalars['String']['input']>;
  filename_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  filename_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  filename_null?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<MediaType>;
  type_in?: InputMaybe<Array<MediaType>>;
  type_nin?: InputMaybe<Array<MediaType>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_gt?: InputMaybe<Scalars['String']['input']>;
  url_gte?: InputMaybe<Scalars['String']['input']>;
  url_ilike?: InputMaybe<Scalars['String']['input']>;
  url_in?: InputMaybe<Array<Scalars['String']['input']>>;
  url_like?: InputMaybe<Scalars['String']['input']>;
  url_lt?: InputMaybe<Scalars['String']['input']>;
  url_lte?: InputMaybe<Scalars['String']['input']>;
  url_ne?: InputMaybe<Scalars['String']['input']>;
  url_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  url_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  url_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MaterialType {
  BlendedFibre = 'BLENDED_FIBRE',
  Cardboard = 'CARDBOARD',
  CoffeePods = 'COFFEE_PODS',
  GlassCoarse = 'GLASS_COARSE',
  GlassFine = 'GLASS_FINE',
  GlassMedium = 'GLASS_MEDIUM',
  GlassMoondust = 'GLASS_MOONDUST',
  GlassSf_300_150 = 'GLASS_SF_300_150',
  GlassSf_500_300 = 'GLASS_SF_500_300',
  GlassSuperfine = 'GLASS_SUPERFINE',
  LiquidPaperBoard = 'LIQUID_PAPER_BOARD',
  MixedPaper = 'MIXED_PAPER',
  MixedPlastic = 'MIXED_PLASTIC',
  SoftPlastic = 'SOFT_PLASTIC',
  Textiles = 'TEXTILES'
}

export enum MediaType {
  Image = 'IMAGE',
  Other = 'OTHER'
}

/** This is an object of key-value pairs. By convention we expect the following keys, which users can enter in Stripe in the metadata field. They will need to type the exact key and the value. Keep in mind that all values are strings. */
export type Metadata = {
  __typename?: 'Metadata';
  background_colour?: Maybe<Scalars['String']['output']>;
  entries_gained_per_scan?: Maybe<Scalars['String']['output']>;
  free_shipping?: Maybe<Scalars['String']['output']>;
  free_tag_limit?: Maybe<Scalars['String']['output']>;
  information_section_item_1?: Maybe<Scalars['String']['output']>;
  information_section_item_2?: Maybe<Scalars['String']['output']>;
  information_section_list?: Maybe<Scalars['String']['output']>;
  is_subscription?: Maybe<Scalars['String']['output']>;
  order_number?: Maybe<Scalars['String']['output']>;
};

/** Data needed to create or update MultipleMetadata. If an ID is passed, this is an update, otherwise it's an insert. */
export type MetadataCreateOrUpdateInput = {
  background_colour?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan?: InputMaybe<Scalars['String']['input']>;
  free_shipping?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2?: InputMaybe<Scalars['String']['input']>;
  information_section_list?: InputMaybe<Scalars['String']['input']>;
  is_subscription?: InputMaybe<Scalars['String']['input']>;
  order_number?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create MultipleMetadata. */
export type MetadataInsertInput = {
  background_colour?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan?: InputMaybe<Scalars['String']['input']>;
  free_shipping?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2?: InputMaybe<Scalars['String']['input']>;
  information_section_list?: InputMaybe<Scalars['String']['input']>;
  is_subscription?: InputMaybe<Scalars['String']['input']>;
  order_number?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to update MultipleMetadata. An ID must be passed. */
export type MetadataUpdateInput = {
  background_colour?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan?: InputMaybe<Scalars['String']['input']>;
  free_shipping?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2?: InputMaybe<Scalars['String']['input']>;
  information_section_list?: InputMaybe<Scalars['String']['input']>;
  is_subscription?: InputMaybe<Scalars['String']['input']>;
  order_number?: InputMaybe<Scalars['String']['input']>;
};

export type MultipleFacilityProductTypesListFilter = {
  _and?: InputMaybe<Array<InputMaybe<MultipleFacilityProductTypesListFilter>>>;
  _not?: InputMaybe<MultipleFacilityProductTypesListFilter>;
  _or?: InputMaybe<Array<InputMaybe<MultipleFacilityProductTypesListFilter>>>;
  facilities?: InputMaybe<FacilitiesListFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_ilike?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_like?: InputMaybe<Scalars['String']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  name_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  name_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MultipleFacilityProductTypesOrderByInput = {
  id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

/** Pagination options for MultipleFacilityProductTypes. */
export type MultipleFacilityProductTypesPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MultipleFacilityProductTypesOrderByInput>;
};

export type MultipleFacilityScanTypesListFilter = {
  _and?: InputMaybe<Array<InputMaybe<MultipleFacilityScanTypesListFilter>>>;
  _not?: InputMaybe<MultipleFacilityScanTypesListFilter>;
  _or?: InputMaybe<Array<InputMaybe<MultipleFacilityScanTypesListFilter>>>;
  facilities?: InputMaybe<FacilitiesListFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_ilike?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_like?: InputMaybe<Scalars['String']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  name_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  name_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MultipleFacilityScanTypesOrderByInput = {
  id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

/** Pagination options for MultipleFacilityScanTypes. */
export type MultipleFacilityScanTypesPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MultipleFacilityScanTypesOrderByInput>;
};

/** This is an object of key-value pairs. By convention we expect the following keys, which users can enter in Stripe in the metadata field. They will need to type the exact key and the value. Keep in mind that all values are strings. */
export type MultipleMetadataListFilter = {
  _and?: InputMaybe<Array<InputMaybe<MultipleMetadataListFilter>>>;
  _not?: InputMaybe<MultipleMetadataListFilter>;
  _or?: InputMaybe<Array<InputMaybe<MultipleMetadataListFilter>>>;
  background_colour?: InputMaybe<Scalars['String']['input']>;
  background_colour_gt?: InputMaybe<Scalars['String']['input']>;
  background_colour_gte?: InputMaybe<Scalars['String']['input']>;
  background_colour_ilike?: InputMaybe<Scalars['String']['input']>;
  background_colour_in?: InputMaybe<Array<Scalars['String']['input']>>;
  background_colour_like?: InputMaybe<Scalars['String']['input']>;
  background_colour_lt?: InputMaybe<Scalars['String']['input']>;
  background_colour_lte?: InputMaybe<Scalars['String']['input']>;
  background_colour_ne?: InputMaybe<Scalars['String']['input']>;
  background_colour_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  background_colour_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  background_colour_null?: InputMaybe<Scalars['Boolean']['input']>;
  entries_gained_per_scan?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan_gt?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan_gte?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan_ilike?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  entries_gained_per_scan_like?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan_lt?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan_lte?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan_ne?: InputMaybe<Scalars['String']['input']>;
  entries_gained_per_scan_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  entries_gained_per_scan_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  entries_gained_per_scan_null?: InputMaybe<Scalars['Boolean']['input']>;
  free_shipping?: InputMaybe<Scalars['String']['input']>;
  free_shipping_gt?: InputMaybe<Scalars['String']['input']>;
  free_shipping_gte?: InputMaybe<Scalars['String']['input']>;
  free_shipping_ilike?: InputMaybe<Scalars['String']['input']>;
  free_shipping_in?: InputMaybe<Array<Scalars['String']['input']>>;
  free_shipping_like?: InputMaybe<Scalars['String']['input']>;
  free_shipping_lt?: InputMaybe<Scalars['String']['input']>;
  free_shipping_lte?: InputMaybe<Scalars['String']['input']>;
  free_shipping_ne?: InputMaybe<Scalars['String']['input']>;
  free_shipping_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  free_shipping_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  free_shipping_null?: InputMaybe<Scalars['Boolean']['input']>;
  free_tag_limit?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit_gt?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit_gte?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit_ilike?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit_in?: InputMaybe<Array<Scalars['String']['input']>>;
  free_tag_limit_like?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit_lt?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit_lte?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit_ne?: InputMaybe<Scalars['String']['input']>;
  free_tag_limit_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  free_tag_limit_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  free_tag_limit_null?: InputMaybe<Scalars['Boolean']['input']>;
  information_section_item_1?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1_gt?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1_gte?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1_ilike?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1_in?: InputMaybe<Array<Scalars['String']['input']>>;
  information_section_item_1_like?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1_lt?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1_lte?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1_ne?: InputMaybe<Scalars['String']['input']>;
  information_section_item_1_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  information_section_item_1_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  information_section_item_1_null?: InputMaybe<Scalars['Boolean']['input']>;
  information_section_item_2?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2_gt?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2_gte?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2_ilike?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2_in?: InputMaybe<Array<Scalars['String']['input']>>;
  information_section_item_2_like?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2_lt?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2_lte?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2_ne?: InputMaybe<Scalars['String']['input']>;
  information_section_item_2_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  information_section_item_2_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  information_section_item_2_null?: InputMaybe<Scalars['Boolean']['input']>;
  information_section_list?: InputMaybe<Scalars['String']['input']>;
  information_section_list_gt?: InputMaybe<Scalars['String']['input']>;
  information_section_list_gte?: InputMaybe<Scalars['String']['input']>;
  information_section_list_ilike?: InputMaybe<Scalars['String']['input']>;
  information_section_list_in?: InputMaybe<Array<Scalars['String']['input']>>;
  information_section_list_like?: InputMaybe<Scalars['String']['input']>;
  information_section_list_lt?: InputMaybe<Scalars['String']['input']>;
  information_section_list_lte?: InputMaybe<Scalars['String']['input']>;
  information_section_list_ne?: InputMaybe<Scalars['String']['input']>;
  information_section_list_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  information_section_list_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  information_section_list_null?: InputMaybe<Scalars['Boolean']['input']>;
  is_subscription?: InputMaybe<Scalars['String']['input']>;
  is_subscription_gt?: InputMaybe<Scalars['String']['input']>;
  is_subscription_gte?: InputMaybe<Scalars['String']['input']>;
  is_subscription_ilike?: InputMaybe<Scalars['String']['input']>;
  is_subscription_in?: InputMaybe<Array<Scalars['String']['input']>>;
  is_subscription_like?: InputMaybe<Scalars['String']['input']>;
  is_subscription_lt?: InputMaybe<Scalars['String']['input']>;
  is_subscription_lte?: InputMaybe<Scalars['String']['input']>;
  is_subscription_ne?: InputMaybe<Scalars['String']['input']>;
  is_subscription_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  is_subscription_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  is_subscription_null?: InputMaybe<Scalars['Boolean']['input']>;
  order_number?: InputMaybe<Scalars['String']['input']>;
  order_number_gt?: InputMaybe<Scalars['String']['input']>;
  order_number_gte?: InputMaybe<Scalars['String']['input']>;
  order_number_ilike?: InputMaybe<Scalars['String']['input']>;
  order_number_in?: InputMaybe<Array<Scalars['String']['input']>>;
  order_number_like?: InputMaybe<Scalars['String']['input']>;
  order_number_lt?: InputMaybe<Scalars['String']['input']>;
  order_number_lte?: InputMaybe<Scalars['String']['input']>;
  order_number_ne?: InputMaybe<Scalars['String']['input']>;
  order_number_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  order_number_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  order_number_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MultipleScanEventChangesListFilter = {
  _and?: InputMaybe<Array<InputMaybe<MultipleScanEventChangesListFilter>>>;
  _not?: InputMaybe<MultipleScanEventChangesListFilter>;
  _or?: InputMaybe<Array<InputMaybe<MultipleScanEventChangesListFilter>>>;
  after?: InputMaybe<Scalars['JSON']['input']>;
  after_in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  after_ne?: InputMaybe<Scalars['JSON']['input']>;
  after_nin?: InputMaybe<Array<Scalars['JSON']['input']>>;
  after_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  after_null?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['JSON']['input']>;
  before_in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  before_ne?: InputMaybe<Scalars['JSON']['input']>;
  before_nin?: InputMaybe<Array<Scalars['JSON']['input']>>;
  before_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  before_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  scanEvent?: InputMaybe<ScanEventsListFilter>;
  user?: InputMaybe<UsersListFilter>;
};

export type MultipleScanEventChangesOrderByInput = {
  after?: InputMaybe<Sort>;
  before?: InputMaybe<Sort>;
  createdAt?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
};

/** Pagination options for MultipleScanEventChanges. */
export type MultipleScanEventChangesPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MultipleScanEventChangesOrderByInput>;
};

export type MultipleUserWithScanEventsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<MultipleUserWithScanEventsListFilter>>>;
  _not?: InputMaybe<MultipleUserWithScanEventsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<MultipleUserWithScanEventsListFilter>>>;
  council?: InputMaybe<Scalars['String']['input']>;
  council_gt?: InputMaybe<Scalars['String']['input']>;
  council_gte?: InputMaybe<Scalars['String']['input']>;
  council_ilike?: InputMaybe<Scalars['String']['input']>;
  council_in?: InputMaybe<Array<Scalars['String']['input']>>;
  council_like?: InputMaybe<Scalars['String']['input']>;
  council_lt?: InputMaybe<Scalars['String']['input']>;
  council_lte?: InputMaybe<Scalars['String']['input']>;
  council_ne?: InputMaybe<Scalars['String']['input']>;
  council_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  council_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  council_null?: InputMaybe<Scalars['Boolean']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  dwellingType_gt?: InputMaybe<Scalars['String']['input']>;
  dwellingType_gte?: InputMaybe<Scalars['String']['input']>;
  dwellingType_ilike?: InputMaybe<Scalars['String']['input']>;
  dwellingType_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dwellingType_like?: InputMaybe<Scalars['String']['input']>;
  dwellingType_lt?: InputMaybe<Scalars['String']['input']>;
  dwellingType_lte?: InputMaybe<Scalars['String']['input']>;
  dwellingType_ne?: InputMaybe<Scalars['String']['input']>;
  dwellingType_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  dwellingType_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  dwellingType_null?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_gt?: InputMaybe<Scalars['String']['input']>;
  email_gte?: InputMaybe<Scalars['String']['input']>;
  email_ilike?: InputMaybe<Scalars['String']['input']>;
  email_in?: InputMaybe<Array<Scalars['String']['input']>>;
  email_like?: InputMaybe<Scalars['String']['input']>;
  email_lt?: InputMaybe<Scalars['String']['input']>;
  email_lte?: InputMaybe<Scalars['String']['input']>;
  email_ne?: InputMaybe<Scalars['String']['input']>;
  email_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  email_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  email_null?: InputMaybe<Scalars['Boolean']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_gt?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_gte?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_ilike?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_in?: InputMaybe<Array<Scalars['String']['input']>>;
  formattedAddress_like?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_lt?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_lte?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_ne?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  formattedAddress_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  formattedAddress_null?: InputMaybe<Scalars['Boolean']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_gt?: InputMaybe<Scalars['String']['input']>;
  gender_gte?: InputMaybe<Scalars['String']['input']>;
  gender_ilike?: InputMaybe<Scalars['String']['input']>;
  gender_in?: InputMaybe<Array<Scalars['String']['input']>>;
  gender_like?: InputMaybe<Scalars['String']['input']>;
  gender_lt?: InputMaybe<Scalars['String']['input']>;
  gender_lte?: InputMaybe<Scalars['String']['input']>;
  gender_ne?: InputMaybe<Scalars['String']['input']>;
  gender_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  gender_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  gender_null?: InputMaybe<Scalars['Boolean']['input']>;
  householdSize?: InputMaybe<Scalars['Float']['input']>;
  householdSize_gt?: InputMaybe<Scalars['Float']['input']>;
  householdSize_gte?: InputMaybe<Scalars['Float']['input']>;
  householdSize_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  householdSize_lt?: InputMaybe<Scalars['Float']['input']>;
  householdSize_lte?: InputMaybe<Scalars['Float']['input']>;
  householdSize_ne?: InputMaybe<Scalars['Float']['input']>;
  householdSize_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  householdSize_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  householdSize_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isParticipatingInPrizeDraw_ne?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isParticipatingInPrizeDraw_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw_null?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_gt?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_gte?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_ilike?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_in?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber_like?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_lt?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_lte?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_ne?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber_null?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_gt?: InputMaybe<Scalars['String']['input']>;
  postcode_gte?: InputMaybe<Scalars['String']['input']>;
  postcode_ilike?: InputMaybe<Scalars['String']['input']>;
  postcode_in?: InputMaybe<Array<Scalars['String']['input']>>;
  postcode_like?: InputMaybe<Scalars['String']['input']>;
  postcode_lt?: InputMaybe<Scalars['String']['input']>;
  postcode_lte?: InputMaybe<Scalars['String']['input']>;
  postcode_ne?: InputMaybe<Scalars['String']['input']>;
  postcode_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  postcode_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  postcode_null?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_gt?: InputMaybe<Scalars['String']['input']>;
  state_gte?: InputMaybe<Scalars['String']['input']>;
  state_ilike?: InputMaybe<Scalars['String']['input']>;
  state_in?: InputMaybe<Array<Scalars['String']['input']>>;
  state_like?: InputMaybe<Scalars['String']['input']>;
  state_lt?: InputMaybe<Scalars['String']['input']>;
  state_lte?: InputMaybe<Scalars['String']['input']>;
  state_ne?: InputMaybe<Scalars['String']['input']>;
  state_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  state_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  state_null?: InputMaybe<Scalars['Boolean']['input']>;
  totalScans?: InputMaybe<Scalars['Float']['input']>;
  totalScans_gt?: InputMaybe<Scalars['Float']['input']>;
  totalScans_gte?: InputMaybe<Scalars['Float']['input']>;
  totalScans_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  totalScans_lt?: InputMaybe<Scalars['Float']['input']>;
  totalScans_lte?: InputMaybe<Scalars['Float']['input']>;
  totalScans_ne?: InputMaybe<Scalars['Float']['input']>;
  totalScans_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  totalScans_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  totalScans_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MultipleUserWithScanEventsOrderByInput = {
  council?: InputMaybe<Sort>;
  dwellingType?: InputMaybe<Sort>;
  email?: InputMaybe<Sort>;
  formattedAddress?: InputMaybe<Sort>;
  gender?: InputMaybe<Sort>;
  householdSize?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  isParticipatingInPrizeDraw?: InputMaybe<Sort>;
  phoneNumber?: InputMaybe<Sort>;
  postcode?: InputMaybe<Sort>;
  state?: InputMaybe<Sort>;
  totalScans?: InputMaybe<Sort>;
};

/** Pagination options for MultipleUserWithScanEvents. */
export type MultipleUserWithScanEventsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MultipleUserWithScanEventsOrderByInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  challengePassword?: Maybe<Token>;
  changePassword?: Maybe<Token>;
  confirmBagMaterial?: Maybe<ScanEvent>;
  /** Create a single AccordionItem. */
  createAccordionItem?: Maybe<AccordionItem>;
  /** Create many AccordionItems. */
  createAccordionItems?: Maybe<Array<Maybe<AccordionItem>>>;
  /** Create a single Account. */
  createAccount?: Maybe<Account>;
  /** Create many Accounts. */
  createAccounts?: Maybe<Array<Maybe<Account>>>;
  /** Create a single BatchCode. */
  createBatchCode?: Maybe<BatchCode>;
  /** Create many BatchCodes. */
  createBatchCodes?: Maybe<Array<Maybe<BatchCode>>>;
  /** Create a single Blacklist. */
  createBlacklist?: Maybe<Blacklist>;
  /** Create many Blacklists. */
  createBlacklists?: Maybe<Array<Maybe<Blacklist>>>;
  /** Create a single Case. */
  createCase?: Maybe<Case>;
  /** Create many Cases. */
  createCases?: Maybe<Array<Maybe<Case>>>;
  /** Create a single Contact. */
  createContact?: Maybe<Contact>;
  /** Create many Contacts. */
  createContacts?: Maybe<Array<Maybe<Contact>>>;
  /** Create a single ContentSection. */
  createContentSection?: Maybe<ContentSection>;
  /** Create many ContentSections. */
  createContentSections?: Maybe<Array<Maybe<ContentSection>>>;
  /** Create a single Council. */
  createCouncil?: Maybe<Council>;
  /** Create many Councils. */
  createCouncils?: Maybe<Array<Maybe<Council>>>;
  createCredential?: Maybe<Credential>;
  /** Create a single DropOffLocation. */
  createDropOffLocation?: Maybe<DropOffLocation>;
  /** Create many DropOffLocations. */
  createDropOffLocations?: Maybe<Array<Maybe<DropOffLocation>>>;
  /** Create many Facilities. */
  createFacilities?: Maybe<Array<Maybe<Facility>>>;
  /** Create a single Facility. */
  createFacility?: Maybe<Facility>;
  /** Create a single FacilityCustomer. */
  createFacilityCustomer?: Maybe<FacilityCustomer>;
  /** Create many FacilityCustomers. */
  createFacilityCustomers?: Maybe<Array<Maybe<FacilityCustomer>>>;
  /** Create a single FacilityProductTypes. */
  createFacilityProductTypes?: Maybe<FacilityProductTypes>;
  /** Create a single FacilityScanTypes. */
  createFacilityScanTypes?: Maybe<FacilityScanTypes>;
  /** Create many MultipleFacilityProductTypes. */
  createMultipleFacilityProductTypes?: Maybe<Array<Maybe<FacilityProductTypes>>>;
  /** Create many MultipleFacilityScanTypes. */
  createMultipleFacilityScanTypes?: Maybe<Array<Maybe<FacilityScanTypes>>>;
  /** Create many MultipleUserWithScanEvents. */
  createMultipleUserWithScanEvents?: Maybe<Array<Maybe<UserWithScanEvents>>>;
  /** Create a single NewsFeed. */
  createNewsFeed?: Maybe<NewsFeed>;
  /** Create many NewsFeeds. */
  createNewsFeeds?: Maybe<Array<Maybe<NewsFeed>>>;
  /** Create or update many AccordionItems. */
  createOrUpdateAccordionItems?: Maybe<Array<Maybe<AccordionItem>>>;
  /** Create or update many Accounts. */
  createOrUpdateAccounts?: Maybe<Array<Maybe<Account>>>;
  /** Create or update many BatchCodes. */
  createOrUpdateBatchCodes?: Maybe<Array<Maybe<BatchCode>>>;
  /** Create or update many Blacklists. */
  createOrUpdateBlacklists?: Maybe<Array<Maybe<Blacklist>>>;
  /** Create or update many Cases. */
  createOrUpdateCases?: Maybe<Array<Maybe<Case>>>;
  /** Create or update many Contacts. */
  createOrUpdateContacts?: Maybe<Array<Maybe<Contact>>>;
  /** Create or update many ContentSections. */
  createOrUpdateContentSections?: Maybe<Array<Maybe<ContentSection>>>;
  /** Create or update many Councils. */
  createOrUpdateCouncils?: Maybe<Array<Maybe<Council>>>;
  /** Create or update many DropOffLocations. */
  createOrUpdateDropOffLocations?: Maybe<Array<Maybe<DropOffLocation>>>;
  /** Create or update many Facilities. */
  createOrUpdateFacilities?: Maybe<Array<Maybe<Facility>>>;
  /** Create or update many FacilityCustomers. */
  createOrUpdateFacilityCustomers?: Maybe<Array<Maybe<FacilityCustomer>>>;
  /** Create or update many MultipleFacilityProductTypes. */
  createOrUpdateMultipleFacilityProductTypes?: Maybe<Array<Maybe<FacilityProductTypes>>>;
  /** Create or update many MultipleFacilityScanTypes. */
  createOrUpdateMultipleFacilityScanTypes?: Maybe<Array<Maybe<FacilityScanTypes>>>;
  /** Create or update many MultipleUserWithScanEvents. */
  createOrUpdateMultipleUserWithScanEvents?: Maybe<Array<Maybe<UserWithScanEvents>>>;
  /** Create or update many NewsFeeds. */
  createOrUpdateNewsFeeds?: Maybe<Array<Maybe<NewsFeed>>>;
  /** Create or update many PastWinners. */
  createOrUpdatePastWinners?: Maybe<Array<Maybe<PastWinner>>>;
  /** Create or update many Postcodes. */
  createOrUpdatePostcodes?: Maybe<Array<Maybe<Postcode>>>;
  /** Create or update many Prizes. */
  createOrUpdatePrizes?: Maybe<Array<Maybe<Prize>>>;
  /** Create or update many Roles. */
  createOrUpdateRoles?: Maybe<Array<Maybe<Role>>>;
  /** Create or update many ScanEventPhotos. */
  createOrUpdateScanEventPhotos?: Maybe<Array<Maybe<ScanEventPhoto>>>;
  /** Create or update many ScanEvents. */
  createOrUpdateScanEvents?: Maybe<Array<Maybe<ScanEvent>>>;
  /** Create or update many Suburbs. */
  createOrUpdateSuburbs?: Maybe<Array<Maybe<Suburb>>>;
  /** Create or update many Tags. */
  createOrUpdateTags?: Maybe<Array<Maybe<Tag>>>;
  /** Create or update many TrackableAssets. */
  createOrUpdateTrackableAssets?: Maybe<Array<Maybe<TrackableAsset>>>;
  /** Create or update many UserAlerts. */
  createOrUpdateUserAlerts?: Maybe<Array<Maybe<UserAlert>>>;
  /** Create or update many UserPrizeEntryCounts. */
  createOrUpdateUserPrizeEntryCounts?: Maybe<Array<Maybe<UserPrizeEntryCount>>>;
  /** Create or update many UserSubscriptions. */
  createOrUpdateUserSubscriptions?: Maybe<Array<Maybe<UserSubscription>>>;
  /** Create or update many Users. */
  createOrUpdateUsers?: Maybe<Array<Maybe<User>>>;
  /** Create a single PastWinner. */
  createPastWinner?: Maybe<PastWinner>;
  /** Create many PastWinners. */
  createPastWinners?: Maybe<Array<Maybe<PastWinner>>>;
  /** Create a single Postcode. */
  createPostcode?: Maybe<Postcode>;
  /** Create many Postcodes. */
  createPostcodes?: Maybe<Array<Maybe<Postcode>>>;
  /** Create a single Prize. */
  createPrize?: Maybe<Prize>;
  /** Create many Prizes. */
  createPrizes?: Maybe<Array<Maybe<Prize>>>;
  /** Create a single Role. */
  createRole?: Maybe<Role>;
  /** Create many Roles. */
  createRoles?: Maybe<Array<Maybe<Role>>>;
  /** Create a Salesforce case. This cannot currently be done by `createCase` base mutation. */
  createSalesforceCase?: Maybe<Case>;
  /** Create a single ScanEvent. */
  createScanEvent?: Maybe<ScanEvent>;
  /** Create a single ScanEventPhoto. */
  createScanEventPhoto?: Maybe<ScanEventPhoto>;
  /** Create many ScanEventPhotos. */
  createScanEventPhotos?: Maybe<Array<Maybe<ScanEventPhoto>>>;
  /** Create many ScanEvents. */
  createScanEvents?: Maybe<Array<Maybe<ScanEvent>>>;
  createSessionForOneOffPayment?: Maybe<StripeCreateSessionResult>;
  createSessionForSubscriptionPayment?: Maybe<StripeCreateSessionResult>;
  /** Create a single Suburb. */
  createSuburb?: Maybe<Suburb>;
  /** Create many Suburbs. */
  createSuburbs?: Maybe<Array<Maybe<Suburb>>>;
  /** Create a single Tag. */
  createTag?: Maybe<Tag>;
  /** Create many Tags. */
  createTags?: Maybe<Array<Maybe<Tag>>>;
  /** Create a single TrackableAsset. */
  createTrackableAsset?: Maybe<TrackableAsset>;
  /** Create many TrackableAssets. */
  createTrackableAssets?: Maybe<Array<Maybe<TrackableAsset>>>;
  /** Create a single User. */
  createUser?: Maybe<User>;
  /** Create a single UserAlert. */
  createUserAlert?: Maybe<UserAlert>;
  /** Create many UserAlerts. */
  createUserAlerts?: Maybe<Array<Maybe<UserAlert>>>;
  /** Create a single UserPrizeEntryCount. */
  createUserPrizeEntryCount?: Maybe<UserPrizeEntryCount>;
  /** Create many UserPrizeEntryCounts. */
  createUserPrizeEntryCounts?: Maybe<Array<Maybe<UserPrizeEntryCount>>>;
  /** Create a single UserSubscription. */
  createUserSubscription?: Maybe<UserSubscription>;
  /** Create many UserSubscriptions. */
  createUserSubscriptions?: Maybe<Array<Maybe<UserSubscription>>>;
  /** Create a single UserWithScanEvents. */
  createUserWithScanEvents?: Maybe<UserWithScanEvents>;
  /** Create many Users. */
  createUsers?: Maybe<Array<Maybe<User>>>;
  customCreateUser?: Maybe<Token>;
  customUpdateScanEvent?: Maybe<ScanEvent>;
  /** Delete a single AccordionItem. */
  deleteAccordionItem?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many AccordionItems with a filter. */
  deleteAccordionItems?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Account. */
  deleteAccount?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Accounts with a filter. */
  deleteAccounts?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single BatchCode. */
  deleteBatchCode?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many BatchCodes with a filter. */
  deleteBatchCodes?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Blacklist. */
  deleteBlacklist?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Blacklists with a filter. */
  deleteBlacklists?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Case. */
  deleteCase?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Cases with a filter. */
  deleteCases?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Contact. */
  deleteContact?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Contacts with a filter. */
  deleteContacts?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single ContentSection. */
  deleteContentSection?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many ContentSections with a filter. */
  deleteContentSections?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Council. */
  deleteCouncil?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Councils with a filter. */
  deleteCouncils?: Maybe<Scalars['Boolean']['output']>;
  deleteCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single DropOffLocation. */
  deleteDropOffLocation?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many DropOffLocations with a filter. */
  deleteDropOffLocations?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Facilities with a filter. */
  deleteFacilities?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Facility. */
  deleteFacility?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single FacilityCustomer. */
  deleteFacilityCustomer?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many FacilityCustomers with a filter. */
  deleteFacilityCustomers?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single FacilityProductTypes. */
  deleteFacilityProductTypes?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single FacilityScanTypes. */
  deleteFacilityScanTypes?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many MultipleFacilityProductTypes with a filter. */
  deleteMultipleFacilityProductTypes?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many MultipleFacilityScanTypes with a filter. */
  deleteMultipleFacilityScanTypes?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many MultipleUserWithScanEvents with a filter. */
  deleteMultipleUserWithScanEvents?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single NewsFeed. */
  deleteNewsFeed?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many NewsFeeds with a filter. */
  deleteNewsFeeds?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single PastWinner. */
  deletePastWinner?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many PastWinners with a filter. */
  deletePastWinners?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Postcode. */
  deletePostcode?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Postcodes with a filter. */
  deletePostcodes?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Prize. */
  deletePrize?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Prizes with a filter. */
  deletePrizes?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Role. */
  deleteRole?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Roles with a filter. */
  deleteRoles?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single ScanEvent. */
  deleteScanEvent?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single ScanEventPhoto. */
  deleteScanEventPhoto?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many ScanEventPhotos with a filter. */
  deleteScanEventPhotos?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many ScanEvents with a filter. */
  deleteScanEvents?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Suburb. */
  deleteSuburb?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Suburbs with a filter. */
  deleteSuburbs?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single Tag. */
  deleteTag?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Tags with a filter. */
  deleteTags?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single TrackableAsset. */
  deleteTrackableAsset?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many TrackableAssets with a filter. */
  deleteTrackableAssets?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single User. */
  deleteUser?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single UserAlert. */
  deleteUserAlert?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many UserAlerts with a filter. */
  deleteUserAlerts?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single UserPrizeEntryCount. */
  deleteUserPrizeEntryCount?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many UserPrizeEntryCounts with a filter. */
  deleteUserPrizeEntryCounts?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single UserSubscription. */
  deleteUserSubscription?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many UserSubscriptions with a filter. */
  deleteUserSubscriptions?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a single UserWithScanEvents. */
  deleteUserWithScanEvents?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many Users with a filter. */
  deleteUsers?: Maybe<Scalars['Boolean']['output']>;
  facilityBagAudit?: Maybe<ScanEvent>;
  facilityBagScan?: Maybe<ScanEvent>;
  facilityBaleCreate?: Maybe<ScanEvent>;
  facilityBaleInbound?: Maybe<ScanEvent>;
  facilityBaleOutbound?: Maybe<ScanEvent>;
  facilityBaleProcessed?: Maybe<Array<Maybe<ScanEvent>>>;
  finaliseSubscription?: Maybe<StripeProduct>;
  generateBatchCodes?: Maybe<BatchCode>;
  getDeleteUrl?: Maybe<Scalars['String']['output']>;
  getUploadUrl?: Maybe<Scalars['JSON']['output']>;
  loginPassword?: Maybe<Token>;
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  scanAssetFromUser?: Maybe<ScanEvent>;
  sendResetPasswordLink?: Maybe<Scalars['Boolean']['output']>;
  tagBatchCode?: Maybe<Scalars['Float']['output']>;
  untagBatchCode?: Maybe<Scalars['Float']['output']>;
  /** Update a single AccordionItem. */
  updateAccordionItem?: Maybe<AccordionItem>;
  /** Update many AccordionItems. */
  updateAccordionItems?: Maybe<Array<Maybe<AccordionItem>>>;
  /** Update a single Account. */
  updateAccount?: Maybe<Account>;
  /** Update many Accounts. */
  updateAccounts?: Maybe<Array<Maybe<Account>>>;
  /** Update a single BatchCode. */
  updateBatchCode?: Maybe<BatchCode>;
  /** Update many BatchCodes. */
  updateBatchCodes?: Maybe<Array<Maybe<BatchCode>>>;
  /** Update a single Blacklist. */
  updateBlacklist?: Maybe<Blacklist>;
  /** Update many Blacklists. */
  updateBlacklists?: Maybe<Array<Maybe<Blacklist>>>;
  /** Update a single Case. */
  updateCase?: Maybe<Case>;
  /** Update many Cases. */
  updateCases?: Maybe<Array<Maybe<Case>>>;
  /** Update a single Contact. */
  updateContact?: Maybe<Contact>;
  /** Update many Contacts. */
  updateContacts?: Maybe<Array<Maybe<Contact>>>;
  /** Update a single ContentSection. */
  updateContentSection?: Maybe<ContentSection>;
  /** Update many ContentSections. */
  updateContentSections?: Maybe<Array<Maybe<ContentSection>>>;
  /** Update a single Council. */
  updateCouncil?: Maybe<Council>;
  /** Update many Councils. */
  updateCouncils?: Maybe<Array<Maybe<Council>>>;
  updateCredential?: Maybe<Credential>;
  updateCurrentUser?: Maybe<User>;
  /** Update a single DropOffLocation. */
  updateDropOffLocation?: Maybe<DropOffLocation>;
  /** Update many DropOffLocations. */
  updateDropOffLocations?: Maybe<Array<Maybe<DropOffLocation>>>;
  /** Update many Facilities. */
  updateFacilities?: Maybe<Array<Maybe<Facility>>>;
  /** Update a single Facility. */
  updateFacility?: Maybe<Facility>;
  /** Update a single FacilityCustomer. */
  updateFacilityCustomer?: Maybe<FacilityCustomer>;
  /** Update many FacilityCustomers. */
  updateFacilityCustomers?: Maybe<Array<Maybe<FacilityCustomer>>>;
  /** Update a single FacilityProductTypes. */
  updateFacilityProductTypes?: Maybe<FacilityProductTypes>;
  /** Update a single FacilityScanTypes. */
  updateFacilityScanTypes?: Maybe<FacilityScanTypes>;
  /** Update many MultipleFacilityProductTypes. */
  updateMultipleFacilityProductTypes?: Maybe<Array<Maybe<FacilityProductTypes>>>;
  /** Update many MultipleFacilityScanTypes. */
  updateMultipleFacilityScanTypes?: Maybe<Array<Maybe<FacilityScanTypes>>>;
  /** Update many MultipleUserWithScanEvents. */
  updateMultipleUserWithScanEvents?: Maybe<Array<Maybe<UserWithScanEvents>>>;
  /** Update a single NewsFeed. */
  updateNewsFeed?: Maybe<NewsFeed>;
  /** Update many NewsFeeds. */
  updateNewsFeeds?: Maybe<Array<Maybe<NewsFeed>>>;
  /** Update a single PastWinner. */
  updatePastWinner?: Maybe<PastWinner>;
  /** Update many PastWinners. */
  updatePastWinners?: Maybe<Array<Maybe<PastWinner>>>;
  /** Update a single Postcode. */
  updatePostcode?: Maybe<Postcode>;
  /** Update many Postcodes. */
  updatePostcodes?: Maybe<Array<Maybe<Postcode>>>;
  /** Update a single Prize. */
  updatePrize?: Maybe<Prize>;
  /** Update many Prizes. */
  updatePrizes?: Maybe<Array<Maybe<Prize>>>;
  /** Update a single Role. */
  updateRole?: Maybe<Role>;
  /** Update many Roles. */
  updateRoles?: Maybe<Array<Maybe<Role>>>;
  /** Update a single ScanEvent. */
  updateScanEvent?: Maybe<ScanEvent>;
  /** Update a single ScanEventPhoto. */
  updateScanEventPhoto?: Maybe<ScanEventPhoto>;
  /** Update many ScanEventPhotos. */
  updateScanEventPhotos?: Maybe<Array<Maybe<ScanEventPhoto>>>;
  /** Update many ScanEvents. */
  updateScanEvents?: Maybe<Array<Maybe<ScanEvent>>>;
  /** Update a single Suburb. */
  updateSuburb?: Maybe<Suburb>;
  /** Update many Suburbs. */
  updateSuburbs?: Maybe<Array<Maybe<Suburb>>>;
  /** Update a single Tag. */
  updateTag?: Maybe<Tag>;
  /** Update many Tags. */
  updateTags?: Maybe<Array<Maybe<Tag>>>;
  /** Update a single TrackableAsset. */
  updateTrackableAsset?: Maybe<TrackableAsset>;
  /** Update many TrackableAssets. */
  updateTrackableAssets?: Maybe<Array<Maybe<TrackableAsset>>>;
  /** Update a single User. */
  updateUser?: Maybe<User>;
  /** Update a single UserAlert. */
  updateUserAlert?: Maybe<UserAlert>;
  /** Update many UserAlerts. */
  updateUserAlerts?: Maybe<Array<Maybe<UserAlert>>>;
  updateUserEmail?: Maybe<User>;
  /** Update a single UserPrizeEntryCount. */
  updateUserPrizeEntryCount?: Maybe<UserPrizeEntryCount>;
  /** Update many UserPrizeEntryCounts. */
  updateUserPrizeEntryCounts?: Maybe<Array<Maybe<UserPrizeEntryCount>>>;
  /** Update a single UserSubscription. */
  updateUserSubscription?: Maybe<UserSubscription>;
  /** Update many UserSubscriptions. */
  updateUserSubscriptions?: Maybe<Array<Maybe<UserSubscription>>>;
  /** Update a single UserWithScanEvents. */
  updateUserWithScanEvents?: Maybe<UserWithScanEvents>;
  /** Update many Users. */
  updateUsers?: Maybe<Array<Maybe<User>>>;
};


export type MutationChallengePasswordArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangePasswordArgs = {
  newPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationConfirmBagMaterialArgs = {
  input?: InputMaybe<UserScanMaterialConfirmInput>;
};


export type MutationCreateAccordionItemArgs = {
  input: AccordionItemInsertInput;
};


export type MutationCreateAccordionItemsArgs = {
  input: Array<AccordionItemInsertInput>;
};


export type MutationCreateAccountArgs = {
  input: AccountInsertInput;
};


export type MutationCreateAccountsArgs = {
  input: Array<AccountInsertInput>;
};


export type MutationCreateBatchCodeArgs = {
  input: BatchCodeInsertInput;
};


export type MutationCreateBatchCodesArgs = {
  input: Array<BatchCodeInsertInput>;
};


export type MutationCreateBlacklistArgs = {
  input: BlacklistInsertInput;
};


export type MutationCreateBlacklistsArgs = {
  input: Array<BlacklistInsertInput>;
};


export type MutationCreateCaseArgs = {
  input: CaseInsertInput;
};


export type MutationCreateCasesArgs = {
  input: Array<CaseInsertInput>;
};


export type MutationCreateContactArgs = {
  input: ContactInsertInput;
};


export type MutationCreateContactsArgs = {
  input: Array<ContactInsertInput>;
};


export type MutationCreateContentSectionArgs = {
  input: ContentSectionInsertInput;
};


export type MutationCreateContentSectionsArgs = {
  input: Array<ContentSectionInsertInput>;
};


export type MutationCreateCouncilArgs = {
  input: CouncilInsertInput;
};


export type MutationCreateCouncilsArgs = {
  input: Array<CouncilInsertInput>;
};


export type MutationCreateCredentialArgs = {
  input?: InputMaybe<CredentialInsertInput>;
};


export type MutationCreateDropOffLocationArgs = {
  input: DropOffLocationInsertInput;
};


export type MutationCreateDropOffLocationsArgs = {
  input: Array<DropOffLocationInsertInput>;
};


export type MutationCreateFacilitiesArgs = {
  input: Array<FacilityInsertInput>;
};


export type MutationCreateFacilityArgs = {
  input: FacilityInsertInput;
};


export type MutationCreateFacilityCustomerArgs = {
  input: FacilityCustomerInsertInput;
};


export type MutationCreateFacilityCustomersArgs = {
  input: Array<FacilityCustomerInsertInput>;
};


export type MutationCreateFacilityProductTypesArgs = {
  input: FacilityProductTypesInsertInput;
};


export type MutationCreateFacilityScanTypesArgs = {
  input: FacilityScanTypesInsertInput;
};


export type MutationCreateMultipleFacilityProductTypesArgs = {
  input: Array<FacilityProductTypesInsertInput>;
};


export type MutationCreateMultipleFacilityScanTypesArgs = {
  input: Array<FacilityScanTypesInsertInput>;
};


export type MutationCreateMultipleUserWithScanEventsArgs = {
  input: Array<UserWithScanEventsInsertInput>;
};


export type MutationCreateNewsFeedArgs = {
  input: NewsFeedInsertInput;
};


export type MutationCreateNewsFeedsArgs = {
  input: Array<NewsFeedInsertInput>;
};


export type MutationCreateOrUpdateAccordionItemsArgs = {
  input: Array<AccordionItemCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateAccountsArgs = {
  input: Array<AccountCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateBatchCodesArgs = {
  input: Array<BatchCodeCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateBlacklistsArgs = {
  input: Array<BlacklistCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateCasesArgs = {
  input: Array<CaseCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateContactsArgs = {
  input: Array<ContactCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateContentSectionsArgs = {
  input: Array<ContentSectionCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateCouncilsArgs = {
  input: Array<CouncilCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateDropOffLocationsArgs = {
  input: Array<DropOffLocationCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateFacilitiesArgs = {
  input: Array<FacilityCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateFacilityCustomersArgs = {
  input: Array<FacilityCustomerCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateMultipleFacilityProductTypesArgs = {
  input: Array<FacilityProductTypesCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateMultipleFacilityScanTypesArgs = {
  input: Array<FacilityScanTypesCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateMultipleUserWithScanEventsArgs = {
  input: Array<UserWithScanEventsCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateNewsFeedsArgs = {
  input: Array<NewsFeedCreateOrUpdateInput>;
};


export type MutationCreateOrUpdatePastWinnersArgs = {
  input: Array<PastWinnerCreateOrUpdateInput>;
};


export type MutationCreateOrUpdatePostcodesArgs = {
  input: Array<PostcodeCreateOrUpdateInput>;
};


export type MutationCreateOrUpdatePrizesArgs = {
  input: Array<PrizeCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateRolesArgs = {
  input: Array<RoleCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateScanEventPhotosArgs = {
  input: Array<ScanEventPhotoCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateScanEventsArgs = {
  input: Array<ScanEventCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateSuburbsArgs = {
  input: Array<SuburbCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateTagsArgs = {
  input: Array<TagCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateTrackableAssetsArgs = {
  input: Array<TrackableAssetCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateUserAlertsArgs = {
  input: Array<UserAlertCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateUserPrizeEntryCountsArgs = {
  input: Array<UserPrizeEntryCountCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateUserSubscriptionsArgs = {
  input: Array<UserSubscriptionCreateOrUpdateInput>;
};


export type MutationCreateOrUpdateUsersArgs = {
  input: Array<UserCreateOrUpdateInput>;
};


export type MutationCreatePastWinnerArgs = {
  input: PastWinnerInsertInput;
};


export type MutationCreatePastWinnersArgs = {
  input: Array<PastWinnerInsertInput>;
};


export type MutationCreatePostcodeArgs = {
  input: PostcodeInsertInput;
};


export type MutationCreatePostcodesArgs = {
  input: Array<PostcodeInsertInput>;
};


export type MutationCreatePrizeArgs = {
  input: PrizeInsertInput;
};


export type MutationCreatePrizesArgs = {
  input: Array<PrizeInsertInput>;
};


export type MutationCreateRoleArgs = {
  input: RoleInsertInput;
};


export type MutationCreateRolesArgs = {
  input: Array<RoleInsertInput>;
};


export type MutationCreateSalesforceCaseArgs = {
  input?: InputMaybe<CreateSalesforceCaseInput>;
};


export type MutationCreateScanEventArgs = {
  input: ScanEventInsertInput;
};


export type MutationCreateScanEventPhotoArgs = {
  input: ScanEventPhotoInsertInput;
};


export type MutationCreateScanEventPhotosArgs = {
  input: Array<ScanEventPhotoInsertInput>;
};


export type MutationCreateScanEventsArgs = {
  input: Array<ScanEventInsertInput>;
};


export type MutationCreateSessionForOneOffPaymentArgs = {
  lineItems?: InputMaybe<Array<InputMaybe<StripeSessionLineItemInput>>>;
};


export type MutationCreateSessionForSubscriptionPaymentArgs = {
  lineItem?: InputMaybe<StripeSessionLineItemInput>;
};


export type MutationCreateSuburbArgs = {
  input: SuburbInsertInput;
};


export type MutationCreateSuburbsArgs = {
  input: Array<SuburbInsertInput>;
};


export type MutationCreateTagArgs = {
  input: TagInsertInput;
};


export type MutationCreateTagsArgs = {
  input: Array<TagInsertInput>;
};


export type MutationCreateTrackableAssetArgs = {
  input: TrackableAssetInsertInput;
};


export type MutationCreateTrackableAssetsArgs = {
  input: Array<TrackableAssetInsertInput>;
};


export type MutationCreateUserArgs = {
  input: UserInsertInput;
};


export type MutationCreateUserAlertArgs = {
  input: UserAlertInsertInput;
};


export type MutationCreateUserAlertsArgs = {
  input: Array<UserAlertInsertInput>;
};


export type MutationCreateUserPrizeEntryCountArgs = {
  input: UserPrizeEntryCountInsertInput;
};


export type MutationCreateUserPrizeEntryCountsArgs = {
  input: Array<UserPrizeEntryCountInsertInput>;
};


export type MutationCreateUserSubscriptionArgs = {
  input: UserSubscriptionInsertInput;
};


export type MutationCreateUserSubscriptionsArgs = {
  input: Array<UserSubscriptionInsertInput>;
};


export type MutationCreateUserWithScanEventsArgs = {
  input: UserWithScanEventsInsertInput;
};


export type MutationCreateUsersArgs = {
  input: Array<UserInsertInput>;
};


export type MutationCustomCreateUserArgs = {
  input?: InputMaybe<CustomCreateUserInput>;
};


export type MutationCustomUpdateScanEventArgs = {
  input?: InputMaybe<UpdateScanEventInput>;
};


export type MutationDeleteAccordionItemArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteAccordionItemsArgs = {
  filter: AccordionItemsListFilter;
};


export type MutationDeleteAccountArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteAccountsArgs = {
  filter: AccountsListFilter;
};


export type MutationDeleteBatchCodeArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteBatchCodesArgs = {
  filter: BatchCodesListFilter;
};


export type MutationDeleteBlacklistArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteBlacklistsArgs = {
  filter: BlacklistsListFilter;
};


export type MutationDeleteCaseArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteCasesArgs = {
  filter: CasesListFilter;
};


export type MutationDeleteContactArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteContactsArgs = {
  filter: ContactsListFilter;
};


export type MutationDeleteContentSectionArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteContentSectionsArgs = {
  filter: ContentSectionsListFilter;
};


export type MutationDeleteCouncilArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteCouncilsArgs = {
  filter: CouncilsListFilter;
};


export type MutationDeleteCurrentUserArgs = {
  input?: InputMaybe<DeleteCurrentUserInput>;
};


export type MutationDeleteDropOffLocationArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteDropOffLocationsArgs = {
  filter: DropOffLocationsListFilter;
};


export type MutationDeleteFacilitiesArgs = {
  filter: FacilitiesListFilter;
};


export type MutationDeleteFacilityArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteFacilityCustomerArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteFacilityCustomersArgs = {
  filter: FacilityCustomersListFilter;
};


export type MutationDeleteFacilityProductTypesArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteFacilityScanTypesArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteMultipleFacilityProductTypesArgs = {
  filter: MultipleFacilityProductTypesListFilter;
};


export type MutationDeleteMultipleFacilityScanTypesArgs = {
  filter: MultipleFacilityScanTypesListFilter;
};


export type MutationDeleteMultipleUserWithScanEventsArgs = {
  filter: MultipleUserWithScanEventsListFilter;
};


export type MutationDeleteNewsFeedArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteNewsFeedsArgs = {
  filter: NewsFeedsListFilter;
};


export type MutationDeletePastWinnerArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeletePastWinnersArgs = {
  filter: PastWinnersListFilter;
};


export type MutationDeletePostcodeArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeletePostcodesArgs = {
  filter: PostcodesListFilter;
};


export type MutationDeletePrizeArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeletePrizesArgs = {
  filter: PrizesListFilter;
};


export type MutationDeleteRoleArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteRolesArgs = {
  filter: RolesListFilter;
};


export type MutationDeleteScanEventArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteScanEventPhotoArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteScanEventPhotosArgs = {
  filter: ScanEventPhotosListFilter;
};


export type MutationDeleteScanEventsArgs = {
  filter: ScanEventsListFilter;
};


export type MutationDeleteSuburbArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteSuburbsArgs = {
  filter: SuburbsListFilter;
};


export type MutationDeleteTagArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteTagsArgs = {
  filter: TagsListFilter;
};


export type MutationDeleteTrackableAssetArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteTrackableAssetsArgs = {
  filter: TrackableAssetsListFilter;
};


export type MutationDeleteUserArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteUserAlertArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteUserAlertsArgs = {
  filter: UserAlertsListFilter;
};


export type MutationDeleteUserPrizeEntryCountArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteUserPrizeEntryCountsArgs = {
  filter: UserPrizeEntryCountsListFilter;
};


export type MutationDeleteUserSubscriptionArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteUserSubscriptionsArgs = {
  filter: UserSubscriptionsListFilter;
};


export type MutationDeleteUserWithScanEventsArgs = {
  filter: DeleteOneFilterInput;
};


export type MutationDeleteUsersArgs = {
  filter: UsersListFilter;
};


export type MutationFacilityBagAuditArgs = {
  input?: InputMaybe<FacilityBagAuditInput>;
};


export type MutationFacilityBagScanArgs = {
  input?: InputMaybe<FacilityBagScanInput>;
};


export type MutationFacilityBaleCreateArgs = {
  input?: InputMaybe<FacilityBaleCreateInput>;
};


export type MutationFacilityBaleInboundArgs = {
  input?: InputMaybe<FacilityBaleInboundInput>;
};


export type MutationFacilityBaleOutboundArgs = {
  input?: InputMaybe<FacilityBaleOutboundInput>;
};


export type MutationFacilityBaleProcessedArgs = {
  input?: InputMaybe<FacilityBaleProcessedInput>;
};


export type MutationFinaliseSubscriptionArgs = {
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateBatchCodesArgs = {
  input?: InputMaybe<GenerateBatchCodesInput>;
};


export type MutationGetDeleteUrlArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetUploadUrlArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLoginPasswordArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPasswordArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationScanAssetFromUserArgs = {
  input?: InputMaybe<ScanEventFromUserInput>;
};


export type MutationSendResetPasswordLinkArgs = {
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTagBatchCodeArgs = {
  batchCodeId?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUntagBatchCodeArgs = {
  batchCodeId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAccordionItemArgs = {
  input: AccordionItemUpdateInput;
};


export type MutationUpdateAccordionItemsArgs = {
  input: Array<AccordionItemUpdateInput>;
};


export type MutationUpdateAccountArgs = {
  input: AccountUpdateInput;
};


export type MutationUpdateAccountsArgs = {
  input: Array<AccountUpdateInput>;
};


export type MutationUpdateBatchCodeArgs = {
  input: BatchCodeUpdateInput;
};


export type MutationUpdateBatchCodesArgs = {
  input: Array<BatchCodeUpdateInput>;
};


export type MutationUpdateBlacklistArgs = {
  input: BlacklistUpdateInput;
};


export type MutationUpdateBlacklistsArgs = {
  input: Array<BlacklistUpdateInput>;
};


export type MutationUpdateCaseArgs = {
  input: CaseUpdateInput;
};


export type MutationUpdateCasesArgs = {
  input: Array<CaseUpdateInput>;
};


export type MutationUpdateContactArgs = {
  input: ContactUpdateInput;
};


export type MutationUpdateContactsArgs = {
  input: Array<ContactUpdateInput>;
};


export type MutationUpdateContentSectionArgs = {
  input: ContentSectionUpdateInput;
};


export type MutationUpdateContentSectionsArgs = {
  input: Array<ContentSectionUpdateInput>;
};


export type MutationUpdateCouncilArgs = {
  input: CouncilUpdateInput;
};


export type MutationUpdateCouncilsArgs = {
  input: Array<CouncilUpdateInput>;
};


export type MutationUpdateCredentialArgs = {
  input?: InputMaybe<CredentialUpdateInput>;
};


export type MutationUpdateCurrentUserArgs = {
  input?: InputMaybe<UserInput>;
};


export type MutationUpdateDropOffLocationArgs = {
  input: DropOffLocationUpdateInput;
};


export type MutationUpdateDropOffLocationsArgs = {
  input: Array<DropOffLocationUpdateInput>;
};


export type MutationUpdateFacilitiesArgs = {
  input: Array<FacilityUpdateInput>;
};


export type MutationUpdateFacilityArgs = {
  input: FacilityUpdateInput;
};


export type MutationUpdateFacilityCustomerArgs = {
  input: FacilityCustomerUpdateInput;
};


export type MutationUpdateFacilityCustomersArgs = {
  input: Array<FacilityCustomerUpdateInput>;
};


export type MutationUpdateFacilityProductTypesArgs = {
  input: FacilityProductTypesUpdateInput;
};


export type MutationUpdateFacilityScanTypesArgs = {
  input: FacilityScanTypesUpdateInput;
};


export type MutationUpdateMultipleFacilityProductTypesArgs = {
  input: Array<FacilityProductTypesUpdateInput>;
};


export type MutationUpdateMultipleFacilityScanTypesArgs = {
  input: Array<FacilityScanTypesUpdateInput>;
};


export type MutationUpdateMultipleUserWithScanEventsArgs = {
  input: Array<UserWithScanEventsUpdateInput>;
};


export type MutationUpdateNewsFeedArgs = {
  input: NewsFeedUpdateInput;
};


export type MutationUpdateNewsFeedsArgs = {
  input: Array<NewsFeedUpdateInput>;
};


export type MutationUpdatePastWinnerArgs = {
  input: PastWinnerUpdateInput;
};


export type MutationUpdatePastWinnersArgs = {
  input: Array<PastWinnerUpdateInput>;
};


export type MutationUpdatePostcodeArgs = {
  input: PostcodeUpdateInput;
};


export type MutationUpdatePostcodesArgs = {
  input: Array<PostcodeUpdateInput>;
};


export type MutationUpdatePrizeArgs = {
  input: PrizeUpdateInput;
};


export type MutationUpdatePrizesArgs = {
  input: Array<PrizeUpdateInput>;
};


export type MutationUpdateRoleArgs = {
  input: RoleUpdateInput;
};


export type MutationUpdateRolesArgs = {
  input: Array<RoleUpdateInput>;
};


export type MutationUpdateScanEventArgs = {
  input: ScanEventUpdateInput;
};


export type MutationUpdateScanEventPhotoArgs = {
  input: ScanEventPhotoUpdateInput;
};


export type MutationUpdateScanEventPhotosArgs = {
  input: Array<ScanEventPhotoUpdateInput>;
};


export type MutationUpdateScanEventsArgs = {
  input: Array<ScanEventUpdateInput>;
};


export type MutationUpdateSuburbArgs = {
  input: SuburbUpdateInput;
};


export type MutationUpdateSuburbsArgs = {
  input: Array<SuburbUpdateInput>;
};


export type MutationUpdateTagArgs = {
  input: TagUpdateInput;
};


export type MutationUpdateTagsArgs = {
  input: Array<TagUpdateInput>;
};


export type MutationUpdateTrackableAssetArgs = {
  input: TrackableAssetUpdateInput;
};


export type MutationUpdateTrackableAssetsArgs = {
  input: Array<TrackableAssetUpdateInput>;
};


export type MutationUpdateUserArgs = {
  input: UserUpdateInput;
};


export type MutationUpdateUserAlertArgs = {
  input: UserAlertUpdateInput;
};


export type MutationUpdateUserAlertsArgs = {
  input: Array<UserAlertUpdateInput>;
};


export type MutationUpdateUserEmailArgs = {
  input?: InputMaybe<UpdateUserEmailInput>;
};


export type MutationUpdateUserPrizeEntryCountArgs = {
  input: UserPrizeEntryCountUpdateInput;
};


export type MutationUpdateUserPrizeEntryCountsArgs = {
  input: Array<UserPrizeEntryCountUpdateInput>;
};


export type MutationUpdateUserSubscriptionArgs = {
  input: UserSubscriptionUpdateInput;
};


export type MutationUpdateUserSubscriptionsArgs = {
  input: Array<UserSubscriptionUpdateInput>;
};


export type MutationUpdateUserWithScanEventsArgs = {
  input: UserWithScanEventsUpdateInput;
};


export type MutationUpdateUsersArgs = {
  input: Array<UserUpdateInput>;
};

export type NewsFeed = {
  __typename?: 'NewsFeed';
  createdAt?: Maybe<Scalars['ISOString']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Data needed to create or update NewsFeeds. If an ID is passed, this is an update, otherwise it's an insert. */
export type NewsFeedCreateOrUpdateInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create NewsFeeds. */
export type NewsFeedInsertInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  description: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Data needed to update NewsFeeds. An ID must be passed. */
export type NewsFeedUpdateInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NewsFeedsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<NewsFeedsListFilter>>>;
  _not?: InputMaybe<NewsFeedsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<NewsFeedsListFilter>>>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_ilike?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_like?: InputMaybe<Scalars['String']['input']>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  description_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  description_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl_gt?: InputMaybe<Scalars['String']['input']>;
  imageUrl_gte?: InputMaybe<Scalars['String']['input']>;
  imageUrl_ilike?: InputMaybe<Scalars['String']['input']>;
  imageUrl_in?: InputMaybe<Array<Scalars['String']['input']>>;
  imageUrl_like?: InputMaybe<Scalars['String']['input']>;
  imageUrl_lt?: InputMaybe<Scalars['String']['input']>;
  imageUrl_lte?: InputMaybe<Scalars['String']['input']>;
  imageUrl_ne?: InputMaybe<Scalars['String']['input']>;
  imageUrl_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  imageUrl_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl_null?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl_gt?: InputMaybe<Scalars['String']['input']>;
  linkUrl_gte?: InputMaybe<Scalars['String']['input']>;
  linkUrl_ilike?: InputMaybe<Scalars['String']['input']>;
  linkUrl_in?: InputMaybe<Array<Scalars['String']['input']>>;
  linkUrl_like?: InputMaybe<Scalars['String']['input']>;
  linkUrl_lt?: InputMaybe<Scalars['String']['input']>;
  linkUrl_lte?: InputMaybe<Scalars['String']['input']>;
  linkUrl_ne?: InputMaybe<Scalars['String']['input']>;
  linkUrl_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  linkUrl_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl_null?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_ilike?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_like?: InputMaybe<Scalars['String']['input']>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_ne?: InputMaybe<Scalars['String']['input']>;
  title_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  title_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  title_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewsFeedsOrderByInput = {
  createdAt?: InputMaybe<Sort>;
  description?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  imageUrl?: InputMaybe<Sort>;
  linkUrl?: InputMaybe<Sort>;
  title?: InputMaybe<Sort>;
};

/** Pagination options for NewsFeeds. */
export type NewsFeedsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NewsFeedsOrderByInput>;
};

export type PasskeyAuthenticationResponse = {
  authenticatorAttachment?: InputMaybe<Scalars['String']['input']>;
  clientExtensionResults: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
  rawId: Scalars['String']['input'];
  response: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};

export type PasskeyRegistrationResponse = {
  authenticatorAttachment?: InputMaybe<Scalars['String']['input']>;
  clientExtensionResults: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
  rawId: Scalars['String']['input'];
  response: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};

export type PastWinner = {
  __typename?: 'PastWinner';
  content?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  prize?: Maybe<Scalars['String']['output']>;
};

/** Data needed to create or update PastWinners. If an ID is passed, this is an update, otherwise it's an insert. */
export type PastWinnerCreateOrUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  prize?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create PastWinners. */
export type PastWinnerInsertInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  prize?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to update PastWinners. An ID must be passed. */
export type PastWinnerUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  prize?: InputMaybe<Scalars['String']['input']>;
};

export type PastWinnersListFilter = {
  _and?: InputMaybe<Array<InputMaybe<PastWinnersListFilter>>>;
  _not?: InputMaybe<PastWinnersListFilter>;
  _or?: InputMaybe<Array<InputMaybe<PastWinnersListFilter>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_gt?: InputMaybe<Scalars['String']['input']>;
  content_gte?: InputMaybe<Scalars['String']['input']>;
  content_ilike?: InputMaybe<Scalars['String']['input']>;
  content_in?: InputMaybe<Array<Scalars['String']['input']>>;
  content_like?: InputMaybe<Scalars['String']['input']>;
  content_lt?: InputMaybe<Scalars['String']['input']>;
  content_lte?: InputMaybe<Scalars['String']['input']>;
  content_ne?: InputMaybe<Scalars['String']['input']>;
  content_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  content_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  content_null?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  heading_gt?: InputMaybe<Scalars['String']['input']>;
  heading_gte?: InputMaybe<Scalars['String']['input']>;
  heading_ilike?: InputMaybe<Scalars['String']['input']>;
  heading_in?: InputMaybe<Array<Scalars['String']['input']>>;
  heading_like?: InputMaybe<Scalars['String']['input']>;
  heading_lt?: InputMaybe<Scalars['String']['input']>;
  heading_lte?: InputMaybe<Scalars['String']['input']>;
  heading_ne?: InputMaybe<Scalars['String']['input']>;
  heading_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  heading_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  heading_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_ilike?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_like?: InputMaybe<Scalars['String']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  name_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  name_null?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_gt?: InputMaybe<Scalars['String']['input']>;
  postcode_gte?: InputMaybe<Scalars['String']['input']>;
  postcode_ilike?: InputMaybe<Scalars['String']['input']>;
  postcode_in?: InputMaybe<Array<Scalars['String']['input']>>;
  postcode_like?: InputMaybe<Scalars['String']['input']>;
  postcode_lt?: InputMaybe<Scalars['String']['input']>;
  postcode_lte?: InputMaybe<Scalars['String']['input']>;
  postcode_ne?: InputMaybe<Scalars['String']['input']>;
  postcode_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  postcode_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  postcode_null?: InputMaybe<Scalars['Boolean']['input']>;
  prize?: InputMaybe<Scalars['String']['input']>;
  prize_gt?: InputMaybe<Scalars['String']['input']>;
  prize_gte?: InputMaybe<Scalars['String']['input']>;
  prize_ilike?: InputMaybe<Scalars['String']['input']>;
  prize_in?: InputMaybe<Array<Scalars['String']['input']>>;
  prize_like?: InputMaybe<Scalars['String']['input']>;
  prize_lt?: InputMaybe<Scalars['String']['input']>;
  prize_lte?: InputMaybe<Scalars['String']['input']>;
  prize_ne?: InputMaybe<Scalars['String']['input']>;
  prize_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  prize_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  prize_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PastWinnersOrderByInput = {
  content?: InputMaybe<Sort>;
  heading?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  postcode?: InputMaybe<Sort>;
  prize?: InputMaybe<Sort>;
};

/** Pagination options for PastWinners. */
export type PastWinnersPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PastWinnersOrderByInput>;
};

export type Postcode = {
  __typename?: 'Postcode';
  councils?: Maybe<Array<Council>>;
  councils_aggregate?: Maybe<AggregationResult>;
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  postcode: Scalars['String']['output'];
};


export type PostcodeCouncilsArgs = {
  filter?: InputMaybe<CouncilsListFilter>;
};


export type PostcodeCouncils_AggregateArgs = {
  filter?: InputMaybe<CouncilsListFilter>;
};

/** Data needed to create or update Postcodes. If an ID is passed, this is an update, otherwise it's an insert. */
export type PostcodeCreateOrUpdateInput = {
  councils?: InputMaybe<Array<CouncilCreateOrUpdateInput>>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create Postcodes. */
export type PostcodeInsertInput = {
  councils?: InputMaybe<Array<CouncilCreateOrUpdateInput>>;
  country: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
};

/** Data needed to update Postcodes. An ID must be passed. */
export type PostcodeUpdateInput = {
  councils?: InputMaybe<Array<CouncilCreateOrUpdateInput>>;
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
};

export type PostcodesListFilter = {
  _and?: InputMaybe<Array<InputMaybe<PostcodesListFilter>>>;
  _not?: InputMaybe<PostcodesListFilter>;
  _or?: InputMaybe<Array<InputMaybe<PostcodesListFilter>>>;
  councils?: InputMaybe<CouncilsListFilter>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_gt?: InputMaybe<Scalars['String']['input']>;
  country_gte?: InputMaybe<Scalars['String']['input']>;
  country_ilike?: InputMaybe<Scalars['String']['input']>;
  country_in?: InputMaybe<Array<Scalars['String']['input']>>;
  country_like?: InputMaybe<Scalars['String']['input']>;
  country_lt?: InputMaybe<Scalars['String']['input']>;
  country_lte?: InputMaybe<Scalars['String']['input']>;
  country_ne?: InputMaybe<Scalars['String']['input']>;
  country_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  country_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  country_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_gt?: InputMaybe<Scalars['String']['input']>;
  postcode_gte?: InputMaybe<Scalars['String']['input']>;
  postcode_ilike?: InputMaybe<Scalars['String']['input']>;
  postcode_in?: InputMaybe<Array<Scalars['String']['input']>>;
  postcode_like?: InputMaybe<Scalars['String']['input']>;
  postcode_lt?: InputMaybe<Scalars['String']['input']>;
  postcode_lte?: InputMaybe<Scalars['String']['input']>;
  postcode_ne?: InputMaybe<Scalars['String']['input']>;
  postcode_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  postcode_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  postcode_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostcodesOrderByInput = {
  country?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  postcode?: InputMaybe<Sort>;
};

/** Pagination options for Postcodes. */
export type PostcodesPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PostcodesOrderByInput>;
};

export type Prize = {
  __typename?: 'Prize';
  createdAt?: Maybe<Scalars['ISOString']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  seen?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  user?: Maybe<User>;
  user_aggregate?: Maybe<AggregationResult>;
};


export type PrizeUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type PrizeUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};

/** Data needed to create or update Prizes. If an ID is passed, this is an update, otherwise it's an insert. */
export type PrizeCreateOrUpdateInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserCreateOrUpdateInput>;
};

/** Data needed to create Prizes. */
export type PrizeInsertInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  user?: InputMaybe<UserCreateOrUpdateInput>;
};

/** Data needed to update Prizes. An ID must be passed. */
export type PrizeUpdateInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserCreateOrUpdateInput>;
};

export type PrizesListFilter = {
  _and?: InputMaybe<Array<InputMaybe<PrizesListFilter>>>;
  _not?: InputMaybe<PrizesListFilter>;
  _or?: InputMaybe<Array<InputMaybe<PrizesListFilter>>>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  hidden_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  hidden_ne?: InputMaybe<Scalars['Boolean']['input']>;
  hidden_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  hidden_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  hidden_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  seen_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  seen_ne?: InputMaybe<Scalars['Boolean']['input']>;
  seen_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  seen_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  seen_null?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_ilike?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_like?: InputMaybe<Scalars['String']['input']>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_ne?: InputMaybe<Scalars['String']['input']>;
  title_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  title_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  title_null?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<UsersListFilter>;
};

export type PrizesOrderByInput = {
  createdAt?: InputMaybe<Sort>;
  hidden?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  seen?: InputMaybe<Sort>;
  title?: InputMaybe<Sort>;
};

/** Pagination options for Prizes. */
export type PrizesPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PrizesOrderByInput>;
};

export type Query = {
  __typename?: 'Query';
  /** Query used by the Admin UI to introspect the schema and metadata. */
  _graphweaver?: Maybe<AdminUiMetadata>;
  /** Get a single AccordionItem. */
  accordionItem?: Maybe<AccordionItem>;
  /** Get multiple AccordionItems. */
  accordionItems?: Maybe<Array<Maybe<AccordionItem>>>;
  /** Get aggregated data for AccordionItems. */
  accordionItems_aggregate?: Maybe<AggregationResult>;
  /** Get a single Account. */
  account?: Maybe<Account>;
  /** Get multiple Accounts. */
  accounts?: Maybe<Array<Maybe<Account>>>;
  /** Get aggregated data for Accounts. */
  accounts_aggregate?: Maybe<AggregationResult>;
  /** Get a single BatchCode. */
  batchCode?: Maybe<BatchCode>;
  /** Get multiple BatchCodes. */
  batchCodes?: Maybe<Array<Maybe<BatchCode>>>;
  /** Get aggregated data for BatchCodes. */
  batchCodes_aggregate?: Maybe<AggregationResult>;
  /** Get a single Blacklist. */
  blacklist?: Maybe<Blacklist>;
  /** Get multiple Blacklists. */
  blacklists?: Maybe<Array<Maybe<Blacklist>>>;
  /** Get aggregated data for Blacklists. */
  blacklists_aggregate?: Maybe<AggregationResult>;
  /** Get a single Case. */
  case?: Maybe<Case>;
  /** Get multiple Cases. */
  cases?: Maybe<Array<Maybe<Case>>>;
  /** Get aggregated data for Cases. */
  cases_aggregate?: Maybe<AggregationResult>;
  checkPrizeStatus?: Maybe<Array<Maybe<Prize>>>;
  /** Get a single Contact. */
  contact?: Maybe<Contact>;
  /** Get multiple Contacts. */
  contacts?: Maybe<Array<Maybe<Contact>>>;
  /** Get aggregated data for Contacts. */
  contacts_aggregate?: Maybe<AggregationResult>;
  /** Get a single ContentSection. */
  contentSection?: Maybe<ContentSection>;
  /** Get multiple ContentSections. */
  contentSections?: Maybe<Array<Maybe<ContentSection>>>;
  /** Get aggregated data for ContentSections. */
  contentSections_aggregate?: Maybe<AggregationResult>;
  /** Get a single Council. */
  council?: Maybe<Council>;
  /** Get multiple Councils. */
  councils?: Maybe<Array<Maybe<Council>>>;
  /** Get aggregated data for Councils. */
  councils_aggregate?: Maybe<AggregationResult>;
  /** Get a single Credential. */
  credential?: Maybe<Credential>;
  /** Get multiple Credentials. */
  credentials?: Maybe<Array<Maybe<Credential>>>;
  /** Get aggregated data for Credentials. */
  credentials_aggregate?: Maybe<AggregationResult>;
  currentUser?: Maybe<User>;
  /** Get a single DropOffLocation. */
  dropOffLocation?: Maybe<DropOffLocation>;
  /** Get multiple DropOffLocations. */
  dropOffLocations?: Maybe<Array<Maybe<DropOffLocation>>>;
  /** Get aggregated data for DropOffLocations. */
  dropOffLocations_aggregate?: Maybe<AggregationResult>;
  /** Get multiple Facilities. */
  facilities?: Maybe<Array<Maybe<Facility>>>;
  /** Get aggregated data for Facilities. */
  facilities_aggregate?: Maybe<AggregationResult>;
  /** Get a single Facility. */
  facility?: Maybe<Facility>;
  /** Get a single FacilityCustomer. */
  facilityCustomer?: Maybe<FacilityCustomer>;
  /** Get multiple FacilityCustomers. */
  facilityCustomers?: Maybe<Array<Maybe<FacilityCustomer>>>;
  /** Get aggregated data for FacilityCustomers. */
  facilityCustomers_aggregate?: Maybe<AggregationResult>;
  /** Get a single FacilityProductTypes. */
  facilityProductTypes?: Maybe<FacilityProductTypes>;
  /** Get a single FacilityScanTypes. */
  facilityScanTypes?: Maybe<FacilityScanTypes>;
  getCouncilStats?: Maybe<CouncilStats>;
  getDownloadUrl?: Maybe<Scalars['String']['output']>;
  getDropOffLocations?: Maybe<Array<Maybe<DropOffLocation>>>;
  getScanStats?: Maybe<ScanStats>;
  getSectionContent?: Maybe<Array<Maybe<ContentSection>>>;
  /** Get multiple MultipleFacilityProductTypes. */
  multipleFacilityProductTypes?: Maybe<Array<Maybe<FacilityProductTypes>>>;
  /** Get aggregated data for MultipleFacilityProductTypes. */
  multipleFacilityProductTypes_aggregate?: Maybe<AggregationResult>;
  /** Get multiple MultipleFacilityScanTypes. */
  multipleFacilityScanTypes?: Maybe<Array<Maybe<FacilityScanTypes>>>;
  /** Get aggregated data for MultipleFacilityScanTypes. */
  multipleFacilityScanTypes_aggregate?: Maybe<AggregationResult>;
  /** Get multiple MultipleScanEventChanges. */
  multipleScanEventChanges?: Maybe<Array<Maybe<ScanEventChanges>>>;
  /** Get aggregated data for MultipleScanEventChanges. */
  multipleScanEventChanges_aggregate?: Maybe<AggregationResult>;
  /** Get multiple MultipleUserWithScanEvents. */
  multipleUserWithScanEvents?: Maybe<Array<Maybe<UserWithScanEvents>>>;
  /** Get aggregated data for MultipleUserWithScanEvents. */
  multipleUserWithScanEvents_aggregate?: Maybe<AggregationResult>;
  /** Get a single NewsFeed. */
  newsFeed?: Maybe<NewsFeed>;
  /** Get multiple NewsFeeds. */
  newsFeeds?: Maybe<Array<Maybe<NewsFeed>>>;
  /** Get aggregated data for NewsFeeds. */
  newsFeeds_aggregate?: Maybe<AggregationResult>;
  /** Get a single PastWinner. */
  pastWinner?: Maybe<PastWinner>;
  /** Get multiple PastWinners. */
  pastWinners?: Maybe<Array<Maybe<PastWinner>>>;
  /** Get aggregated data for PastWinners. */
  pastWinners_aggregate?: Maybe<AggregationResult>;
  /** Get a single Postcode. */
  postcode?: Maybe<Postcode>;
  /** Get multiple Postcodes. */
  postcodes?: Maybe<Array<Maybe<Postcode>>>;
  /** Get aggregated data for Postcodes. */
  postcodes_aggregate?: Maybe<AggregationResult>;
  /** Get a single Prize. */
  prize?: Maybe<Prize>;
  /** Get multiple Prizes. */
  prizes?: Maybe<Array<Maybe<Prize>>>;
  /** Get aggregated data for Prizes. */
  prizes_aggregate?: Maybe<AggregationResult>;
  /** Get a single Role. */
  role?: Maybe<Role>;
  /** Get multiple Roles. */
  roles?: Maybe<Array<Maybe<Role>>>;
  /** Get aggregated data for Roles. */
  roles_aggregate?: Maybe<AggregationResult>;
  /** Get a single ScanEvent. */
  scanEvent?: Maybe<ScanEvent>;
  /** Get a single ScanEventChanges. */
  scanEventChanges?: Maybe<ScanEventChanges>;
  /** Get a single ScanEventPhoto. */
  scanEventPhoto?: Maybe<ScanEventPhoto>;
  /** Get multiple ScanEventPhotos. */
  scanEventPhotos?: Maybe<Array<Maybe<ScanEventPhoto>>>;
  /** Get aggregated data for ScanEventPhotos. */
  scanEventPhotos_aggregate?: Maybe<AggregationResult>;
  /** Get a single ScanEventWithTag. */
  scanEventWithTag?: Maybe<ScanEventWithTag>;
  /** Get multiple ScanEventWithTags. */
  scanEventWithTags?: Maybe<Array<Maybe<ScanEventWithTag>>>;
  /** Get aggregated data for ScanEventWithTags. */
  scanEventWithTags_aggregate?: Maybe<AggregationResult>;
  /** Get multiple ScanEvents. */
  scanEvents?: Maybe<Array<Maybe<ScanEvent>>>;
  /** Get aggregated data for ScanEvents. */
  scanEvents_aggregate?: Maybe<AggregationResult>;
  stripeOneTimeProducts?: Maybe<Array<Maybe<StripeProduct>>>;
  stripeProduct?: Maybe<StripeProduct>;
  stripePublishableKey?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionProducts?: Maybe<Array<Maybe<StripeProduct>>>;
  /** Get a single Suburb. */
  suburb?: Maybe<Suburb>;
  /** Get multiple Suburbs. */
  suburbs?: Maybe<Array<Maybe<Suburb>>>;
  /** Get aggregated data for Suburbs. */
  suburbs_aggregate?: Maybe<AggregationResult>;
  /** Get a single Tag. */
  tag?: Maybe<Tag>;
  /** Get a single TaggedBatchCode. */
  taggedBatchCode?: Maybe<TaggedBatchCode>;
  /** Get multiple TaggedBatchCodes. */
  taggedBatchCodes?: Maybe<Array<Maybe<TaggedBatchCode>>>;
  /** Get aggregated data for TaggedBatchCodes. */
  taggedBatchCodes_aggregate?: Maybe<AggregationResult>;
  /** Get multiple Tags. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Get aggregated data for Tags. */
  tags_aggregate?: Maybe<AggregationResult>;
  /** Get a single TrackableAsset. */
  trackableAsset?: Maybe<TrackableAsset>;
  /** Get multiple TrackableAssets. */
  trackableAssets?: Maybe<Array<Maybe<TrackableAsset>>>;
  /** Get aggregated data for TrackableAssets. */
  trackableAssets_aggregate?: Maybe<AggregationResult>;
  /** Get a single User. */
  user?: Maybe<User>;
  /** Get a single UserAlert. */
  userAlert?: Maybe<UserAlert>;
  /** Get multiple UserAlerts. */
  userAlerts?: Maybe<Array<Maybe<UserAlert>>>;
  /** Get aggregated data for UserAlerts. */
  userAlerts_aggregate?: Maybe<AggregationResult>;
  /** Get a single UserPrizeEntryCount. */
  userPrizeEntryCount?: Maybe<UserPrizeEntryCount>;
  /** Get multiple UserPrizeEntryCounts. */
  userPrizeEntryCounts?: Maybe<Array<Maybe<UserPrizeEntryCount>>>;
  /** Get aggregated data for UserPrizeEntryCounts. */
  userPrizeEntryCounts_aggregate?: Maybe<AggregationResult>;
  /** Get a single UserSubscription. */
  userSubscription?: Maybe<UserSubscription>;
  /** Gets the currently signed-in user active subscription charges. */
  userSubscriptionCharges?: Maybe<Array<Maybe<StripeCharge>>>;
  /** Gets the currently signed-in user active subscription. */
  userSubscriptionProduct?: Maybe<StripeProduct>;
  /** Get multiple UserSubscriptions. */
  userSubscriptions?: Maybe<Array<Maybe<UserSubscription>>>;
  /** Get aggregated data for UserSubscriptions. */
  userSubscriptions_aggregate?: Maybe<AggregationResult>;
  /** Get a single UserWithScanEvents. */
  userWithScanEvents?: Maybe<UserWithScanEvents>;
  /** Get multiple Users. */
  users?: Maybe<Array<Maybe<User>>>;
  /** Get aggregated data for Users. */
  users_aggregate?: Maybe<AggregationResult>;
};


export type QueryAccordionItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccordionItemsArgs = {
  filter?: InputMaybe<AccordionItemsListFilter>;
  pagination?: InputMaybe<AccordionItemsPaginationInput>;
};


export type QueryAccordionItems_AggregateArgs = {
  filter?: InputMaybe<AccordionItemsListFilter>;
};


export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountsArgs = {
  filter?: InputMaybe<AccountsListFilter>;
  pagination?: InputMaybe<AccountsPaginationInput>;
};


export type QueryAccounts_AggregateArgs = {
  filter?: InputMaybe<AccountsListFilter>;
};


export type QueryBatchCodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBatchCodesArgs = {
  filter?: InputMaybe<BatchCodesListFilter>;
  pagination?: InputMaybe<BatchCodesPaginationInput>;
};


export type QueryBatchCodes_AggregateArgs = {
  filter?: InputMaybe<BatchCodesListFilter>;
};


export type QueryBlacklistArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBlacklistsArgs = {
  filter?: InputMaybe<BlacklistsListFilter>;
  pagination?: InputMaybe<BlacklistsPaginationInput>;
};


export type QueryBlacklists_AggregateArgs = {
  filter?: InputMaybe<BlacklistsListFilter>;
};


export type QueryCaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCasesArgs = {
  filter?: InputMaybe<CasesListFilter>;
  pagination?: InputMaybe<CasesPaginationInput>;
};


export type QueryCases_AggregateArgs = {
  filter?: InputMaybe<CasesListFilter>;
};


export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactsArgs = {
  filter?: InputMaybe<ContactsListFilter>;
  pagination?: InputMaybe<ContactsPaginationInput>;
};


export type QueryContacts_AggregateArgs = {
  filter?: InputMaybe<ContactsListFilter>;
};


export type QueryContentSectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentSectionsArgs = {
  filter?: InputMaybe<ContentSectionsListFilter>;
  pagination?: InputMaybe<ContentSectionsPaginationInput>;
};


export type QueryContentSections_AggregateArgs = {
  filter?: InputMaybe<ContentSectionsListFilter>;
};


export type QueryCouncilArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCouncilsArgs = {
  filter?: InputMaybe<CouncilsListFilter>;
  pagination?: InputMaybe<CouncilsPaginationInput>;
};


export type QueryCouncils_AggregateArgs = {
  filter?: InputMaybe<CouncilsListFilter>;
};


export type QueryCredentialArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCredentialsArgs = {
  filter?: InputMaybe<CredentialsListFilter>;
  pagination?: InputMaybe<CredentialsPaginationInput>;
};


export type QueryCredentials_AggregateArgs = {
  filter?: InputMaybe<CredentialsListFilter>;
};


export type QueryDropOffLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDropOffLocationsArgs = {
  filter?: InputMaybe<DropOffLocationsListFilter>;
  pagination?: InputMaybe<DropOffLocationsPaginationInput>;
};


export type QueryDropOffLocations_AggregateArgs = {
  filter?: InputMaybe<DropOffLocationsListFilter>;
};


export type QueryFacilitiesArgs = {
  filter?: InputMaybe<FacilitiesListFilter>;
  pagination?: InputMaybe<FacilitiesPaginationInput>;
};


export type QueryFacilities_AggregateArgs = {
  filter?: InputMaybe<FacilitiesListFilter>;
};


export type QueryFacilityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFacilityCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFacilityCustomersArgs = {
  filter?: InputMaybe<FacilityCustomersListFilter>;
  pagination?: InputMaybe<FacilityCustomersPaginationInput>;
};


export type QueryFacilityCustomers_AggregateArgs = {
  filter?: InputMaybe<FacilityCustomersListFilter>;
};


export type QueryFacilityProductTypesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFacilityScanTypesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCouncilStatsArgs = {
  councilId?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<MaterialType>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDownloadUrlArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDropOffLocationsArgs = {
  input?: InputMaybe<GetDropoffLocationsInput>;
};


export type QueryGetSectionContentArgs = {
  input?: InputMaybe<GetSectionContentInput>;
};


export type QueryMultipleFacilityProductTypesArgs = {
  filter?: InputMaybe<MultipleFacilityProductTypesListFilter>;
  pagination?: InputMaybe<MultipleFacilityProductTypesPaginationInput>;
};


export type QueryMultipleFacilityProductTypes_AggregateArgs = {
  filter?: InputMaybe<MultipleFacilityProductTypesListFilter>;
};


export type QueryMultipleFacilityScanTypesArgs = {
  filter?: InputMaybe<MultipleFacilityScanTypesListFilter>;
  pagination?: InputMaybe<MultipleFacilityScanTypesPaginationInput>;
};


export type QueryMultipleFacilityScanTypes_AggregateArgs = {
  filter?: InputMaybe<MultipleFacilityScanTypesListFilter>;
};


export type QueryMultipleScanEventChangesArgs = {
  filter?: InputMaybe<MultipleScanEventChangesListFilter>;
  pagination?: InputMaybe<MultipleScanEventChangesPaginationInput>;
};


export type QueryMultipleScanEventChanges_AggregateArgs = {
  filter?: InputMaybe<MultipleScanEventChangesListFilter>;
};


export type QueryMultipleUserWithScanEventsArgs = {
  filter?: InputMaybe<MultipleUserWithScanEventsListFilter>;
  pagination?: InputMaybe<MultipleUserWithScanEventsPaginationInput>;
};


export type QueryMultipleUserWithScanEvents_AggregateArgs = {
  filter?: InputMaybe<MultipleUserWithScanEventsListFilter>;
};


export type QueryNewsFeedArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNewsFeedsArgs = {
  filter?: InputMaybe<NewsFeedsListFilter>;
  pagination?: InputMaybe<NewsFeedsPaginationInput>;
};


export type QueryNewsFeeds_AggregateArgs = {
  filter?: InputMaybe<NewsFeedsListFilter>;
};


export type QueryPastWinnerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPastWinnersArgs = {
  filter?: InputMaybe<PastWinnersListFilter>;
  pagination?: InputMaybe<PastWinnersPaginationInput>;
};


export type QueryPastWinners_AggregateArgs = {
  filter?: InputMaybe<PastWinnersListFilter>;
};


export type QueryPostcodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPostcodesArgs = {
  filter?: InputMaybe<PostcodesListFilter>;
  pagination?: InputMaybe<PostcodesPaginationInput>;
};


export type QueryPostcodes_AggregateArgs = {
  filter?: InputMaybe<PostcodesListFilter>;
};


export type QueryPrizeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPrizesArgs = {
  filter?: InputMaybe<PrizesListFilter>;
  pagination?: InputMaybe<PrizesPaginationInput>;
};


export type QueryPrizes_AggregateArgs = {
  filter?: InputMaybe<PrizesListFilter>;
};


export type QueryRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRolesArgs = {
  filter?: InputMaybe<RolesListFilter>;
  pagination?: InputMaybe<RolesPaginationInput>;
};


export type QueryRoles_AggregateArgs = {
  filter?: InputMaybe<RolesListFilter>;
};


export type QueryScanEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScanEventChangesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScanEventPhotoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScanEventPhotosArgs = {
  filter?: InputMaybe<ScanEventPhotosListFilter>;
  pagination?: InputMaybe<ScanEventPhotosPaginationInput>;
};


export type QueryScanEventPhotos_AggregateArgs = {
  filter?: InputMaybe<ScanEventPhotosListFilter>;
};


export type QueryScanEventWithTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScanEventWithTagsArgs = {
  filter?: InputMaybe<ScanEventWithTagsListFilter>;
  pagination?: InputMaybe<ScanEventWithTagsPaginationInput>;
};


export type QueryScanEventWithTags_AggregateArgs = {
  filter?: InputMaybe<ScanEventWithTagsListFilter>;
};


export type QueryScanEventsArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
  pagination?: InputMaybe<ScanEventsPaginationInput>;
};


export type QueryScanEvents_AggregateArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
};


export type QueryStripeProductArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySuburbArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySuburbsArgs = {
  filter?: InputMaybe<SuburbsListFilter>;
  pagination?: InputMaybe<SuburbsPaginationInput>;
};


export type QuerySuburbs_AggregateArgs = {
  filter?: InputMaybe<SuburbsListFilter>;
};


export type QueryTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaggedBatchCodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaggedBatchCodesArgs = {
  filter?: InputMaybe<TaggedBatchCodesListFilter>;
  pagination?: InputMaybe<TaggedBatchCodesPaginationInput>;
};


export type QueryTaggedBatchCodes_AggregateArgs = {
  filter?: InputMaybe<TaggedBatchCodesListFilter>;
};


export type QueryTagsArgs = {
  filter?: InputMaybe<TagsListFilter>;
  pagination?: InputMaybe<TagsPaginationInput>;
};


export type QueryTags_AggregateArgs = {
  filter?: InputMaybe<TagsListFilter>;
};


export type QueryTrackableAssetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTrackableAssetsArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
  pagination?: InputMaybe<TrackableAssetsPaginationInput>;
};


export type QueryTrackableAssets_AggregateArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserAlertArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserAlertsArgs = {
  filter?: InputMaybe<UserAlertsListFilter>;
  pagination?: InputMaybe<UserAlertsPaginationInput>;
};


export type QueryUserAlerts_AggregateArgs = {
  filter?: InputMaybe<UserAlertsListFilter>;
};


export type QueryUserPrizeEntryCountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserPrizeEntryCountsArgs = {
  filter?: InputMaybe<UserPrizeEntryCountsListFilter>;
  pagination?: InputMaybe<UserPrizeEntryCountsPaginationInput>;
};


export type QueryUserPrizeEntryCounts_AggregateArgs = {
  filter?: InputMaybe<UserPrizeEntryCountsListFilter>;
};


export type QueryUserSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserSubscriptionsArgs = {
  filter?: InputMaybe<UserSubscriptionsListFilter>;
  pagination?: InputMaybe<UserSubscriptionsPaginationInput>;
};


export type QueryUserSubscriptions_AggregateArgs = {
  filter?: InputMaybe<UserSubscriptionsListFilter>;
};


export type QueryUserWithScanEventsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UsersListFilter>;
  pagination?: InputMaybe<UsersPaginationInput>;
};


export type QueryUsers_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['ID']['output'];
  name: RoleName;
  users?: Maybe<Array<User>>;
  users_aggregate?: Maybe<AggregationResult>;
};


export type RoleUsersArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type RoleUsers_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};

/** Data needed to create or update Roles. If an ID is passed, this is an update, otherwise it's an insert. */
export type RoleCreateOrUpdateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<RoleName>;
  users?: InputMaybe<Array<UserCreateOrUpdateInput>>;
};

/** Data needed to create Roles. */
export type RoleInsertInput = {
  name: RoleName;
  users?: InputMaybe<Array<UserCreateOrUpdateInput>>;
};

export enum RoleName {
  Admin = 'ADMIN',
  Council = 'COUNCIL',
  Facility = 'FACILITY',
  Guest = 'GUEST',
  SuperAdmin = 'SUPER_ADMIN',
  User = 'USER'
}

/** Data needed to update Roles. An ID must be passed. */
export type RoleUpdateInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<RoleName>;
  users?: InputMaybe<Array<UserCreateOrUpdateInput>>;
};

export type RolesListFilter = {
  _and?: InputMaybe<Array<InputMaybe<RolesListFilter>>>;
  _not?: InputMaybe<RolesListFilter>;
  _or?: InputMaybe<Array<InputMaybe<RolesListFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<RoleName>;
  name_in?: InputMaybe<Array<RoleName>>;
  name_nin?: InputMaybe<Array<RoleName>>;
  users?: InputMaybe<UsersListFilter>;
};

export type RolesOrderByInput = {
  id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

/** Pagination options for Roles. */
export type RolesPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RolesOrderByInput>;
};

export type ScanEvent = {
  __typename?: 'ScanEvent';
  contaminationAmount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['ISOString']['output']>;
  createdByApplicationType?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<User>;
  createdByUser_aggregate?: Maybe<AggregationResult>;
  entriesGained: Scalars['Float']['output'];
  facility?: Maybe<Facility>;
  facility_aggregate?: Maybe<AggregationResult>;
  id: Scalars['ID']['output'];
  isContaminated?: Maybe<Scalars['Boolean']['output']>;
  isDamaged?: Maybe<Scalars['Boolean']['output']>;
  material?: Maybe<MaterialType>;
  notes?: Maybe<Scalars['String']['output']>;
  photos?: Maybe<Array<ScanEventPhoto>>;
  photos_aggregate?: Maybe<AggregationResult>;
  scanEventChanges?: Maybe<Array<ScanEventChanges>>;
  scanEventChanges_aggregate?: Maybe<AggregationResult>;
  scanEventType?: Maybe<ScanEventType>;
  trackableAsset: TrackableAsset;
  trackableAsset_aggregate?: Maybe<AggregationResult>;
  wasExcludedFromPrizeEntries: Scalars['Boolean']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};


export type ScanEventCreatedByUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type ScanEventCreatedByUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type ScanEventFacilityArgs = {
  filter?: InputMaybe<FacilitiesListFilter>;
};


export type ScanEventFacility_AggregateArgs = {
  filter?: InputMaybe<FacilitiesListFilter>;
};


export type ScanEventPhotosArgs = {
  filter?: InputMaybe<ScanEventPhotosListFilter>;
};


export type ScanEventPhotos_AggregateArgs = {
  filter?: InputMaybe<ScanEventPhotosListFilter>;
};


export type ScanEventScanEventChangesArgs = {
  filter?: InputMaybe<MultipleScanEventChangesListFilter>;
};


export type ScanEventScanEventChanges_AggregateArgs = {
  filter?: InputMaybe<MultipleScanEventChangesListFilter>;
};


export type ScanEventTrackableAssetArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type ScanEventTrackableAsset_AggregateArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};

export type ScanEventChangeInput = {
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  photoId?: InputMaybe<Scalars['String']['input']>;
  scanId?: InputMaybe<Scalars['String']['input']>;
  scannableCode?: InputMaybe<Scalars['String']['input']>;
  type: ScanEventChangeType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum ScanEventChangeType {
  AddDocketPhoto = 'ADD_DOCKET_PHOTO',
  AddLoadPhoto = 'ADD_LOAD_PHOTO',
  AddScan = 'ADD_SCAN',
  RemoveDocketPhoto = 'REMOVE_DOCKET_PHOTO',
  RemoveLoadPhoto = 'REMOVE_LOAD_PHOTO',
  RemoveScan = 'REMOVE_SCAN',
  UpdateContaminationAmount = 'UPDATE_CONTAMINATION_AMOUNT',
  UpdateDocketId = 'UPDATE_DOCKET_ID',
  UpdateIsContaminated = 'UPDATE_IS_CONTAMINATED',
  UpdateIsDamaged = 'UPDATE_IS_DAMAGED',
  UpdateNotes = 'UPDATE_NOTES',
  UpdateTruckRegistration = 'UPDATE_TRUCK_REGISTRATION',
  UpdateWeight = 'UPDATE_WEIGHT'
}

export type ScanEventChanges = {
  __typename?: 'ScanEventChanges';
  after: Scalars['JSON']['output'];
  before: Scalars['JSON']['output'];
  createdAt: Scalars['ISOString']['output'];
  id: Scalars['ID']['output'];
  scanEvent: ScanEvent;
  scanEvent_aggregate?: Maybe<AggregationResult>;
  user: User;
  user_aggregate?: Maybe<AggregationResult>;
};


export type ScanEventChangesScanEventArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
};


export type ScanEventChangesScanEvent_AggregateArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
};


export type ScanEventChangesUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type ScanEventChangesUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};

/** Data needed to create or update ScanEvents. If an ID is passed, this is an update, otherwise it's an insert. */
export type ScanEventCreateOrUpdateInput = {
  contaminationAmount?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  entriesGained?: InputMaybe<Scalars['Float']['input']>;
  facility?: InputMaybe<FacilityCreateOrUpdateInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isContaminated?: InputMaybe<Scalars['Boolean']['input']>;
  isDamaged?: InputMaybe<Scalars['Boolean']['input']>;
  material?: InputMaybe<MaterialType>;
  notes?: InputMaybe<Scalars['String']['input']>;
  photos?: InputMaybe<Array<ScanEventPhotoCreateOrUpdateInput>>;
  scanEventType?: InputMaybe<ScanEventType>;
  trackableAsset?: InputMaybe<TrackableAssetCreateOrUpdateInput>;
  wasExcludedFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ScanEventFromUserInput = {
  createdByUser?: InputMaybe<Scalars['String']['input']>;
  scannableCode: Scalars['String']['input'];
};

/** Data needed to create ScanEvents. */
export type ScanEventInsertInput = {
  contaminationAmount?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  entriesGained?: InputMaybe<Scalars['Float']['input']>;
  facility?: InputMaybe<FacilityCreateOrUpdateInput>;
  isContaminated?: InputMaybe<Scalars['Boolean']['input']>;
  isDamaged?: InputMaybe<Scalars['Boolean']['input']>;
  material?: InputMaybe<MaterialType>;
  notes?: InputMaybe<Scalars['String']['input']>;
  photos?: InputMaybe<Array<ScanEventPhotoCreateOrUpdateInput>>;
  scanEventType?: InputMaybe<ScanEventType>;
  trackableAsset?: InputMaybe<TrackableAssetCreateOrUpdateInput>;
  wasExcludedFromPrizeEntries: Scalars['Boolean']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ScanEventPhoto = {
  __typename?: 'ScanEventPhoto';
  createdAt?: Maybe<Scalars['ISOString']['output']>;
  createdByApplicationType?: Maybe<Scalars['String']['output']>;
  createdByUser: User;
  createdByUser_aggregate?: Maybe<AggregationResult>;
  id: Scalars['ID']['output'];
  photo?: Maybe<GraphweaverMedia>;
  photoType?: Maybe<ScanEventPhotoType>;
  scanEvent: ScanEvent;
  scanEvent_aggregate?: Maybe<AggregationResult>;
};


export type ScanEventPhotoCreatedByUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type ScanEventPhotoCreatedByUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type ScanEventPhotoScanEventArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
};


export type ScanEventPhotoScanEvent_AggregateArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
};

/** Data needed to create or update ScanEventPhotos. If an ID is passed, this is an update, otherwise it's an insert. */
export type ScanEventPhotoCreateOrUpdateInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  photo?: InputMaybe<GraphweaverMediaCreateOrUpdateInput>;
  photoType?: InputMaybe<ScanEventPhotoType>;
  scanEvent?: InputMaybe<ScanEventCreateOrUpdateInput>;
};

/** Data needed to create ScanEventPhotos. */
export type ScanEventPhotoInsertInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  photo?: InputMaybe<GraphweaverMediaCreateOrUpdateInput>;
  photoType?: InputMaybe<ScanEventPhotoType>;
  scanEvent?: InputMaybe<ScanEventCreateOrUpdateInput>;
};

export enum ScanEventPhotoType {
  Audit = 'AUDIT',
  Docket = 'DOCKET',
  Load = 'LOAD'
}

/** Data needed to update ScanEventPhotos. An ID must be passed. */
export type ScanEventPhotoUpdateInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  id: Scalars['ID']['input'];
  photo?: InputMaybe<GraphweaverMediaCreateOrUpdateInput>;
  photoType?: InputMaybe<ScanEventPhotoType>;
  scanEvent?: InputMaybe<ScanEventCreateOrUpdateInput>;
};

export type ScanEventPhotosListFilter = {
  _and?: InputMaybe<Array<InputMaybe<ScanEventPhotosListFilter>>>;
  _not?: InputMaybe<ScanEventPhotosListFilter>;
  _or?: InputMaybe<Array<InputMaybe<ScanEventPhotosListFilter>>>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_gt?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_gte?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_ilike?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByApplicationType_like?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_lt?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_lte?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_ne?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByApplicationType_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdByApplicationType_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUser?: InputMaybe<UsersListFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  photo?: InputMaybe<GraphweaverMediasListFilter>;
  photoType?: InputMaybe<ScanEventPhotoType>;
  photoType_in?: InputMaybe<Array<ScanEventPhotoType>>;
  photoType_nin?: InputMaybe<Array<ScanEventPhotoType>>;
  scanEvent?: InputMaybe<ScanEventsListFilter>;
};

export type ScanEventPhotosOrderByInput = {
  createdAt?: InputMaybe<Sort>;
  createdByApplicationType?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  photoType?: InputMaybe<Sort>;
};

/** Pagination options for ScanEventPhotos. */
export type ScanEventPhotosPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ScanEventPhotosOrderByInput>;
};

export enum ScanEventType {
  CustomerBagScan = 'CUSTOMER_BAG_SCAN',
  FacilityBagAudit = 'FACILITY_BAG_AUDIT',
  FacilityBagScan = 'FACILITY_BAG_SCAN',
  FacilityBaleAudit = 'FACILITY_BALE_AUDIT',
  FacilityBaleCreate = 'FACILITY_BALE_CREATE',
  FacilityBaleInbound = 'FACILITY_BALE_INBOUND',
  FacilityBaleOutbound = 'FACILITY_BALE_OUTBOUND',
  FacilityBaleProcessed = 'FACILITY_BALE_PROCESSED',
  LoadArrival = 'LOAD_ARRIVAL',
  LoadDispatched = 'LOAD_DISPATCHED'
}

/** Data needed to update ScanEvents. An ID must be passed. */
export type ScanEventUpdateInput = {
  contaminationAmount?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  entriesGained?: InputMaybe<Scalars['Float']['input']>;
  facility?: InputMaybe<FacilityCreateOrUpdateInput>;
  id: Scalars['ID']['input'];
  isContaminated?: InputMaybe<Scalars['Boolean']['input']>;
  isDamaged?: InputMaybe<Scalars['Boolean']['input']>;
  material?: InputMaybe<MaterialType>;
  notes?: InputMaybe<Scalars['String']['input']>;
  photos?: InputMaybe<Array<ScanEventPhotoCreateOrUpdateInput>>;
  scanEventType?: InputMaybe<ScanEventType>;
  trackableAsset?: InputMaybe<TrackableAssetCreateOrUpdateInput>;
  wasExcludedFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ScanEventWithTag = {
  __typename?: 'ScanEventWithTag';
  assetIntendedMaterial?: Maybe<MaterialType>;
  assetSerialNumber?: Maybe<Scalars['String']['output']>;
  assetType?: Maybe<AssetType>;
  batchCodeCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISOString']['output']>;
  createdByApplicationType?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<User>;
  createdByUserAddress?: Maybe<Scalars['String']['output']>;
  createdByUserCouncil?: Maybe<Scalars['String']['output']>;
  createdByUserFirstName?: Maybe<Scalars['String']['output']>;
  createdByUserLastName?: Maybe<Scalars['String']['output']>;
  createdByUserSalesforceId: Scalars['String']['output'];
  createdByUser_aggregate?: Maybe<AggregationResult>;
  entriesGained: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  material?: Maybe<MaterialType>;
  tag?: Maybe<Tag>;
  tag_aggregate?: Maybe<AggregationResult>;
  trackableAsset: TrackableAsset;
  trackableAsset_aggregate?: Maybe<AggregationResult>;
  wasExcludedFromPrizeEntries: Scalars['Boolean']['output'];
};


export type ScanEventWithTagCreatedByUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type ScanEventWithTagCreatedByUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type ScanEventWithTagTagArgs = {
  filter?: InputMaybe<TagsListFilter>;
};


export type ScanEventWithTagTag_AggregateArgs = {
  filter?: InputMaybe<TagsListFilter>;
};


export type ScanEventWithTagTrackableAssetArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type ScanEventWithTagTrackableAsset_AggregateArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};

export type ScanEventWithTagsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<ScanEventWithTagsListFilter>>>;
  _not?: InputMaybe<ScanEventWithTagsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<ScanEventWithTagsListFilter>>>;
  assetIntendedMaterial?: InputMaybe<MaterialType>;
  assetIntendedMaterial_in?: InputMaybe<Array<MaterialType>>;
  assetIntendedMaterial_nin?: InputMaybe<Array<MaterialType>>;
  assetSerialNumber?: InputMaybe<Scalars['String']['input']>;
  assetSerialNumber_gt?: InputMaybe<Scalars['String']['input']>;
  assetSerialNumber_gte?: InputMaybe<Scalars['String']['input']>;
  assetSerialNumber_ilike?: InputMaybe<Scalars['String']['input']>;
  assetSerialNumber_in?: InputMaybe<Array<Scalars['String']['input']>>;
  assetSerialNumber_like?: InputMaybe<Scalars['String']['input']>;
  assetSerialNumber_lt?: InputMaybe<Scalars['String']['input']>;
  assetSerialNumber_lte?: InputMaybe<Scalars['String']['input']>;
  assetSerialNumber_ne?: InputMaybe<Scalars['String']['input']>;
  assetSerialNumber_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  assetSerialNumber_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  assetSerialNumber_null?: InputMaybe<Scalars['Boolean']['input']>;
  assetType?: InputMaybe<AssetType>;
  assetType_in?: InputMaybe<Array<AssetType>>;
  assetType_nin?: InputMaybe<Array<AssetType>>;
  batchCodeCode?: InputMaybe<Scalars['String']['input']>;
  batchCodeCode_gt?: InputMaybe<Scalars['String']['input']>;
  batchCodeCode_gte?: InputMaybe<Scalars['String']['input']>;
  batchCodeCode_ilike?: InputMaybe<Scalars['String']['input']>;
  batchCodeCode_in?: InputMaybe<Array<Scalars['String']['input']>>;
  batchCodeCode_like?: InputMaybe<Scalars['String']['input']>;
  batchCodeCode_lt?: InputMaybe<Scalars['String']['input']>;
  batchCodeCode_lte?: InputMaybe<Scalars['String']['input']>;
  batchCodeCode_ne?: InputMaybe<Scalars['String']['input']>;
  batchCodeCode_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  batchCodeCode_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  batchCodeCode_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_gt?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_gte?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_ilike?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByApplicationType_like?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_lt?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_lte?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_ne?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByApplicationType_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdByApplicationType_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUser?: InputMaybe<UsersListFilter>;
  createdByUserAddress?: InputMaybe<Scalars['String']['input']>;
  createdByUserAddress_gt?: InputMaybe<Scalars['String']['input']>;
  createdByUserAddress_gte?: InputMaybe<Scalars['String']['input']>;
  createdByUserAddress_ilike?: InputMaybe<Scalars['String']['input']>;
  createdByUserAddress_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserAddress_like?: InputMaybe<Scalars['String']['input']>;
  createdByUserAddress_lt?: InputMaybe<Scalars['String']['input']>;
  createdByUserAddress_lte?: InputMaybe<Scalars['String']['input']>;
  createdByUserAddress_ne?: InputMaybe<Scalars['String']['input']>;
  createdByUserAddress_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserAddress_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserAddress_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserCouncil?: InputMaybe<Scalars['String']['input']>;
  createdByUserCouncil_gt?: InputMaybe<Scalars['String']['input']>;
  createdByUserCouncil_gte?: InputMaybe<Scalars['String']['input']>;
  createdByUserCouncil_ilike?: InputMaybe<Scalars['String']['input']>;
  createdByUserCouncil_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserCouncil_like?: InputMaybe<Scalars['String']['input']>;
  createdByUserCouncil_lt?: InputMaybe<Scalars['String']['input']>;
  createdByUserCouncil_lte?: InputMaybe<Scalars['String']['input']>;
  createdByUserCouncil_ne?: InputMaybe<Scalars['String']['input']>;
  createdByUserCouncil_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserCouncil_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserCouncil_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserFirstName?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName_gt?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName_gte?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName_ilike?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserFirstName_like?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName_lt?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName_lte?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName_ne?: InputMaybe<Scalars['String']['input']>;
  createdByUserFirstName_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserFirstName_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserFirstName_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserLastName?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName_gt?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName_gte?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName_ilike?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserLastName_like?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName_lt?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName_lte?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName_ne?: InputMaybe<Scalars['String']['input']>;
  createdByUserLastName_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserLastName_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserLastName_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserSalesforceId?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId_gt?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId_gte?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId_ilike?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserSalesforceId_like?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId_lt?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId_lte?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId_ne?: InputMaybe<Scalars['String']['input']>;
  createdByUserSalesforceId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserSalesforceId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserSalesforceId_null?: InputMaybe<Scalars['Boolean']['input']>;
  entriesGained?: InputMaybe<Scalars['Float']['input']>;
  entriesGained_gt?: InputMaybe<Scalars['Float']['input']>;
  entriesGained_gte?: InputMaybe<Scalars['Float']['input']>;
  entriesGained_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  entriesGained_lt?: InputMaybe<Scalars['Float']['input']>;
  entriesGained_lte?: InputMaybe<Scalars['Float']['input']>;
  entriesGained_ne?: InputMaybe<Scalars['Float']['input']>;
  entriesGained_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  entriesGained_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  entriesGained_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  material?: InputMaybe<MaterialType>;
  material_in?: InputMaybe<Array<MaterialType>>;
  material_nin?: InputMaybe<Array<MaterialType>>;
  tag?: InputMaybe<TagsListFilter>;
  trackableAsset?: InputMaybe<TrackableAssetsListFilter>;
  wasExcludedFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  wasExcludedFromPrizeEntries_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  wasExcludedFromPrizeEntries_ne?: InputMaybe<Scalars['Boolean']['input']>;
  wasExcludedFromPrizeEntries_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  wasExcludedFromPrizeEntries_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  wasExcludedFromPrizeEntries_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScanEventWithTagsOrderByInput = {
  assetIntendedMaterial?: InputMaybe<Sort>;
  assetSerialNumber?: InputMaybe<Sort>;
  assetType?: InputMaybe<Sort>;
  batchCodeCode?: InputMaybe<Sort>;
  createdAt?: InputMaybe<Sort>;
  createdByApplicationType?: InputMaybe<Sort>;
  createdByUserAddress?: InputMaybe<Sort>;
  createdByUserCouncil?: InputMaybe<Sort>;
  createdByUserFirstName?: InputMaybe<Sort>;
  createdByUserLastName?: InputMaybe<Sort>;
  createdByUserSalesforceId?: InputMaybe<Sort>;
  entriesGained?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  material?: InputMaybe<Sort>;
  wasExcludedFromPrizeEntries?: InputMaybe<Sort>;
};

/** Pagination options for ScanEventWithTags. */
export type ScanEventWithTagsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ScanEventWithTagsOrderByInput>;
};

export type ScanEventsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<ScanEventsListFilter>>>;
  _not?: InputMaybe<ScanEventsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<ScanEventsListFilter>>>;
  contaminationAmount?: InputMaybe<Scalars['Float']['input']>;
  contaminationAmount_gt?: InputMaybe<Scalars['Float']['input']>;
  contaminationAmount_gte?: InputMaybe<Scalars['Float']['input']>;
  contaminationAmount_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  contaminationAmount_lt?: InputMaybe<Scalars['Float']['input']>;
  contaminationAmount_lte?: InputMaybe<Scalars['Float']['input']>;
  contaminationAmount_ne?: InputMaybe<Scalars['Float']['input']>;
  contaminationAmount_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  contaminationAmount_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  contaminationAmount_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByApplicationType?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_gt?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_gte?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_ilike?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByApplicationType_like?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_lt?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_lte?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_ne?: InputMaybe<Scalars['String']['input']>;
  createdByApplicationType_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByApplicationType_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdByApplicationType_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUser?: InputMaybe<UsersListFilter>;
  entriesGained?: InputMaybe<Scalars['Float']['input']>;
  entriesGained_gt?: InputMaybe<Scalars['Float']['input']>;
  entriesGained_gte?: InputMaybe<Scalars['Float']['input']>;
  entriesGained_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  entriesGained_lt?: InputMaybe<Scalars['Float']['input']>;
  entriesGained_lte?: InputMaybe<Scalars['Float']['input']>;
  entriesGained_ne?: InputMaybe<Scalars['Float']['input']>;
  entriesGained_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  entriesGained_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  entriesGained_null?: InputMaybe<Scalars['Boolean']['input']>;
  facility?: InputMaybe<FacilitiesListFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  isContaminated?: InputMaybe<Scalars['Boolean']['input']>;
  isContaminated_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isContaminated_ne?: InputMaybe<Scalars['Boolean']['input']>;
  isContaminated_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isContaminated_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  isContaminated_null?: InputMaybe<Scalars['Boolean']['input']>;
  isDamaged?: InputMaybe<Scalars['Boolean']['input']>;
  isDamaged_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDamaged_ne?: InputMaybe<Scalars['Boolean']['input']>;
  isDamaged_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDamaged_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  isDamaged_null?: InputMaybe<Scalars['Boolean']['input']>;
  material?: InputMaybe<MaterialType>;
  material_in?: InputMaybe<Array<MaterialType>>;
  material_nin?: InputMaybe<Array<MaterialType>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notes_gt?: InputMaybe<Scalars['String']['input']>;
  notes_gte?: InputMaybe<Scalars['String']['input']>;
  notes_ilike?: InputMaybe<Scalars['String']['input']>;
  notes_in?: InputMaybe<Array<Scalars['String']['input']>>;
  notes_like?: InputMaybe<Scalars['String']['input']>;
  notes_lt?: InputMaybe<Scalars['String']['input']>;
  notes_lte?: InputMaybe<Scalars['String']['input']>;
  notes_ne?: InputMaybe<Scalars['String']['input']>;
  notes_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  notes_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  notes_null?: InputMaybe<Scalars['Boolean']['input']>;
  photos?: InputMaybe<ScanEventPhotosListFilter>;
  scanEventChanges?: InputMaybe<MultipleScanEventChangesListFilter>;
  scanEventType?: InputMaybe<ScanEventType>;
  scanEventType_in?: InputMaybe<Array<ScanEventType>>;
  scanEventType_nin?: InputMaybe<Array<ScanEventType>>;
  trackableAsset?: InputMaybe<TrackableAssetsListFilter>;
  wasExcludedFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  wasExcludedFromPrizeEntries_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  wasExcludedFromPrizeEntries_ne?: InputMaybe<Scalars['Boolean']['input']>;
  wasExcludedFromPrizeEntries_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  wasExcludedFromPrizeEntries_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  wasExcludedFromPrizeEntries_null?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weight_gt?: InputMaybe<Scalars['Float']['input']>;
  weight_gte?: InputMaybe<Scalars['Float']['input']>;
  weight_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  weight_lt?: InputMaybe<Scalars['Float']['input']>;
  weight_lte?: InputMaybe<Scalars['Float']['input']>;
  weight_ne?: InputMaybe<Scalars['Float']['input']>;
  weight_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  weight_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  weight_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScanEventsOrderByInput = {
  contaminationAmount?: InputMaybe<Sort>;
  createdAt?: InputMaybe<Sort>;
  createdByApplicationType?: InputMaybe<Sort>;
  entriesGained?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  isContaminated?: InputMaybe<Sort>;
  isDamaged?: InputMaybe<Sort>;
  material?: InputMaybe<Sort>;
  notes?: InputMaybe<Sort>;
  scanEventType?: InputMaybe<Sort>;
  wasExcludedFromPrizeEntries?: InputMaybe<Sort>;
  weight?: InputMaybe<Sort>;
};

/** Pagination options for ScanEvents. */
export type ScanEventsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ScanEventsOrderByInput>;
};

export type ScanStats = {
  __typename?: 'ScanStats';
  totalScans: Scalars['Float']['output'];
  totalScansForCouncil: Scalars['Float']['output'];
};

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StripeCharge = {
  __typename?: 'StripeCharge';
  created: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  receiptNumber: Scalars['Float']['output'];
  receiptUrl: Scalars['String']['output'];
};

/** Data needed to create or update StripeCharges. If an ID is passed, this is an update, otherwise it's an insert. */
export type StripeChargeCreateOrUpdateInput = {
  created?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  receiptNumber?: InputMaybe<Scalars['Float']['input']>;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create StripeCharges. */
export type StripeChargeInsertInput = {
  created: Scalars['Float']['input'];
  receiptNumber: Scalars['Float']['input'];
  receiptUrl: Scalars['String']['input'];
};

/** Data needed to update StripeCharges. An ID must be passed. */
export type StripeChargeUpdateInput = {
  created?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  receiptNumber?: InputMaybe<Scalars['Float']['input']>;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
};

export type StripeChargesListFilter = {
  _and?: InputMaybe<Array<InputMaybe<StripeChargesListFilter>>>;
  _not?: InputMaybe<StripeChargesListFilter>;
  _or?: InputMaybe<Array<InputMaybe<StripeChargesListFilter>>>;
  created?: InputMaybe<Scalars['Float']['input']>;
  created_gt?: InputMaybe<Scalars['Float']['input']>;
  created_gte?: InputMaybe<Scalars['Float']['input']>;
  created_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  created_lt?: InputMaybe<Scalars['Float']['input']>;
  created_lte?: InputMaybe<Scalars['Float']['input']>;
  created_ne?: InputMaybe<Scalars['Float']['input']>;
  created_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  created_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  created_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_ilike?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_like?: InputMaybe<Scalars['String']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_ne?: InputMaybe<Scalars['String']['input']>;
  id_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  receiptNumber?: InputMaybe<Scalars['Float']['input']>;
  receiptNumber_gt?: InputMaybe<Scalars['Float']['input']>;
  receiptNumber_gte?: InputMaybe<Scalars['Float']['input']>;
  receiptNumber_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  receiptNumber_lt?: InputMaybe<Scalars['Float']['input']>;
  receiptNumber_lte?: InputMaybe<Scalars['Float']['input']>;
  receiptNumber_ne?: InputMaybe<Scalars['Float']['input']>;
  receiptNumber_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  receiptNumber_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  receiptNumber_null?: InputMaybe<Scalars['Boolean']['input']>;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  receiptUrl_gt?: InputMaybe<Scalars['String']['input']>;
  receiptUrl_gte?: InputMaybe<Scalars['String']['input']>;
  receiptUrl_ilike?: InputMaybe<Scalars['String']['input']>;
  receiptUrl_in?: InputMaybe<Array<Scalars['String']['input']>>;
  receiptUrl_like?: InputMaybe<Scalars['String']['input']>;
  receiptUrl_lt?: InputMaybe<Scalars['String']['input']>;
  receiptUrl_lte?: InputMaybe<Scalars['String']['input']>;
  receiptUrl_ne?: InputMaybe<Scalars['String']['input']>;
  receiptUrl_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  receiptUrl_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  receiptUrl_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeCreateSessionResult = {
  __typename?: 'StripeCreateSessionResult';
  clientSecret: Scalars['String']['output'];
};

/** Data needed to create or update StripeCreateSessionResults. If an ID is passed, this is an update, otherwise it's an insert. */
export type StripeCreateSessionResultCreateOrUpdateInput = {
  clientSecret?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create StripeCreateSessionResults. */
export type StripeCreateSessionResultInsertInput = {
  clientSecret: Scalars['String']['input'];
};

/** Data needed to update StripeCreateSessionResults. An ID must be passed. */
export type StripeCreateSessionResultUpdateInput = {
  clientSecret?: InputMaybe<Scalars['String']['input']>;
};

export type StripeCreateSessionResultsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<StripeCreateSessionResultsListFilter>>>;
  _not?: InputMaybe<StripeCreateSessionResultsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<StripeCreateSessionResultsListFilter>>>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  clientSecret_gt?: InputMaybe<Scalars['String']['input']>;
  clientSecret_gte?: InputMaybe<Scalars['String']['input']>;
  clientSecret_ilike?: InputMaybe<Scalars['String']['input']>;
  clientSecret_in?: InputMaybe<Array<Scalars['String']['input']>>;
  clientSecret_like?: InputMaybe<Scalars['String']['input']>;
  clientSecret_lt?: InputMaybe<Scalars['String']['input']>;
  clientSecret_lte?: InputMaybe<Scalars['String']['input']>;
  clientSecret_ne?: InputMaybe<Scalars['String']['input']>;
  clientSecret_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  clientSecret_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  clientSecret_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripePrice = {
  __typename?: 'StripePrice';
  active: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  unit_amount: Scalars['Float']['output'];
};

/** Data needed to create or update StripePrices. If an ID is passed, this is an update, otherwise it's an insert. */
export type StripePriceCreateOrUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  unit_amount?: InputMaybe<Scalars['Float']['input']>;
};

/** Data needed to create StripePrices. */
export type StripePriceInsertInput = {
  active: Scalars['Boolean']['input'];
  unit_amount: Scalars['Float']['input'];
};

/** Data needed to update StripePrices. An ID must be passed. */
export type StripePriceUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  unit_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type StripePricesListFilter = {
  _and?: InputMaybe<Array<InputMaybe<StripePricesListFilter>>>;
  _not?: InputMaybe<StripePricesListFilter>;
  _or?: InputMaybe<Array<InputMaybe<StripePricesListFilter>>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  active_ne?: InputMaybe<Scalars['Boolean']['input']>;
  active_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  active_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  active_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_ilike?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_like?: InputMaybe<Scalars['String']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_ne?: InputMaybe<Scalars['String']['input']>;
  id_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  unit_amount?: InputMaybe<Scalars['Float']['input']>;
  unit_amount_gt?: InputMaybe<Scalars['Float']['input']>;
  unit_amount_gte?: InputMaybe<Scalars['Float']['input']>;
  unit_amount_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  unit_amount_lt?: InputMaybe<Scalars['Float']['input']>;
  unit_amount_lte?: InputMaybe<Scalars['Float']['input']>;
  unit_amount_ne?: InputMaybe<Scalars['Float']['input']>;
  unit_amount_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  unit_amount_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  unit_amount_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  active: Scalars['Boolean']['output'];
  default_price?: Maybe<StripePrice>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  metadata?: Maybe<Metadata>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Data needed to create or update StripeProducts. If an ID is passed, this is an update, otherwise it's an insert. */
export type StripeProductCreateOrUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  default_price?: InputMaybe<StripePriceCreateOrUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<MetadataCreateOrUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create StripeProducts. */
export type StripeProductInsertInput = {
  active: Scalars['Boolean']['input'];
  default_price?: InputMaybe<StripePriceCreateOrUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<MetadataCreateOrUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to update StripeProducts. An ID must be passed. */
export type StripeProductUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  default_price?: InputMaybe<StripePriceCreateOrUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  images?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<MetadataCreateOrUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type StripeProductsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<StripeProductsListFilter>>>;
  _not?: InputMaybe<StripeProductsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<StripeProductsListFilter>>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  active_ne?: InputMaybe<Scalars['Boolean']['input']>;
  active_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  active_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  active_null?: InputMaybe<Scalars['Boolean']['input']>;
  default_price?: InputMaybe<StripePricesListFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_ilike?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_like?: InputMaybe<Scalars['String']['input']>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  description_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  description_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_ilike?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_like?: InputMaybe<Scalars['String']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_ne?: InputMaybe<Scalars['String']['input']>;
  id_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MultipleMetadataListFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_ilike?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_like?: InputMaybe<Scalars['String']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  name_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  name_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeSessionLineItemInput = {
  priceId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
};

export type SubscriptionCount = {
  __typename?: 'SubscriptionCount';
  count: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
};

export type Suburb = {
  __typename?: 'Suburb';
  boundaryFeature?: Maybe<Scalars['JSON']['output']>;
  councils: Array<Council>;
  councils_aggregate?: Maybe<AggregationResult>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isCustomMapFeature: Scalars['Boolean']['output'];
  placeId?: Maybe<Scalars['String']['output']>;
  uniqueName: Scalars['String']['output'];
};


export type SuburbCouncilsArgs = {
  filter?: InputMaybe<CouncilsListFilter>;
};


export type SuburbCouncils_AggregateArgs = {
  filter?: InputMaybe<CouncilsListFilter>;
};

/** Data needed to create or update Suburbs. If an ID is passed, this is an update, otherwise it's an insert. */
export type SuburbCreateOrUpdateInput = {
  boundaryFeature?: InputMaybe<Scalars['JSON']['input']>;
  councils?: InputMaybe<Array<CouncilCreateOrUpdateInput>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isCustomMapFeature?: InputMaybe<Scalars['Boolean']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  uniqueName?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create Suburbs. */
export type SuburbInsertInput = {
  boundaryFeature?: InputMaybe<Scalars['JSON']['input']>;
  councils?: InputMaybe<Array<CouncilCreateOrUpdateInput>>;
  displayName: Scalars['String']['input'];
  isCustomMapFeature: Scalars['Boolean']['input'];
  placeId?: InputMaybe<Scalars['String']['input']>;
  uniqueName: Scalars['String']['input'];
};

/** Data needed to update Suburbs. An ID must be passed. */
export type SuburbUpdateInput = {
  boundaryFeature?: InputMaybe<Scalars['JSON']['input']>;
  councils?: InputMaybe<Array<CouncilCreateOrUpdateInput>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isCustomMapFeature?: InputMaybe<Scalars['Boolean']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  uniqueName?: InputMaybe<Scalars['String']['input']>;
};

export type SuburbsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<SuburbsListFilter>>>;
  _not?: InputMaybe<SuburbsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<SuburbsListFilter>>>;
  boundaryFeature?: InputMaybe<Scalars['JSON']['input']>;
  boundaryFeature_in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  boundaryFeature_ne?: InputMaybe<Scalars['JSON']['input']>;
  boundaryFeature_nin?: InputMaybe<Array<Scalars['JSON']['input']>>;
  boundaryFeature_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  boundaryFeature_null?: InputMaybe<Scalars['Boolean']['input']>;
  councils?: InputMaybe<CouncilsListFilter>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayName_gt?: InputMaybe<Scalars['String']['input']>;
  displayName_gte?: InputMaybe<Scalars['String']['input']>;
  displayName_ilike?: InputMaybe<Scalars['String']['input']>;
  displayName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName_like?: InputMaybe<Scalars['String']['input']>;
  displayName_lt?: InputMaybe<Scalars['String']['input']>;
  displayName_lte?: InputMaybe<Scalars['String']['input']>;
  displayName_ne?: InputMaybe<Scalars['String']['input']>;
  displayName_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  displayName_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomMapFeature?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomMapFeature_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isCustomMapFeature_ne?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomMapFeature_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isCustomMapFeature_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomMapFeature_null?: InputMaybe<Scalars['Boolean']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  placeId_gt?: InputMaybe<Scalars['String']['input']>;
  placeId_gte?: InputMaybe<Scalars['String']['input']>;
  placeId_ilike?: InputMaybe<Scalars['String']['input']>;
  placeId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  placeId_like?: InputMaybe<Scalars['String']['input']>;
  placeId_lt?: InputMaybe<Scalars['String']['input']>;
  placeId_lte?: InputMaybe<Scalars['String']['input']>;
  placeId_ne?: InputMaybe<Scalars['String']['input']>;
  placeId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  placeId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  placeId_null?: InputMaybe<Scalars['Boolean']['input']>;
  uniqueName?: InputMaybe<Scalars['String']['input']>;
  uniqueName_gt?: InputMaybe<Scalars['String']['input']>;
  uniqueName_gte?: InputMaybe<Scalars['String']['input']>;
  uniqueName_ilike?: InputMaybe<Scalars['String']['input']>;
  uniqueName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  uniqueName_like?: InputMaybe<Scalars['String']['input']>;
  uniqueName_lt?: InputMaybe<Scalars['String']['input']>;
  uniqueName_lte?: InputMaybe<Scalars['String']['input']>;
  uniqueName_ne?: InputMaybe<Scalars['String']['input']>;
  uniqueName_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  uniqueName_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  uniqueName_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SuburbsOrderByInput = {
  boundaryFeature?: InputMaybe<Sort>;
  displayName?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  isCustomMapFeature?: InputMaybe<Sort>;
  placeId?: InputMaybe<Sort>;
  uniqueName?: InputMaybe<Sort>;
};

/** Pagination options for Suburbs. */
export type SuburbsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SuburbsOrderByInput>;
};

export type Tag = {
  __typename?: 'Tag';
  excludeFromPrizeEntries: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  trackableAssets?: Maybe<Array<TrackableAsset>>;
  trackableAssets_aggregate?: Maybe<AggregationResult>;
};


export type TagTrackableAssetsArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type TagTrackableAssets_AggregateArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};

/** Data needed to create or update Tags. If an ID is passed, this is an update, otherwise it's an insert. */
export type TagCreateOrUpdateInput = {
  excludeFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  trackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
};

/** Data needed to create Tags. */
export type TagInsertInput = {
  excludeFromPrizeEntries: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  trackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
};

/** Data needed to update Tags. An ID must be passed. */
export type TagUpdateInput = {
  excludeFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  trackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
};

export type TaggedBatchCode = {
  __typename?: 'TaggedBatchCode';
  batchCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isTrial: Scalars['Boolean']['output'];
  materialType?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<AssetType>;
  tagCode?: Maybe<Scalars['String']['output']>;
  trackableAssetCount?: Maybe<Scalars['Float']['output']>;
};

export type TaggedBatchCodesListFilter = {
  _and?: InputMaybe<Array<InputMaybe<TaggedBatchCodesListFilter>>>;
  _not?: InputMaybe<TaggedBatchCodesListFilter>;
  _or?: InputMaybe<Array<InputMaybe<TaggedBatchCodesListFilter>>>;
  batchCode?: InputMaybe<Scalars['String']['input']>;
  batchCode_gt?: InputMaybe<Scalars['String']['input']>;
  batchCode_gte?: InputMaybe<Scalars['String']['input']>;
  batchCode_ilike?: InputMaybe<Scalars['String']['input']>;
  batchCode_in?: InputMaybe<Array<Scalars['String']['input']>>;
  batchCode_like?: InputMaybe<Scalars['String']['input']>;
  batchCode_lt?: InputMaybe<Scalars['String']['input']>;
  batchCode_lte?: InputMaybe<Scalars['String']['input']>;
  batchCode_ne?: InputMaybe<Scalars['String']['input']>;
  batchCode_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  batchCode_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  batchCode_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  createdAt_gt?: InputMaybe<Scalars['String']['input']>;
  createdAt_gte?: InputMaybe<Scalars['String']['input']>;
  createdAt_ilike?: InputMaybe<Scalars['String']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt_like?: InputMaybe<Scalars['String']['input']>;
  createdAt_lt?: InputMaybe<Scalars['String']['input']>;
  createdAt_lte?: InputMaybe<Scalars['String']['input']>;
  createdAt_ne?: InputMaybe<Scalars['String']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_gt?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_gte?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_ilike?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByEmail_like?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_lt?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_lte?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_ne?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByEmail_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdByEmail_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  isTrial?: InputMaybe<Scalars['Boolean']['input']>;
  isTrial_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isTrial_ne?: InputMaybe<Scalars['Boolean']['input']>;
  isTrial_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isTrial_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  isTrial_null?: InputMaybe<Scalars['Boolean']['input']>;
  materialType?: InputMaybe<Scalars['String']['input']>;
  materialType_gt?: InputMaybe<Scalars['String']['input']>;
  materialType_gte?: InputMaybe<Scalars['String']['input']>;
  materialType_ilike?: InputMaybe<Scalars['String']['input']>;
  materialType_in?: InputMaybe<Array<Scalars['String']['input']>>;
  materialType_like?: InputMaybe<Scalars['String']['input']>;
  materialType_lt?: InputMaybe<Scalars['String']['input']>;
  materialType_lte?: InputMaybe<Scalars['String']['input']>;
  materialType_ne?: InputMaybe<Scalars['String']['input']>;
  materialType_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  materialType_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  materialType_null?: InputMaybe<Scalars['Boolean']['input']>;
  productType?: InputMaybe<AssetType>;
  productType_in?: InputMaybe<Array<AssetType>>;
  productType_nin?: InputMaybe<Array<AssetType>>;
  tagCode?: InputMaybe<Scalars['String']['input']>;
  tagCode_gt?: InputMaybe<Scalars['String']['input']>;
  tagCode_gte?: InputMaybe<Scalars['String']['input']>;
  tagCode_ilike?: InputMaybe<Scalars['String']['input']>;
  tagCode_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tagCode_like?: InputMaybe<Scalars['String']['input']>;
  tagCode_lt?: InputMaybe<Scalars['String']['input']>;
  tagCode_lte?: InputMaybe<Scalars['String']['input']>;
  tagCode_ne?: InputMaybe<Scalars['String']['input']>;
  tagCode_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  tagCode_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  tagCode_null?: InputMaybe<Scalars['Boolean']['input']>;
  trackableAssetCount?: InputMaybe<Scalars['Float']['input']>;
  trackableAssetCount_gt?: InputMaybe<Scalars['Float']['input']>;
  trackableAssetCount_gte?: InputMaybe<Scalars['Float']['input']>;
  trackableAssetCount_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  trackableAssetCount_lt?: InputMaybe<Scalars['Float']['input']>;
  trackableAssetCount_lte?: InputMaybe<Scalars['Float']['input']>;
  trackableAssetCount_ne?: InputMaybe<Scalars['Float']['input']>;
  trackableAssetCount_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  trackableAssetCount_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  trackableAssetCount_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaggedBatchCodesOrderByInput = {
  batchCode?: InputMaybe<Sort>;
  createdAt?: InputMaybe<Sort>;
  createdByEmail?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  isTrial?: InputMaybe<Sort>;
  materialType?: InputMaybe<Sort>;
  productType?: InputMaybe<Sort>;
  tagCode?: InputMaybe<Sort>;
  trackableAssetCount?: InputMaybe<Sort>;
};

/** Pagination options for TaggedBatchCodes. */
export type TaggedBatchCodesPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TaggedBatchCodesOrderByInput>;
};

export type TagsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<TagsListFilter>>>;
  _not?: InputMaybe<TagsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<TagsListFilter>>>;
  excludeFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromPrizeEntries_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  excludeFromPrizeEntries_ne?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromPrizeEntries_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  excludeFromPrizeEntries_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromPrizeEntries_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_ilike?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_like?: InputMaybe<Scalars['String']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  name_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  name_null?: InputMaybe<Scalars['Boolean']['input']>;
  trackableAssets?: InputMaybe<TrackableAssetsListFilter>;
};

export type TagsOrderByInput = {
  excludeFromPrizeEntries?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

/** Pagination options for Tags. */
export type TagsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TagsOrderByInput>;
};

export type Token = {
  __typename?: 'Token';
  authToken: Scalars['String']['output'];
};

export type TrackableAsset = {
  __typename?: 'TrackableAsset';
  actualMaterial?: Maybe<MaterialType>;
  assetType?: Maybe<AssetType>;
  batchCode?: Maybe<BatchCode>;
  batchCode_aggregate?: Maybe<AggregationResult>;
  codeUrl?: Maybe<Scalars['String']['output']>;
  containedInTrackableAssets?: Maybe<Array<TrackableAsset>>;
  containedInTrackableAssets_aggregate?: Maybe<AggregationResult>;
  containsTrackableAssets?: Maybe<Array<TrackableAsset>>;
  containsTrackableAssets_aggregate?: Maybe<AggregationResult>;
  createdByUser?: Maybe<User>;
  createdByUser_aggregate?: Maybe<AggregationResult>;
  docketId?: Maybe<Scalars['String']['output']>;
  excludeFromPrizeEntries: Scalars['Boolean']['output'];
  facilityCustomer?: Maybe<FacilityCustomer>;
  facilityCustomer_aggregate?: Maybe<AggregationResult>;
  id: Scalars['ID']['output'];
  intendedMaterial?: Maybe<MaterialType>;
  scanEvents?: Maybe<Array<ScanEvent>>;
  scanEvents_aggregate?: Maybe<AggregationResult>;
  scannableCode?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  shouldConfirmMaterial: Scalars['Boolean']['output'];
  status?: Maybe<AssetStatus>;
  tag?: Maybe<Tag>;
  tag_aggregate?: Maybe<AggregationResult>;
  truckRegistration?: Maybe<Scalars['String']['output']>;
  useCase?: Maybe<AssetUseCase>;
};


export type TrackableAssetBatchCodeArgs = {
  filter?: InputMaybe<BatchCodesListFilter>;
};


export type TrackableAssetBatchCode_AggregateArgs = {
  filter?: InputMaybe<BatchCodesListFilter>;
};


export type TrackableAssetContainedInTrackableAssetsArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type TrackableAssetContainedInTrackableAssets_AggregateArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type TrackableAssetContainsTrackableAssetsArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type TrackableAssetContainsTrackableAssets_AggregateArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type TrackableAssetCreatedByUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type TrackableAssetCreatedByUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type TrackableAssetFacilityCustomerArgs = {
  filter?: InputMaybe<FacilityCustomersListFilter>;
};


export type TrackableAssetFacilityCustomer_AggregateArgs = {
  filter?: InputMaybe<FacilityCustomersListFilter>;
};


export type TrackableAssetScanEventsArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
};


export type TrackableAssetScanEvents_AggregateArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
};


export type TrackableAssetTagArgs = {
  filter?: InputMaybe<TagsListFilter>;
};


export type TrackableAssetTag_AggregateArgs = {
  filter?: InputMaybe<TagsListFilter>;
};

/** Data needed to create or update TrackableAssets. If an ID is passed, this is an update, otherwise it's an insert. */
export type TrackableAssetCreateOrUpdateInput = {
  actualMaterial?: InputMaybe<MaterialType>;
  assetType?: InputMaybe<AssetType>;
  batchCode?: InputMaybe<BatchCodeCreateOrUpdateInput>;
  codeUrl?: InputMaybe<Scalars['String']['input']>;
  containedInTrackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
  containsTrackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  docketId?: InputMaybe<Scalars['String']['input']>;
  excludeFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  facilityCustomer?: InputMaybe<FacilityCustomerCreateOrUpdateInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  intendedMaterial?: InputMaybe<MaterialType>;
  scanEvents?: InputMaybe<Array<ScanEventCreateOrUpdateInput>>;
  scannableCode?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  shouldConfirmMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AssetStatus>;
  tag?: InputMaybe<TagCreateOrUpdateInput>;
  truckRegistration?: InputMaybe<Scalars['String']['input']>;
  useCase?: InputMaybe<AssetUseCase>;
};

/** Data needed to create TrackableAssets. */
export type TrackableAssetInsertInput = {
  actualMaterial?: InputMaybe<MaterialType>;
  assetType?: InputMaybe<AssetType>;
  batchCode?: InputMaybe<BatchCodeCreateOrUpdateInput>;
  codeUrl?: InputMaybe<Scalars['String']['input']>;
  containedInTrackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
  containsTrackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  docketId?: InputMaybe<Scalars['String']['input']>;
  excludeFromPrizeEntries: Scalars['Boolean']['input'];
  facilityCustomer?: InputMaybe<FacilityCustomerCreateOrUpdateInput>;
  intendedMaterial?: InputMaybe<MaterialType>;
  scanEvents?: InputMaybe<Array<ScanEventCreateOrUpdateInput>>;
  scannableCode?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  shouldConfirmMaterial: Scalars['Boolean']['input'];
  status?: InputMaybe<AssetStatus>;
  tag?: InputMaybe<TagCreateOrUpdateInput>;
  truckRegistration?: InputMaybe<Scalars['String']['input']>;
  useCase?: InputMaybe<AssetUseCase>;
};

/** Data needed to update TrackableAssets. An ID must be passed. */
export type TrackableAssetUpdateInput = {
  actualMaterial?: InputMaybe<MaterialType>;
  assetType?: InputMaybe<AssetType>;
  batchCode?: InputMaybe<BatchCodeCreateOrUpdateInput>;
  codeUrl?: InputMaybe<Scalars['String']['input']>;
  containedInTrackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
  containsTrackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
  createdByUser?: InputMaybe<UserCreateOrUpdateInput>;
  docketId?: InputMaybe<Scalars['String']['input']>;
  excludeFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  facilityCustomer?: InputMaybe<FacilityCustomerCreateOrUpdateInput>;
  id: Scalars['ID']['input'];
  intendedMaterial?: InputMaybe<MaterialType>;
  scanEvents?: InputMaybe<Array<ScanEventCreateOrUpdateInput>>;
  scannableCode?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  shouldConfirmMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AssetStatus>;
  tag?: InputMaybe<TagCreateOrUpdateInput>;
  truckRegistration?: InputMaybe<Scalars['String']['input']>;
  useCase?: InputMaybe<AssetUseCase>;
};

export type TrackableAssetsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<TrackableAssetsListFilter>>>;
  _not?: InputMaybe<TrackableAssetsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<TrackableAssetsListFilter>>>;
  actualMaterial?: InputMaybe<MaterialType>;
  actualMaterial_in?: InputMaybe<Array<MaterialType>>;
  actualMaterial_nin?: InputMaybe<Array<MaterialType>>;
  assetType?: InputMaybe<AssetType>;
  assetType_in?: InputMaybe<Array<AssetType>>;
  assetType_nin?: InputMaybe<Array<AssetType>>;
  batchCode?: InputMaybe<BatchCodesListFilter>;
  codeUrl?: InputMaybe<Scalars['String']['input']>;
  codeUrl_gt?: InputMaybe<Scalars['String']['input']>;
  codeUrl_gte?: InputMaybe<Scalars['String']['input']>;
  codeUrl_ilike?: InputMaybe<Scalars['String']['input']>;
  codeUrl_in?: InputMaybe<Array<Scalars['String']['input']>>;
  codeUrl_like?: InputMaybe<Scalars['String']['input']>;
  codeUrl_lt?: InputMaybe<Scalars['String']['input']>;
  codeUrl_lte?: InputMaybe<Scalars['String']['input']>;
  codeUrl_ne?: InputMaybe<Scalars['String']['input']>;
  codeUrl_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  codeUrl_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  codeUrl_null?: InputMaybe<Scalars['Boolean']['input']>;
  containedInTrackableAssets?: InputMaybe<TrackableAssetsListFilter>;
  containsTrackableAssets?: InputMaybe<TrackableAssetsListFilter>;
  createdByUser?: InputMaybe<UsersListFilter>;
  docketId?: InputMaybe<Scalars['String']['input']>;
  docketId_gt?: InputMaybe<Scalars['String']['input']>;
  docketId_gte?: InputMaybe<Scalars['String']['input']>;
  docketId_ilike?: InputMaybe<Scalars['String']['input']>;
  docketId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  docketId_like?: InputMaybe<Scalars['String']['input']>;
  docketId_lt?: InputMaybe<Scalars['String']['input']>;
  docketId_lte?: InputMaybe<Scalars['String']['input']>;
  docketId_ne?: InputMaybe<Scalars['String']['input']>;
  docketId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  docketId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  docketId_null?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromPrizeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromPrizeEntries_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  excludeFromPrizeEntries_ne?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromPrizeEntries_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  excludeFromPrizeEntries_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromPrizeEntries_null?: InputMaybe<Scalars['Boolean']['input']>;
  facilityCustomer?: InputMaybe<FacilityCustomersListFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  intendedMaterial?: InputMaybe<MaterialType>;
  intendedMaterial_in?: InputMaybe<Array<MaterialType>>;
  intendedMaterial_nin?: InputMaybe<Array<MaterialType>>;
  scanEvents?: InputMaybe<ScanEventsListFilter>;
  scannableCode?: InputMaybe<Scalars['String']['input']>;
  scannableCode_gt?: InputMaybe<Scalars['String']['input']>;
  scannableCode_gte?: InputMaybe<Scalars['String']['input']>;
  scannableCode_ilike?: InputMaybe<Scalars['String']['input']>;
  scannableCode_in?: InputMaybe<Array<Scalars['String']['input']>>;
  scannableCode_like?: InputMaybe<Scalars['String']['input']>;
  scannableCode_lt?: InputMaybe<Scalars['String']['input']>;
  scannableCode_lte?: InputMaybe<Scalars['String']['input']>;
  scannableCode_ne?: InputMaybe<Scalars['String']['input']>;
  scannableCode_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  scannableCode_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  scannableCode_null?: InputMaybe<Scalars['Boolean']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber_gt?: InputMaybe<Scalars['String']['input']>;
  serialNumber_gte?: InputMaybe<Scalars['String']['input']>;
  serialNumber_ilike?: InputMaybe<Scalars['String']['input']>;
  serialNumber_in?: InputMaybe<Array<Scalars['String']['input']>>;
  serialNumber_like?: InputMaybe<Scalars['String']['input']>;
  serialNumber_lt?: InputMaybe<Scalars['String']['input']>;
  serialNumber_lte?: InputMaybe<Scalars['String']['input']>;
  serialNumber_ne?: InputMaybe<Scalars['String']['input']>;
  serialNumber_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  serialNumber_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  serialNumber_null?: InputMaybe<Scalars['Boolean']['input']>;
  shouldConfirmMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  shouldConfirmMaterial_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  shouldConfirmMaterial_ne?: InputMaybe<Scalars['Boolean']['input']>;
  shouldConfirmMaterial_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  shouldConfirmMaterial_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  shouldConfirmMaterial_null?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AssetStatus>;
  status_in?: InputMaybe<Array<AssetStatus>>;
  status_nin?: InputMaybe<Array<AssetStatus>>;
  tag?: InputMaybe<TagsListFilter>;
  truckRegistration?: InputMaybe<Scalars['String']['input']>;
  truckRegistration_gt?: InputMaybe<Scalars['String']['input']>;
  truckRegistration_gte?: InputMaybe<Scalars['String']['input']>;
  truckRegistration_ilike?: InputMaybe<Scalars['String']['input']>;
  truckRegistration_in?: InputMaybe<Array<Scalars['String']['input']>>;
  truckRegistration_like?: InputMaybe<Scalars['String']['input']>;
  truckRegistration_lt?: InputMaybe<Scalars['String']['input']>;
  truckRegistration_lte?: InputMaybe<Scalars['String']['input']>;
  truckRegistration_ne?: InputMaybe<Scalars['String']['input']>;
  truckRegistration_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  truckRegistration_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  truckRegistration_null?: InputMaybe<Scalars['Boolean']['input']>;
  useCase?: InputMaybe<AssetUseCase>;
  useCase_in?: InputMaybe<Array<AssetUseCase>>;
  useCase_nin?: InputMaybe<Array<AssetUseCase>>;
};

export type TrackableAssetsOrderByInput = {
  actualMaterial?: InputMaybe<Sort>;
  assetType?: InputMaybe<Sort>;
  codeUrl?: InputMaybe<Sort>;
  docketId?: InputMaybe<Sort>;
  excludeFromPrizeEntries?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  intendedMaterial?: InputMaybe<Sort>;
  scannableCode?: InputMaybe<Sort>;
  serialNumber?: InputMaybe<Sort>;
  shouldConfirmMaterial?: InputMaybe<Sort>;
  status?: InputMaybe<Sort>;
  truckRegistration?: InputMaybe<Sort>;
  useCase?: InputMaybe<Sort>;
};

/** Pagination options for TrackableAssets. */
export type TrackableAssetsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TrackableAssetsOrderByInput>;
};

export type UpdateScanEventInput = {
  changes: Array<ScanEventChangeInput>;
  scanEventId: Scalars['String']['input'];
};

export type UpdateUserEmailInput = {
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  batchCodes?: Maybe<Array<BatchCode>>;
  batchCodes_aggregate?: Maybe<AggregationResult>;
  binReminderEnabled: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  cityPlaceId?: Maybe<Scalars['String']['output']>;
  contact: Contact;
  contact_aggregate?: Maybe<AggregationResult>;
  councilId?: Maybe<Scalars['Float']['output']>;
  createdTrackableAssets?: Maybe<Array<TrackableAsset>>;
  createdTrackableAssets_aggregate?: Maybe<AggregationResult>;
  dateOfBirth?: Maybe<Scalars['DateScalar']['output']>;
  dwellingType?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  facilities?: Maybe<Array<Facility>>;
  facilities_aggregate?: Maybe<AggregationResult>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hasLoggedIn?: Maybe<Scalars['Boolean']['output']>;
  householdSize?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isCouncilStaffOf?: Maybe<Array<Council>>;
  isCouncilStaffOf_aggregate?: Maybe<AggregationResult>;
  isManualAddress?: Maybe<Scalars['Boolean']['output']>;
  isOver18?: Maybe<Scalars['Boolean']['output']>;
  isParticipatingInPrizeDraw?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  linkedCouncil?: Maybe<Council>;
  linkedCouncil_aggregate?: Maybe<AggregationResult>;
  lng?: Maybe<Scalars['Float']['output']>;
  migrationAccountUuid?: Maybe<Scalars['String']['output']>;
  nearestDropOff?: Maybe<Scalars['JSON']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  prizes: Array<Prize>;
  prizes_aggregate?: Maybe<AggregationResult>;
  pushSubscription?: Maybe<Scalars['JSON']['output']>;
  roles: Array<Role>;
  roles_aggregate?: Maybe<AggregationResult>;
  salesforceContactId: Scalars['String']['output'];
  scanEventChanges?: Maybe<Array<ScanEventChanges>>;
  scanEventChanges_aggregate?: Maybe<AggregationResult>;
  scanEvents?: Maybe<Array<ScanEvent>>;
  scanEvents_aggregate?: Maybe<AggregationResult>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Suburb>;
  suburbId?: Maybe<Scalars['String']['output']>;
  suburb_aggregate?: Maybe<AggregationResult>;
  userAlerts: Array<UserAlert>;
  userAlerts_aggregate?: Maybe<AggregationResult>;
  userPrizeEntryCounts?: Maybe<Array<UserPrizeEntryCount>>;
  userPrizeEntryCounts_aggregate?: Maybe<AggregationResult>;
  userSubscriptions?: Maybe<Array<UserSubscription>>;
  userSubscriptions_aggregate?: Maybe<AggregationResult>;
};


export type UserBatchCodesArgs = {
  filter?: InputMaybe<BatchCodesListFilter>;
};


export type UserBatchCodes_AggregateArgs = {
  filter?: InputMaybe<BatchCodesListFilter>;
};


export type UserContactArgs = {
  filter?: InputMaybe<ContactsListFilter>;
};


export type UserContact_AggregateArgs = {
  filter?: InputMaybe<ContactsListFilter>;
};


export type UserCreatedTrackableAssetsArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type UserCreatedTrackableAssets_AggregateArgs = {
  filter?: InputMaybe<TrackableAssetsListFilter>;
};


export type UserFacilitiesArgs = {
  filter?: InputMaybe<FacilitiesListFilter>;
};


export type UserFacilities_AggregateArgs = {
  filter?: InputMaybe<FacilitiesListFilter>;
};


export type UserIsCouncilStaffOfArgs = {
  filter?: InputMaybe<CouncilsListFilter>;
};


export type UserIsCouncilStaffOf_AggregateArgs = {
  filter?: InputMaybe<CouncilsListFilter>;
};


export type UserLinkedCouncilArgs = {
  filter?: InputMaybe<CouncilsListFilter>;
};


export type UserLinkedCouncil_AggregateArgs = {
  filter?: InputMaybe<CouncilsListFilter>;
};


export type UserPrizesArgs = {
  filter?: InputMaybe<PrizesListFilter>;
};


export type UserPrizes_AggregateArgs = {
  filter?: InputMaybe<PrizesListFilter>;
};


export type UserRolesArgs = {
  filter?: InputMaybe<RolesListFilter>;
};


export type UserRoles_AggregateArgs = {
  filter?: InputMaybe<RolesListFilter>;
};


export type UserScanEventChangesArgs = {
  filter?: InputMaybe<MultipleScanEventChangesListFilter>;
};


export type UserScanEventChanges_AggregateArgs = {
  filter?: InputMaybe<MultipleScanEventChangesListFilter>;
};


export type UserScanEventsArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
};


export type UserScanEvents_AggregateArgs = {
  filter?: InputMaybe<ScanEventsListFilter>;
};


export type UserSuburbArgs = {
  filter?: InputMaybe<SuburbsListFilter>;
};


export type UserSuburb_AggregateArgs = {
  filter?: InputMaybe<SuburbsListFilter>;
};


export type UserUserAlertsArgs = {
  filter?: InputMaybe<UserAlertsListFilter>;
};


export type UserUserAlerts_AggregateArgs = {
  filter?: InputMaybe<UserAlertsListFilter>;
};


export type UserUserPrizeEntryCountsArgs = {
  filter?: InputMaybe<UserPrizeEntryCountsListFilter>;
};


export type UserUserPrizeEntryCounts_AggregateArgs = {
  filter?: InputMaybe<UserPrizeEntryCountsListFilter>;
};


export type UserUserSubscriptionsArgs = {
  filter?: InputMaybe<UserSubscriptionsListFilter>;
};


export type UserUserSubscriptions_AggregateArgs = {
  filter?: InputMaybe<UserSubscriptionsListFilter>;
};

export type UserAlert = {
  __typename?: 'UserAlert';
  createdAt: Scalars['ISOString']['output'];
  day: UserAlertDay;
  frequency: UserAlertFrequency;
  from?: Maybe<Scalars['DateScalar']['output']>;
  id: Scalars['ID']['output'];
  time: Scalars['String']['output'];
  updatedAt: Scalars['ISOString']['output'];
  user: User;
  user_aggregate?: Maybe<AggregationResult>;
};


export type UserAlertUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type UserAlertUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};

/** Data needed to create or update UserAlerts. If an ID is passed, this is an update, otherwise it's an insert. */
export type UserAlertCreateOrUpdateInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  day?: InputMaybe<UserAlertDay>;
  frequency?: InputMaybe<UserAlertFrequency>;
  from?: InputMaybe<Scalars['DateScalar']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['ISOString']['input']>;
  user?: InputMaybe<UserCreateOrUpdateInput>;
};

export enum UserAlertDay {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum UserAlertFrequency {
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

/** Data needed to create UserAlerts. */
export type UserAlertInsertInput = {
  createdAt: Scalars['ISOString']['input'];
  day: UserAlertDay;
  frequency: UserAlertFrequency;
  from?: InputMaybe<Scalars['DateScalar']['input']>;
  time: Scalars['String']['input'];
  updatedAt: Scalars['ISOString']['input'];
  user?: InputMaybe<UserCreateOrUpdateInput>;
};

/** Data needed to update UserAlerts. An ID must be passed. */
export type UserAlertUpdateInput = {
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  day?: InputMaybe<UserAlertDay>;
  frequency?: InputMaybe<UserAlertFrequency>;
  from?: InputMaybe<Scalars['DateScalar']['input']>;
  id: Scalars['ID']['input'];
  time?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['ISOString']['input']>;
  user?: InputMaybe<UserCreateOrUpdateInput>;
};

export type UserAlertsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<UserAlertsListFilter>>>;
  _not?: InputMaybe<UserAlertsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<UserAlertsListFilter>>>;
  createdAt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  createdAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  createdAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  day?: InputMaybe<UserAlertDay>;
  day_in?: InputMaybe<Array<UserAlertDay>>;
  day_nin?: InputMaybe<Array<UserAlertDay>>;
  frequency?: InputMaybe<UserAlertFrequency>;
  frequency_in?: InputMaybe<Array<UserAlertFrequency>>;
  frequency_nin?: InputMaybe<Array<UserAlertFrequency>>;
  from?: InputMaybe<Scalars['DateScalar']['input']>;
  from_gt?: InputMaybe<Scalars['DateScalar']['input']>;
  from_gte?: InputMaybe<Scalars['DateScalar']['input']>;
  from_in?: InputMaybe<Array<Scalars['DateScalar']['input']>>;
  from_lt?: InputMaybe<Scalars['DateScalar']['input']>;
  from_lte?: InputMaybe<Scalars['DateScalar']['input']>;
  from_ne?: InputMaybe<Scalars['DateScalar']['input']>;
  from_nin?: InputMaybe<Array<Scalars['DateScalar']['input']>>;
  from_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  from_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  time_gt?: InputMaybe<Scalars['String']['input']>;
  time_gte?: InputMaybe<Scalars['String']['input']>;
  time_ilike?: InputMaybe<Scalars['String']['input']>;
  time_in?: InputMaybe<Array<Scalars['String']['input']>>;
  time_like?: InputMaybe<Scalars['String']['input']>;
  time_lt?: InputMaybe<Scalars['String']['input']>;
  time_lte?: InputMaybe<Scalars['String']['input']>;
  time_ne?: InputMaybe<Scalars['String']['input']>;
  time_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  time_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  time_null?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['ISOString']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['ISOString']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['ISOString']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['ISOString']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['ISOString']['input']>;
  updatedAt_ne?: InputMaybe<Scalars['ISOString']['input']>;
  updatedAt_nin?: InputMaybe<Array<Scalars['ISOString']['input']>>;
  updatedAt_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt_null?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<UsersListFilter>;
};

export type UserAlertsOrderByInput = {
  createdAt?: InputMaybe<Sort>;
  day?: InputMaybe<Sort>;
  frequency?: InputMaybe<Sort>;
  from?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  time?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

/** Pagination options for UserAlerts. */
export type UserAlertsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserAlertsOrderByInput>;
};

/** Data needed to create or update Users. If an ID is passed, this is an update, otherwise it's an insert. */
export type UserCreateOrUpdateInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  batchCodes?: InputMaybe<Array<BatchCodeCreateOrUpdateInput>>;
  binReminderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityPlaceId?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactCreateOrUpdateInput>;
  councilId?: InputMaybe<Scalars['Float']['input']>;
  createdTrackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
  dateOfBirth?: InputMaybe<Scalars['DateScalar']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facilities?: InputMaybe<Array<FacilityCreateOrUpdateInput>>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasLoggedIn?: InputMaybe<Scalars['Boolean']['input']>;
  householdSize?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isCouncilStaffOf?: InputMaybe<Array<CouncilCreateOrUpdateInput>>;
  isManualAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isOver18?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  linkedCouncil?: InputMaybe<CouncilCreateOrUpdateInput>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  migrationAccountUuid?: InputMaybe<Scalars['String']['input']>;
  nearestDropOff?: InputMaybe<Scalars['JSON']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  prizes?: InputMaybe<Array<PrizeCreateOrUpdateInput>>;
  pushSubscription?: InputMaybe<Scalars['JSON']['input']>;
  roles?: InputMaybe<Array<RoleCreateOrUpdateInput>>;
  salesforceContactId?: InputMaybe<Scalars['String']['input']>;
  scanEvents?: InputMaybe<Array<ScanEventCreateOrUpdateInput>>;
  state?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<SuburbCreateOrUpdateInput>;
  suburbId?: InputMaybe<Scalars['String']['input']>;
  userAlerts?: InputMaybe<Array<UserAlertCreateOrUpdateInput>>;
  userPrizeEntryCounts?: InputMaybe<Array<UserPrizeEntryCountCreateOrUpdateInput>>;
  userSubscriptions?: InputMaybe<Array<UserSubscriptionCreateOrUpdateInput>>;
};

export type UserInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityPlaceId?: InputMaybe<Scalars['String']['input']>;
  council?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateScalar']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  householdSize?: InputMaybe<Scalars['Float']['input']>;
  isManualAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isOver18?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Data needed to create Users. */
export type UserInsertInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  batchCodes?: InputMaybe<Array<BatchCodeCreateOrUpdateInput>>;
  binReminderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityPlaceId?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactCreateOrUpdateInput>;
  councilId?: InputMaybe<Scalars['Float']['input']>;
  createdTrackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
  dateOfBirth?: InputMaybe<Scalars['DateScalar']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  facilities?: InputMaybe<Array<FacilityCreateOrUpdateInput>>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasLoggedIn?: InputMaybe<Scalars['Boolean']['input']>;
  householdSize?: InputMaybe<Scalars['Float']['input']>;
  isCouncilStaffOf?: InputMaybe<Array<CouncilCreateOrUpdateInput>>;
  isManualAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isOver18?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  linkedCouncil?: InputMaybe<CouncilCreateOrUpdateInput>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  migrationAccountUuid?: InputMaybe<Scalars['String']['input']>;
  nearestDropOff?: InputMaybe<Scalars['JSON']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  prizes?: InputMaybe<Array<PrizeCreateOrUpdateInput>>;
  pushSubscription?: InputMaybe<Scalars['JSON']['input']>;
  roles?: InputMaybe<Array<RoleCreateOrUpdateInput>>;
  salesforceContactId: Scalars['String']['input'];
  scanEvents?: InputMaybe<Array<ScanEventCreateOrUpdateInput>>;
  state?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<SuburbCreateOrUpdateInput>;
  suburbId?: InputMaybe<Scalars['String']['input']>;
  userAlerts?: InputMaybe<Array<UserAlertCreateOrUpdateInput>>;
  userPrizeEntryCounts?: InputMaybe<Array<UserPrizeEntryCountCreateOrUpdateInput>>;
  userSubscriptions?: InputMaybe<Array<UserSubscriptionCreateOrUpdateInput>>;
};

export type UserPrizeEntryCount = {
  __typename?: 'UserPrizeEntryCount';
  address?: Maybe<Scalars['String']['output']>;
  count: Scalars['Float']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  periodType: Scalars['String']['output'];
  periodValue: Scalars['Float']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  user: User;
  user_aggregate?: Maybe<AggregationResult>;
};


export type UserPrizeEntryCountUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


export type UserPrizeEntryCountUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};

/** Data needed to create or update UserPrizeEntryCounts. If an ID is passed, this is an update, otherwise it's an insert. */
export type UserPrizeEntryCountCreateOrUpdateInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  periodType?: InputMaybe<Scalars['String']['input']>;
  periodValue?: InputMaybe<Scalars['Float']['input']>;
  user?: InputMaybe<UserCreateOrUpdateInput>;
};

/** Data needed to create UserPrizeEntryCounts. */
export type UserPrizeEntryCountInsertInput = {
  count: Scalars['Float']['input'];
  periodType: Scalars['String']['input'];
  periodValue: Scalars['Float']['input'];
  user?: InputMaybe<UserCreateOrUpdateInput>;
};

/** Data needed to update UserPrizeEntryCounts. An ID must be passed. */
export type UserPrizeEntryCountUpdateInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  periodValue?: InputMaybe<Scalars['Float']['input']>;
  user?: InputMaybe<UserCreateOrUpdateInput>;
};

export type UserPrizeEntryCountsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<UserPrizeEntryCountsListFilter>>>;
  _not?: InputMaybe<UserPrizeEntryCountsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<UserPrizeEntryCountsListFilter>>>;
  address?: InputMaybe<Scalars['String']['input']>;
  address_gt?: InputMaybe<Scalars['String']['input']>;
  address_gte?: InputMaybe<Scalars['String']['input']>;
  address_ilike?: InputMaybe<Scalars['String']['input']>;
  address_in?: InputMaybe<Array<Scalars['String']['input']>>;
  address_like?: InputMaybe<Scalars['String']['input']>;
  address_lt?: InputMaybe<Scalars['String']['input']>;
  address_lte?: InputMaybe<Scalars['String']['input']>;
  address_ne?: InputMaybe<Scalars['String']['input']>;
  address_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  address_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  address_null?: InputMaybe<Scalars['Boolean']['input']>;
  count?: InputMaybe<Scalars['Float']['input']>;
  count_gt?: InputMaybe<Scalars['Float']['input']>;
  count_gte?: InputMaybe<Scalars['Float']['input']>;
  count_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  count_lt?: InputMaybe<Scalars['Float']['input']>;
  count_lte?: InputMaybe<Scalars['Float']['input']>;
  count_ne?: InputMaybe<Scalars['Float']['input']>;
  count_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  count_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  count_null?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_gt?: InputMaybe<Scalars['String']['input']>;
  firstName_gte?: InputMaybe<Scalars['String']['input']>;
  firstName_ilike?: InputMaybe<Scalars['String']['input']>;
  firstName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName_like?: InputMaybe<Scalars['String']['input']>;
  firstName_lt?: InputMaybe<Scalars['String']['input']>;
  firstName_lte?: InputMaybe<Scalars['String']['input']>;
  firstName_ne?: InputMaybe<Scalars['String']['input']>;
  firstName_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  firstName_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_gt?: InputMaybe<Scalars['String']['input']>;
  lastName_gte?: InputMaybe<Scalars['String']['input']>;
  lastName_ilike?: InputMaybe<Scalars['String']['input']>;
  lastName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName_like?: InputMaybe<Scalars['String']['input']>;
  lastName_lt?: InputMaybe<Scalars['String']['input']>;
  lastName_lte?: InputMaybe<Scalars['String']['input']>;
  lastName_ne?: InputMaybe<Scalars['String']['input']>;
  lastName_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  lastName_null?: InputMaybe<Scalars['Boolean']['input']>;
  periodType?: InputMaybe<Scalars['String']['input']>;
  periodType_gt?: InputMaybe<Scalars['String']['input']>;
  periodType_gte?: InputMaybe<Scalars['String']['input']>;
  periodType_ilike?: InputMaybe<Scalars['String']['input']>;
  periodType_in?: InputMaybe<Array<Scalars['String']['input']>>;
  periodType_like?: InputMaybe<Scalars['String']['input']>;
  periodType_lt?: InputMaybe<Scalars['String']['input']>;
  periodType_lte?: InputMaybe<Scalars['String']['input']>;
  periodType_ne?: InputMaybe<Scalars['String']['input']>;
  periodType_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  periodType_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  periodType_null?: InputMaybe<Scalars['Boolean']['input']>;
  periodValue?: InputMaybe<Scalars['Float']['input']>;
  periodValue_gt?: InputMaybe<Scalars['Float']['input']>;
  periodValue_gte?: InputMaybe<Scalars['Float']['input']>;
  periodValue_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  periodValue_lt?: InputMaybe<Scalars['Float']['input']>;
  periodValue_lte?: InputMaybe<Scalars['Float']['input']>;
  periodValue_ne?: InputMaybe<Scalars['Float']['input']>;
  periodValue_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  periodValue_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  periodValue_null?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_gt?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_gte?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_ilike?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_in?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber_like?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_lt?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_lte?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_ne?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber_null?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<UsersListFilter>;
};

export type UserPrizeEntryCountsOrderByInput = {
  address?: InputMaybe<Sort>;
  count?: InputMaybe<Sort>;
  firstName?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  lastName?: InputMaybe<Sort>;
  periodType?: InputMaybe<Sort>;
  periodValue?: InputMaybe<Sort>;
  phoneNumber?: InputMaybe<Sort>;
};

/** Pagination options for UserPrizeEntryCounts. */
export type UserPrizeEntryCountsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserPrizeEntryCountsOrderByInput>;
};

export type UserScanMaterialConfirmInput = {
  id: Scalars['String']['input'];
  material: MaterialType;
};

/** Stripe offers subscriptions, but Curby didn't want to use them, instead opting for normal one-off products. We handle "subscription" products in our end, not in Stripe */
export type UserSubscription = {
  __typename?: 'UserSubscription';
  id: Scalars['ID']['output'];
  stripeProductId: Scalars['String']['output'];
  stripeSessionId: Scalars['String']['output'];
  user: User;
  user_aggregate?: Maybe<AggregationResult>;
  validFrom: Scalars['DateScalar']['output'];
  validTo: Scalars['DateScalar']['output'];
};


/** Stripe offers subscriptions, but Curby didn't want to use them, instead opting for normal one-off products. We handle "subscription" products in our end, not in Stripe */
export type UserSubscriptionUserArgs = {
  filter?: InputMaybe<UsersListFilter>;
};


/** Stripe offers subscriptions, but Curby didn't want to use them, instead opting for normal one-off products. We handle "subscription" products in our end, not in Stripe */
export type UserSubscriptionUser_AggregateArgs = {
  filter?: InputMaybe<UsersListFilter>;
};

/** Data needed to create or update UserSubscriptions. If an ID is passed, this is an update, otherwise it's an insert. */
export type UserSubscriptionCreateOrUpdateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserCreateOrUpdateInput>;
  validFrom?: InputMaybe<Scalars['DateScalar']['input']>;
  validTo?: InputMaybe<Scalars['DateScalar']['input']>;
};

/** Data needed to create UserSubscriptions. */
export type UserSubscriptionInsertInput = {
  stripeProductId: Scalars['String']['input'];
  stripeSessionId: Scalars['String']['input'];
  user?: InputMaybe<UserCreateOrUpdateInput>;
  validFrom: Scalars['DateScalar']['input'];
  validTo: Scalars['DateScalar']['input'];
};

/** Data needed to update UserSubscriptions. An ID must be passed. */
export type UserSubscriptionUpdateInput = {
  id: Scalars['ID']['input'];
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserCreateOrUpdateInput>;
  validFrom?: InputMaybe<Scalars['DateScalar']['input']>;
  validTo?: InputMaybe<Scalars['DateScalar']['input']>;
};

/** Stripe offers subscriptions, but Curby didn't want to use them, instead opting for normal one-off products. We handle "subscription" products in our end, not in Stripe */
export type UserSubscriptionsListFilter = {
  _and?: InputMaybe<Array<InputMaybe<UserSubscriptionsListFilter>>>;
  _not?: InputMaybe<UserSubscriptionsListFilter>;
  _or?: InputMaybe<Array<InputMaybe<UserSubscriptionsListFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_gt?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_gte?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_ilike?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  stripeProductId_like?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_lt?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_lte?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_ne?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  stripeProductId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  stripeProductId_null?: InputMaybe<Scalars['Boolean']['input']>;
  stripeSessionId?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId_gt?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId_gte?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId_ilike?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  stripeSessionId_like?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId_lt?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId_lte?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId_ne?: InputMaybe<Scalars['String']['input']>;
  stripeSessionId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  stripeSessionId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  stripeSessionId_null?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<UsersListFilter>;
  validFrom?: InputMaybe<Scalars['DateScalar']['input']>;
  validFrom_gt?: InputMaybe<Scalars['DateScalar']['input']>;
  validFrom_gte?: InputMaybe<Scalars['DateScalar']['input']>;
  validFrom_in?: InputMaybe<Array<Scalars['DateScalar']['input']>>;
  validFrom_lt?: InputMaybe<Scalars['DateScalar']['input']>;
  validFrom_lte?: InputMaybe<Scalars['DateScalar']['input']>;
  validFrom_ne?: InputMaybe<Scalars['DateScalar']['input']>;
  validFrom_nin?: InputMaybe<Array<Scalars['DateScalar']['input']>>;
  validFrom_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  validFrom_null?: InputMaybe<Scalars['Boolean']['input']>;
  validTo?: InputMaybe<Scalars['DateScalar']['input']>;
  validTo_gt?: InputMaybe<Scalars['DateScalar']['input']>;
  validTo_gte?: InputMaybe<Scalars['DateScalar']['input']>;
  validTo_in?: InputMaybe<Array<Scalars['DateScalar']['input']>>;
  validTo_lt?: InputMaybe<Scalars['DateScalar']['input']>;
  validTo_lte?: InputMaybe<Scalars['DateScalar']['input']>;
  validTo_ne?: InputMaybe<Scalars['DateScalar']['input']>;
  validTo_nin?: InputMaybe<Array<Scalars['DateScalar']['input']>>;
  validTo_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  validTo_null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSubscriptionsOrderByInput = {
  id?: InputMaybe<Sort>;
  stripeProductId?: InputMaybe<Sort>;
  stripeSessionId?: InputMaybe<Sort>;
  validFrom?: InputMaybe<Sort>;
  validTo?: InputMaybe<Sort>;
};

/** Pagination options for UserSubscriptions. */
export type UserSubscriptionsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserSubscriptionsOrderByInput>;
};

/** Data needed to update Users. An ID must be passed. */
export type UserUpdateInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  batchCodes?: InputMaybe<Array<BatchCodeCreateOrUpdateInput>>;
  binReminderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityPlaceId?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactCreateOrUpdateInput>;
  councilId?: InputMaybe<Scalars['Float']['input']>;
  createdTrackableAssets?: InputMaybe<Array<TrackableAssetCreateOrUpdateInput>>;
  dateOfBirth?: InputMaybe<Scalars['DateScalar']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facilities?: InputMaybe<Array<FacilityCreateOrUpdateInput>>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasLoggedIn?: InputMaybe<Scalars['Boolean']['input']>;
  householdSize?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  isCouncilStaffOf?: InputMaybe<Array<CouncilCreateOrUpdateInput>>;
  isManualAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isOver18?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  linkedCouncil?: InputMaybe<CouncilCreateOrUpdateInput>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  migrationAccountUuid?: InputMaybe<Scalars['String']['input']>;
  nearestDropOff?: InputMaybe<Scalars['JSON']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  prizes?: InputMaybe<Array<PrizeCreateOrUpdateInput>>;
  pushSubscription?: InputMaybe<Scalars['JSON']['input']>;
  roles?: InputMaybe<Array<RoleCreateOrUpdateInput>>;
  salesforceContactId?: InputMaybe<Scalars['String']['input']>;
  scanEvents?: InputMaybe<Array<ScanEventCreateOrUpdateInput>>;
  state?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<SuburbCreateOrUpdateInput>;
  suburbId?: InputMaybe<Scalars['String']['input']>;
  userAlerts?: InputMaybe<Array<UserAlertCreateOrUpdateInput>>;
  userPrizeEntryCounts?: InputMaybe<Array<UserPrizeEntryCountCreateOrUpdateInput>>;
  userSubscriptions?: InputMaybe<Array<UserSubscriptionCreateOrUpdateInput>>;
};

export type UserWithScanEvents = {
  __typename?: 'UserWithScanEvents';
  council?: Maybe<Scalars['String']['output']>;
  dwellingType?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  formattedAddress?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  householdSize?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isParticipatingInPrizeDraw?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  totalScans?: Maybe<Scalars['Float']['output']>;
};

/** Data needed to create or update MultipleUserWithScanEvents. If an ID is passed, this is an update, otherwise it's an insert. */
export type UserWithScanEventsCreateOrUpdateInput = {
  council?: InputMaybe<Scalars['String']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  householdSize?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isParticipatingInPrizeDraw?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  totalScans?: InputMaybe<Scalars['Float']['input']>;
};

/** Data needed to create MultipleUserWithScanEvents. */
export type UserWithScanEventsInsertInput = {
  council?: InputMaybe<Scalars['String']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  householdSize?: InputMaybe<Scalars['Float']['input']>;
  isParticipatingInPrizeDraw?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  totalScans?: InputMaybe<Scalars['Float']['input']>;
};

/** Data needed to update MultipleUserWithScanEvents. An ID must be passed. */
export type UserWithScanEventsUpdateInput = {
  council?: InputMaybe<Scalars['String']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  householdSize?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  isParticipatingInPrizeDraw?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  totalScans?: InputMaybe<Scalars['Float']['input']>;
};

export type UsersListFilter = {
  _and?: InputMaybe<Array<InputMaybe<UsersListFilter>>>;
  _not?: InputMaybe<UsersListFilter>;
  _or?: InputMaybe<Array<InputMaybe<UsersListFilter>>>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine1_gt?: InputMaybe<Scalars['String']['input']>;
  addressLine1_gte?: InputMaybe<Scalars['String']['input']>;
  addressLine1_ilike?: InputMaybe<Scalars['String']['input']>;
  addressLine1_in?: InputMaybe<Array<Scalars['String']['input']>>;
  addressLine1_like?: InputMaybe<Scalars['String']['input']>;
  addressLine1_lt?: InputMaybe<Scalars['String']['input']>;
  addressLine1_lte?: InputMaybe<Scalars['String']['input']>;
  addressLine1_ne?: InputMaybe<Scalars['String']['input']>;
  addressLine1_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  addressLine1_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  addressLine1_null?: InputMaybe<Scalars['Boolean']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressLine2_gt?: InputMaybe<Scalars['String']['input']>;
  addressLine2_gte?: InputMaybe<Scalars['String']['input']>;
  addressLine2_ilike?: InputMaybe<Scalars['String']['input']>;
  addressLine2_in?: InputMaybe<Array<Scalars['String']['input']>>;
  addressLine2_like?: InputMaybe<Scalars['String']['input']>;
  addressLine2_lt?: InputMaybe<Scalars['String']['input']>;
  addressLine2_lte?: InputMaybe<Scalars['String']['input']>;
  addressLine2_ne?: InputMaybe<Scalars['String']['input']>;
  addressLine2_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  addressLine2_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  addressLine2_null?: InputMaybe<Scalars['Boolean']['input']>;
  batchCodes?: InputMaybe<BatchCodesListFilter>;
  binReminderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  binReminderEnabled_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  binReminderEnabled_ne?: InputMaybe<Scalars['Boolean']['input']>;
  binReminderEnabled_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  binReminderEnabled_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  binReminderEnabled_null?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityPlaceId?: InputMaybe<Scalars['String']['input']>;
  cityPlaceId_gt?: InputMaybe<Scalars['String']['input']>;
  cityPlaceId_gte?: InputMaybe<Scalars['String']['input']>;
  cityPlaceId_ilike?: InputMaybe<Scalars['String']['input']>;
  cityPlaceId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  cityPlaceId_like?: InputMaybe<Scalars['String']['input']>;
  cityPlaceId_lt?: InputMaybe<Scalars['String']['input']>;
  cityPlaceId_lte?: InputMaybe<Scalars['String']['input']>;
  cityPlaceId_ne?: InputMaybe<Scalars['String']['input']>;
  cityPlaceId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  cityPlaceId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  cityPlaceId_null?: InputMaybe<Scalars['Boolean']['input']>;
  city_gt?: InputMaybe<Scalars['String']['input']>;
  city_gte?: InputMaybe<Scalars['String']['input']>;
  city_ilike?: InputMaybe<Scalars['String']['input']>;
  city_in?: InputMaybe<Array<Scalars['String']['input']>>;
  city_like?: InputMaybe<Scalars['String']['input']>;
  city_lt?: InputMaybe<Scalars['String']['input']>;
  city_lte?: InputMaybe<Scalars['String']['input']>;
  city_ne?: InputMaybe<Scalars['String']['input']>;
  city_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  city_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  city_null?: InputMaybe<Scalars['Boolean']['input']>;
  contact?: InputMaybe<ContactsListFilter>;
  councilId?: InputMaybe<Scalars['Float']['input']>;
  councilId_gt?: InputMaybe<Scalars['Float']['input']>;
  councilId_gte?: InputMaybe<Scalars['Float']['input']>;
  councilId_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  councilId_lt?: InputMaybe<Scalars['Float']['input']>;
  councilId_lte?: InputMaybe<Scalars['Float']['input']>;
  councilId_ne?: InputMaybe<Scalars['Float']['input']>;
  councilId_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  councilId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  councilId_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdTrackableAssets?: InputMaybe<TrackableAssetsListFilter>;
  dateOfBirth?: InputMaybe<Scalars['DateScalar']['input']>;
  dateOfBirth_gt?: InputMaybe<Scalars['DateScalar']['input']>;
  dateOfBirth_gte?: InputMaybe<Scalars['DateScalar']['input']>;
  dateOfBirth_in?: InputMaybe<Array<Scalars['DateScalar']['input']>>;
  dateOfBirth_lt?: InputMaybe<Scalars['DateScalar']['input']>;
  dateOfBirth_lte?: InputMaybe<Scalars['DateScalar']['input']>;
  dateOfBirth_ne?: InputMaybe<Scalars['DateScalar']['input']>;
  dateOfBirth_nin?: InputMaybe<Array<Scalars['DateScalar']['input']>>;
  dateOfBirth_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth_null?: InputMaybe<Scalars['Boolean']['input']>;
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  dwellingType_gt?: InputMaybe<Scalars['String']['input']>;
  dwellingType_gte?: InputMaybe<Scalars['String']['input']>;
  dwellingType_ilike?: InputMaybe<Scalars['String']['input']>;
  dwellingType_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dwellingType_like?: InputMaybe<Scalars['String']['input']>;
  dwellingType_lt?: InputMaybe<Scalars['String']['input']>;
  dwellingType_lte?: InputMaybe<Scalars['String']['input']>;
  dwellingType_ne?: InputMaybe<Scalars['String']['input']>;
  dwellingType_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  dwellingType_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  dwellingType_null?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_gt?: InputMaybe<Scalars['String']['input']>;
  email_gte?: InputMaybe<Scalars['String']['input']>;
  email_ilike?: InputMaybe<Scalars['String']['input']>;
  email_in?: InputMaybe<Array<Scalars['String']['input']>>;
  email_like?: InputMaybe<Scalars['String']['input']>;
  email_lt?: InputMaybe<Scalars['String']['input']>;
  email_lte?: InputMaybe<Scalars['String']['input']>;
  email_ne?: InputMaybe<Scalars['String']['input']>;
  email_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  email_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  email_null?: InputMaybe<Scalars['Boolean']['input']>;
  facilities?: InputMaybe<FacilitiesListFilter>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_gt?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_gte?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_ilike?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_in?: InputMaybe<Array<Scalars['String']['input']>>;
  formattedAddress_like?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_lt?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_lte?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_ne?: InputMaybe<Scalars['String']['input']>;
  formattedAddress_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  formattedAddress_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  formattedAddress_null?: InputMaybe<Scalars['Boolean']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_gt?: InputMaybe<Scalars['String']['input']>;
  gender_gte?: InputMaybe<Scalars['String']['input']>;
  gender_ilike?: InputMaybe<Scalars['String']['input']>;
  gender_in?: InputMaybe<Array<Scalars['String']['input']>>;
  gender_like?: InputMaybe<Scalars['String']['input']>;
  gender_lt?: InputMaybe<Scalars['String']['input']>;
  gender_lte?: InputMaybe<Scalars['String']['input']>;
  gender_ne?: InputMaybe<Scalars['String']['input']>;
  gender_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  gender_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  gender_null?: InputMaybe<Scalars['Boolean']['input']>;
  hasLoggedIn?: InputMaybe<Scalars['Boolean']['input']>;
  hasLoggedIn_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  hasLoggedIn_ne?: InputMaybe<Scalars['Boolean']['input']>;
  hasLoggedIn_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  hasLoggedIn_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  hasLoggedIn_null?: InputMaybe<Scalars['Boolean']['input']>;
  householdSize?: InputMaybe<Scalars['Float']['input']>;
  householdSize_gt?: InputMaybe<Scalars['Float']['input']>;
  householdSize_gte?: InputMaybe<Scalars['Float']['input']>;
  householdSize_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  householdSize_lt?: InputMaybe<Scalars['Float']['input']>;
  householdSize_lte?: InputMaybe<Scalars['Float']['input']>;
  householdSize_ne?: InputMaybe<Scalars['Float']['input']>;
  householdSize_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  householdSize_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  householdSize_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_ne?: InputMaybe<Scalars['ID']['input']>;
  id_nin?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  id_null?: InputMaybe<Scalars['Boolean']['input']>;
  isCouncilStaffOf?: InputMaybe<CouncilsListFilter>;
  isManualAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isManualAddress_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isManualAddress_ne?: InputMaybe<Scalars['Boolean']['input']>;
  isManualAddress_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isManualAddress_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  isManualAddress_null?: InputMaybe<Scalars['Boolean']['input']>;
  isOver18?: InputMaybe<Scalars['Boolean']['input']>;
  isOver18_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isOver18_ne?: InputMaybe<Scalars['Boolean']['input']>;
  isOver18_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isOver18_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  isOver18_null?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isParticipatingInPrizeDraw_ne?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw_nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isParticipatingInPrizeDraw_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  isParticipatingInPrizeDraw_null?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lat_gt?: InputMaybe<Scalars['Float']['input']>;
  lat_gte?: InputMaybe<Scalars['Float']['input']>;
  lat_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lat_lt?: InputMaybe<Scalars['Float']['input']>;
  lat_lte?: InputMaybe<Scalars['Float']['input']>;
  lat_ne?: InputMaybe<Scalars['Float']['input']>;
  lat_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  lat_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  lat_null?: InputMaybe<Scalars['Boolean']['input']>;
  linkedCouncil?: InputMaybe<CouncilsListFilter>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  lng_gt?: InputMaybe<Scalars['Float']['input']>;
  lng_gte?: InputMaybe<Scalars['Float']['input']>;
  lng_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lng_lt?: InputMaybe<Scalars['Float']['input']>;
  lng_lte?: InputMaybe<Scalars['Float']['input']>;
  lng_ne?: InputMaybe<Scalars['Float']['input']>;
  lng_nin?: InputMaybe<Array<Scalars['Float']['input']>>;
  lng_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  lng_null?: InputMaybe<Scalars['Boolean']['input']>;
  migrationAccountUuid?: InputMaybe<Scalars['String']['input']>;
  migrationAccountUuid_gt?: InputMaybe<Scalars['String']['input']>;
  migrationAccountUuid_gte?: InputMaybe<Scalars['String']['input']>;
  migrationAccountUuid_ilike?: InputMaybe<Scalars['String']['input']>;
  migrationAccountUuid_in?: InputMaybe<Array<Scalars['String']['input']>>;
  migrationAccountUuid_like?: InputMaybe<Scalars['String']['input']>;
  migrationAccountUuid_lt?: InputMaybe<Scalars['String']['input']>;
  migrationAccountUuid_lte?: InputMaybe<Scalars['String']['input']>;
  migrationAccountUuid_ne?: InputMaybe<Scalars['String']['input']>;
  migrationAccountUuid_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  migrationAccountUuid_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  migrationAccountUuid_null?: InputMaybe<Scalars['Boolean']['input']>;
  nearestDropOff?: InputMaybe<Scalars['JSON']['input']>;
  nearestDropOff_in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  nearestDropOff_ne?: InputMaybe<Scalars['JSON']['input']>;
  nearestDropOff_nin?: InputMaybe<Array<Scalars['JSON']['input']>>;
  nearestDropOff_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  nearestDropOff_null?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_gt?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_gte?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_ilike?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_in?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber_like?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_lt?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_lte?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_ne?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber_null?: InputMaybe<Scalars['Boolean']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  placeId_gt?: InputMaybe<Scalars['String']['input']>;
  placeId_gte?: InputMaybe<Scalars['String']['input']>;
  placeId_ilike?: InputMaybe<Scalars['String']['input']>;
  placeId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  placeId_like?: InputMaybe<Scalars['String']['input']>;
  placeId_lt?: InputMaybe<Scalars['String']['input']>;
  placeId_lte?: InputMaybe<Scalars['String']['input']>;
  placeId_ne?: InputMaybe<Scalars['String']['input']>;
  placeId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  placeId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  placeId_null?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_gt?: InputMaybe<Scalars['String']['input']>;
  postcode_gte?: InputMaybe<Scalars['String']['input']>;
  postcode_ilike?: InputMaybe<Scalars['String']['input']>;
  postcode_in?: InputMaybe<Array<Scalars['String']['input']>>;
  postcode_like?: InputMaybe<Scalars['String']['input']>;
  postcode_lt?: InputMaybe<Scalars['String']['input']>;
  postcode_lte?: InputMaybe<Scalars['String']['input']>;
  postcode_ne?: InputMaybe<Scalars['String']['input']>;
  postcode_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  postcode_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  postcode_null?: InputMaybe<Scalars['Boolean']['input']>;
  prizes?: InputMaybe<PrizesListFilter>;
  pushSubscription?: InputMaybe<Scalars['JSON']['input']>;
  pushSubscription_in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  pushSubscription_ne?: InputMaybe<Scalars['JSON']['input']>;
  pushSubscription_nin?: InputMaybe<Array<Scalars['JSON']['input']>>;
  pushSubscription_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  pushSubscription_null?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<RolesListFilter>;
  salesforceContactId?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId_gt?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId_gte?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId_ilike?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  salesforceContactId_like?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId_lt?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId_lte?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId_ne?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  salesforceContactId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  salesforceContactId_null?: InputMaybe<Scalars['Boolean']['input']>;
  scanEventChanges?: InputMaybe<MultipleScanEventChangesListFilter>;
  scanEvents?: InputMaybe<ScanEventsListFilter>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_gt?: InputMaybe<Scalars['String']['input']>;
  state_gte?: InputMaybe<Scalars['String']['input']>;
  state_ilike?: InputMaybe<Scalars['String']['input']>;
  state_in?: InputMaybe<Array<Scalars['String']['input']>>;
  state_like?: InputMaybe<Scalars['String']['input']>;
  state_lt?: InputMaybe<Scalars['String']['input']>;
  state_lte?: InputMaybe<Scalars['String']['input']>;
  state_ne?: InputMaybe<Scalars['String']['input']>;
  state_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  state_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  state_null?: InputMaybe<Scalars['Boolean']['input']>;
  suburb?: InputMaybe<SuburbsListFilter>;
  suburbId?: InputMaybe<Scalars['String']['input']>;
  suburbId_gt?: InputMaybe<Scalars['String']['input']>;
  suburbId_gte?: InputMaybe<Scalars['String']['input']>;
  suburbId_ilike?: InputMaybe<Scalars['String']['input']>;
  suburbId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  suburbId_like?: InputMaybe<Scalars['String']['input']>;
  suburbId_lt?: InputMaybe<Scalars['String']['input']>;
  suburbId_lte?: InputMaybe<Scalars['String']['input']>;
  suburbId_ne?: InputMaybe<Scalars['String']['input']>;
  suburbId_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  suburbId_notnull?: InputMaybe<Scalars['Boolean']['input']>;
  suburbId_null?: InputMaybe<Scalars['Boolean']['input']>;
  userAlerts?: InputMaybe<UserAlertsListFilter>;
  userPrizeEntryCounts?: InputMaybe<UserPrizeEntryCountsListFilter>;
  userSubscriptions?: InputMaybe<UserSubscriptionsListFilter>;
};

export type UsersOrderByInput = {
  addressLine1?: InputMaybe<Sort>;
  addressLine2?: InputMaybe<Sort>;
  binReminderEnabled?: InputMaybe<Sort>;
  city?: InputMaybe<Sort>;
  cityPlaceId?: InputMaybe<Sort>;
  councilId?: InputMaybe<Sort>;
  dateOfBirth?: InputMaybe<Sort>;
  dwellingType?: InputMaybe<Sort>;
  email?: InputMaybe<Sort>;
  formattedAddress?: InputMaybe<Sort>;
  gender?: InputMaybe<Sort>;
  hasLoggedIn?: InputMaybe<Sort>;
  householdSize?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  isManualAddress?: InputMaybe<Sort>;
  isOver18?: InputMaybe<Sort>;
  isParticipatingInPrizeDraw?: InputMaybe<Sort>;
  lat?: InputMaybe<Sort>;
  lng?: InputMaybe<Sort>;
  migrationAccountUuid?: InputMaybe<Sort>;
  nearestDropOff?: InputMaybe<Sort>;
  phoneNumber?: InputMaybe<Sort>;
  placeId?: InputMaybe<Sort>;
  postcode?: InputMaybe<Sort>;
  pushSubscription?: InputMaybe<Sort>;
  salesforceContactId?: InputMaybe<Sort>;
  state?: InputMaybe<Sort>;
  suburbId?: InputMaybe<Sort>;
};

/** Pagination options for Users. */
export type UsersPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UsersOrderByInput>;
};
